import {
  Unit_instance1fbcbse1fwigr as Unit_instance,
  protoOf180f3jzyo7rfj as protoOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Continuation1aa2oekvx7jm7 as Continuation,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  EmptyCoroutineContext_instance2qpebg1xogbvt as EmptyCoroutineContext_instance,
  createCoroutineUnintercepted3gya308dmbbtg as createCoroutineUnintercepted,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  UnsupportedOperationException_init_$Create$1pe732c4s59hc as UnsupportedOperationException_init_$Create$,
  toString1pkumu07cwy4m as toString,
  isInterface3d6p8outrmvmk as isInterface,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  toString30pk9tzaqopn as toString_0,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  CancellationException_init_$Create$2cv5nayrc39hr as CancellationException_init_$Create$,
  Result__exceptionOrNull_impl_p6xea9ty3elzpd9eo3 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqg2ei4op8d4d2m as _Result___get_value__impl__bjfvqg,
  AbstractCoroutineContextKey9xr9r6wlj5bm as AbstractCoroutineContextKey,
  Key_instance17k9ki7fvysxq as Key_instance,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  getxe4seun860fg as get,
  minusKey2uxs00uz5ceqp as minusKey,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  RuntimeException_init_$Create$518iyh59wo54 as RuntimeException_init_$Create$,
  addSuppressedu5jwjfvsc039 as addSuppressed,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Enum3alwj03lh1n41 as Enum,
  startCoroutine327fwvtqvedik as startCoroutine,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  intercepted2ogpsikxxj4u0 as intercepted,
  ArrayDeque_init_$Create$2333dl090ltjt as ArrayDeque_init_$Create$,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  RuntimeException1r3t0zl97011n as RuntimeException,
  RuntimeException_init_$Init$3m7ccek2krm3f as RuntimeException_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  Error3ofk6owajcepa as Error_0,
  Error_init_$Init$17pe7jtgoh3ll as Error_init_$Init$,
  Element2gr7ezmxqaln7 as Element,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  ArrayList_init_$Create$3bxttkj3v1mea as ArrayList_init_$Create$,
  CancellationException3b36o9qz53rgr as CancellationException,
  ArrayList3it5z8td81qkl as ArrayList,
  IllegalStateException_init_$Create$12oloagvd20rx as IllegalStateException_init_$Create$_0,
  plusolev77jfy5r9 as plus,
  get6d5x931vk0s as get_0,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey_0,
  StringBuilder_init_$Create$2qsge4ydj6bin as StringBuilder_init_$Create$,
  anyToString3ho3k49fc56mj as anyToString,
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
  convertToInty04h231mmjoh as convertToInt,
  shiftRight2gqph14wydb8s as shiftRight,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  listOf1jh22dvmctj1r as listOf,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$_0,
  NoSuchElementException_init_$Create$keivgb96udi6 as NoSuchElementException_init_$Create$,
  compareTo3ankvs086tmwq as compareTo,
  last2n4gf5az1lkn4 as last,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  shiftLeft3tsh2sstjchzn as shiftLeft,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  NoSuchElementException_init_$Init$8big512cht7b as NoSuchElementException_init_$Init$,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalStateException_init_$Init$28k6zlhbptery as IllegalStateException_init_$Init$,
  getKClass3t8tygqu4lcxf as getKClass,
  Unitkvevlwgzwiuc as Unit,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$393utbttlf2x4 as Exception_init_$Init$,
  defineProp3ur6h3slcvq4x as defineProp,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  createCoroutineUnintercepted21q5ochlctscl as createCoroutineUnintercepted_0,
  startCoroutineUninterceptedOrReturnNonGeneratorVersionyfrrvzbtl8bf as startCoroutineUninterceptedOrReturnNonGeneratorVersion,
  plus20p0vtfmu0596 as plus_0,
  KtList3hktaavzmj137 as KtList,
  listOfvhqybd2zx248 as listOf_0,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  Exception_init_$Create$becl18oowirz as Exception_init_$Create$,
  removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull,
  KtMutableList1beimitadwkna as KtMutableList,
  coerceIn302bduskdb54x as coerceIn,
  CancellationException_init_$Create$1muhzgve35v78 as CancellationException_init_$Create$_0,
  CancellationException_init_$Init$1ieejj57c468h as CancellationException_init_$Init$,
  CancellationException_init_$Init$2avhmkaa5k89d as CancellationException_init_$Init$_0,
  HashSet_init_$Create$1almu45bw06ne as HashSet_init_$Create$,
  RuntimeException_init_$Init$1tdhpyy2sm4eb as RuntimeException_init_$Init$_0,
  LinkedHashSet_init_$Create$3o6z3oewjhki9 as LinkedHashSet_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  atomicfu$AtomicRefArray$ofNulls2kz3j9ehigwa3 as atomicfu$AtomicRefArray$ofNulls,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
} from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
function cancel$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.o1y(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.o1y.call(this, cause);
  }
  return tmp;
}
function invokeOnCompletion$default(onCancelling, invokeImmediately, handler, $super) {
  onCancelling = onCancelling === VOID ? false : onCancelling;
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  return $super === VOID ? this.i1y(onCancelling, invokeImmediately, handler) : $super.i1y.call(this, onCancelling, invokeImmediately, handler);
}
initMetadataForInterface(Job, 'Job', VOID, VOID, [Element], [0]);
initMetadataForInterface(ParentJob, 'ParentJob', VOID, VOID, [Job], [0]);
initMetadataForClass(JobSupport, 'JobSupport', VOID, VOID, [Job, ParentJob], [0]);
initMetadataForInterface(CoroutineScope, 'CoroutineScope');
initMetadataForClass(AbstractCoroutine, 'AbstractCoroutine', VOID, JobSupport, [JobSupport, Job, Continuation, CoroutineScope], [0]);
initMetadataForClass(StandaloneCoroutine, 'StandaloneCoroutine', VOID, AbstractCoroutine, VOID, [0]);
initMetadataForClass(LazyStandaloneCoroutine, 'LazyStandaloneCoroutine', VOID, StandaloneCoroutine, VOID, [0]);
initMetadataForCoroutine($awaitCOROUTINE$, CoroutineImpl);
initMetadataForClass(DeferredCoroutine, 'DeferredCoroutine', VOID, AbstractCoroutine, [AbstractCoroutine, Job], [0]);
initMetadataForClass(LazyDeferredCoroutine, 'LazyDeferredCoroutine', VOID, DeferredCoroutine, VOID, [0]);
initMetadataForInterface(CancellableContinuation, 'CancellableContinuation', VOID, VOID, [Continuation]);
initMetadataForInterface(NotCompleted, 'NotCompleted');
initMetadataForInterface(CancelHandler, 'CancelHandler', VOID, VOID, [NotCompleted]);
initMetadataForClass(DisposeOnCancel, 'DisposeOnCancel', VOID, VOID, [CancelHandler]);
initMetadataForClass(UserSupplied, 'UserSupplied', VOID, VOID, [CancelHandler]);
initMetadataForInterface(Runnable, 'Runnable');
initMetadataForClass(SchedulerTask, 'SchedulerTask', VOID, VOID, [Runnable]);
initMetadataForClass(DispatchedTask, 'DispatchedTask', VOID, SchedulerTask);
initMetadataForInterface(Waiter, 'Waiter');
initMetadataForClass(CancellableContinuationImpl, 'CancellableContinuationImpl', VOID, DispatchedTask, [DispatchedTask, CancellableContinuation, Waiter]);
initMetadataForObject(Active, 'Active', VOID, VOID, [NotCompleted]);
initMetadataForClass(CompletedContinuation, 'CompletedContinuation');
initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
initMetadataForInterface(Incomplete, 'Incomplete');
initMetadataForClass(JobNode, 'JobNode', VOID, LockFreeLinkedListNode, [LockFreeLinkedListNode, Incomplete]);
initMetadataForClass(ChildContinuation, 'ChildContinuation', VOID, JobNode);
initMetadataForCoroutine($awaitCOROUTINE$_0, CoroutineImpl);
initMetadataForClass(CompletableDeferredImpl, 'CompletableDeferredImpl', VOID, JobSupport, [JobSupport, Job], [0]);
initMetadataForInterface(CompletableJob, 'CompletableJob', VOID, VOID, [Job], [0]);
initMetadataForClass(CompletedExceptionally, 'CompletedExceptionally');
initMetadataForClass(CancelledContinuation, 'CancelledContinuation', VOID, CompletedExceptionally);
initMetadataForObject(Key, 'Key', VOID, AbstractCoroutineContextKey);
initMetadataForClass(CoroutineDispatcher, 'CoroutineDispatcher', VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, ContinuationInterceptor]);
initMetadataForObject(Key_0, 'Key');
initMetadataForObject(Key_1, 'Key');
initMetadataForClass(CoroutineName, 'CoroutineName', VOID, AbstractCoroutineContextElement);
initMetadataForObject(GlobalScope, 'GlobalScope', VOID, VOID, [CoroutineScope]);
initMetadataForClass(CoroutineStart, 'CoroutineStart', VOID, Enum);
initMetadataForInterface(CopyableThrowable, 'CopyableThrowable');
initMetadataForInterface(Delay, 'Delay', VOID, VOID, VOID, [1]);
initMetadataForClass(EventLoop, 'EventLoop', VOID, CoroutineDispatcher);
initMetadataForObject(ThreadLocalEventLoop, 'ThreadLocalEventLoop');
initMetadataForClass(CompletionHandlerException, 'CompletionHandlerException', VOID, RuntimeException);
initMetadataForClass(CoroutinesInternalError, 'CoroutinesInternalError', VOID, Error_0);
initMetadataForObject(Key_2, 'Key');
initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle');
initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
initMetadataForClass(Finishing, 'Finishing', VOID, SynchronizedObject, [SynchronizedObject, Incomplete]);
initMetadataForClass(ChildCompletion, 'ChildCompletion', VOID, JobNode);
initMetadataForClass(AwaitContinuation, 'AwaitContinuation', VOID, CancellableContinuationImpl);
initMetadataForClass(JobImpl, 'JobImpl', VOID, JobSupport, [JobSupport, CompletableJob], [0]);
initMetadataForClass(Empty, 'Empty', VOID, VOID, [Incomplete]);
initMetadataForClass(LockFreeLinkedListHead, 'LockFreeLinkedListHead', LockFreeLinkedListHead, LockFreeLinkedListNode);
initMetadataForClass(NodeList, 'NodeList', NodeList, LockFreeLinkedListHead, [LockFreeLinkedListHead, Incomplete]);
initMetadataForClass(IncompleteStateBox, 'IncompleteStateBox');
initMetadataForClass(InactiveNodeList, 'InactiveNodeList', VOID, VOID, [Incomplete]);
initMetadataForClass(InvokeOnCompletion, 'InvokeOnCompletion', VOID, JobNode);
initMetadataForClass(InvokeOnCancelling, 'InvokeOnCancelling', VOID, JobNode);
initMetadataForClass(ResumeOnCompletion, 'ResumeOnCompletion', VOID, JobNode);
initMetadataForClass(ChildHandleNode, 'ChildHandleNode', VOID, JobNode);
initMetadataForClass(ResumeAwaitOnCompletion, 'ResumeAwaitOnCompletion', VOID, JobNode);
initMetadataForClass(MainCoroutineDispatcher, 'MainCoroutineDispatcher', VOID, CoroutineDispatcher);
initMetadataForClass(SupervisorJobImpl, 'SupervisorJobImpl', VOID, JobImpl, VOID, [0]);
initMetadataForClass(TimeoutCancellationException, 'TimeoutCancellationException', VOID, CancellationException, [CancellationException, CopyableThrowable]);
initMetadataForObject(Unconfined, 'Unconfined', VOID, CoroutineDispatcher);
initMetadataForObject(Key_3, 'Key');
initMetadataForClass(BufferOverflow, 'BufferOverflow', VOID, Enum);
initMetadataForClass(ConcurrentLinkedListNode, 'ConcurrentLinkedListNode');
initMetadataForClass(Segment, 'Segment', VOID, ConcurrentLinkedListNode, [ConcurrentLinkedListNode, NotCompleted]);
initMetadataForClass(ChannelSegment, 'ChannelSegment', VOID, Segment);
initMetadataForCoroutine($hasNextCOROUTINE$, CoroutineImpl);
initMetadataForClass(SendBroadcast, 'SendBroadcast', VOID, VOID, [Waiter]);
initMetadataForClass(BufferedChannelIterator, 'BufferedChannelIterator', VOID, VOID, [Waiter], [0, 3]);
initMetadataForCoroutine($sendCOROUTINE$, CoroutineImpl);
function close$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  return $super === VOID ? this.q2c(cause) : $super.q2c.call(this, cause);
}
initMetadataForInterface(SendChannel, 'SendChannel', VOID, VOID, VOID, [1]);
function cancel$default_0(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.o1y(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.o1y.call(this, cause);
  }
  return tmp;
}
initMetadataForInterface(ReceiveChannel, 'ReceiveChannel', VOID, VOID, VOID, [0]);
initMetadataForClass(BufferedChannel, 'BufferedChannel', VOID, VOID, [SendChannel, ReceiveChannel], [1, 4, 0, 3]);
initMetadataForClass(WaiterEB, 'WaiterEB');
initMetadataForClass(ReceiveCatching, 'ReceiveCatching', VOID, VOID, [Waiter]);
initMetadataForObject(Factory, 'Factory');
initMetadataForClass(Failed, 'Failed', Failed);
initMetadataForClass(Closed, 'Closed', VOID, Failed);
initMetadataForCompanion(Companion);
initMetadataForClass(ChannelResult, 'ChannelResult');
initMetadataForClass(ClosedReceiveChannelException, 'ClosedReceiveChannelException', VOID, NoSuchElementException);
initMetadataForClass(ClosedSendChannelException, 'ClosedSendChannelException', VOID, IllegalStateException);
initMetadataForClass(ChannelCoroutine, 'ChannelCoroutine', VOID, AbstractCoroutine, [AbstractCoroutine, SendChannel, ReceiveChannel], [1, 0]);
initMetadataForClass(ConflatedBufferedChannel, 'ConflatedBufferedChannel', VOID, BufferedChannel, VOID, [1, 0]);
initMetadataForInterface(ProducerScope, 'ProducerScope', VOID, VOID, [CoroutineScope, SendChannel], [1]);
initMetadataForClass(ProducerCoroutine, 'ProducerCoroutine', VOID, ChannelCoroutine, [ChannelCoroutine, ProducerScope], [1, 0]);
initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
initMetadataForClass(asFlow$$inlined$unsafeFlow$1, VOID, VOID, VOID, VOID, [1]);
initMetadataForInterface(FlowCollector, 'FlowCollector', VOID, VOID, VOID, [1]);
initMetadataForCoroutine($emitCOROUTINE$, CoroutineImpl);
initMetadataForClass(firstOrNull$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
initMetadataForCoroutine($firstOrNullCOROUTINE$, CoroutineImpl);
initMetadataForClass(SegmentOrClosed, 'SegmentOrClosed');
initMetadataForObject(ExceptionSuccessfullyProcessed, 'ExceptionSuccessfullyProcessed', VOID, Exception);
initMetadataForClass(DispatchedContinuation, 'DispatchedContinuation', VOID, DispatchedTask, [DispatchedTask, Continuation]);
initMetadataForClass(DispatchException, 'DispatchException', VOID, Exception);
initMetadataForClass(UndeliveredElementException, 'UndeliveredElementException', VOID, RuntimeException);
initMetadataForClass(ContextScope, 'ContextScope', VOID, VOID, [CoroutineScope]);
initMetadataForClass(Symbol, 'Symbol');
initMetadataForInterface(SelectInstance, 'SelectInstance');
initMetadataForClass(ClauseData, 'ClauseData', VOID, VOID, VOID, [1]);
initMetadataForClass(SelectImplementation, 'SelectImplementation', VOID, VOID, [CancelHandler, SelectInstance, Waiter], [0, 2]);
initMetadataForClass(TrySelectDetailedResult, 'TrySelectDetailedResult', VOID, Enum);
initMetadataForClass(CancellableContinuationWithOwner, 'CancellableContinuationWithOwner', VOID, VOID, [CancellableContinuation, Waiter]);
initMetadataForClass(SemaphoreAndMutexImpl, 'SemaphoreAndMutexImpl', VOID, VOID, VOID, [0]);
initMetadataForClass(MutexImpl, 'MutexImpl', VOID, SemaphoreAndMutexImpl, VOID, [1, 0]);
initMetadataForClass(SemaphoreSegment, 'SemaphoreSegment', VOID, Segment);
initMetadataForClass(SetTimeoutBasedDispatcher, 'SetTimeoutBasedDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
initMetadataForObject(NodeDispatcher, 'NodeDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
initMetadataForClass(MessageQueue, 'MessageQueue', VOID, VOID, [KtMutableList]);
initMetadataForClass(ScheduledMessageQueue, 'ScheduledMessageQueue', VOID, MessageQueue);
initMetadataForClass(WindowMessageQueue, 'WindowMessageQueue', VOID, MessageQueue);
initMetadataForClass(UnconfinedEventLoop, 'UnconfinedEventLoop', UnconfinedEventLoop, EventLoop);
initMetadataForObject(SetTimeoutDispatcher, 'SetTimeoutDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
initMetadataForClass(ClearTimeout, 'ClearTimeout', VOID, VOID, [CancelHandler]);
initMetadataForClass(WindowClearTimeout, 'WindowClearTimeout', VOID, ClearTimeout);
initMetadataForClass(WindowDispatcher, 'WindowDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
initMetadataForObject(Dispatchers, 'Dispatchers');
initMetadataForClass(JsMainDispatcher, 'JsMainDispatcher', VOID, MainCoroutineDispatcher);
initMetadataForClass(JobCancellationException, 'JobCancellationException', VOID, CancellationException);
initMetadataForClass(AbortFlowException, 'AbortFlowException', VOID, CancellationException);
initMetadataForClass(DiagnosticCoroutineContextException, 'DiagnosticCoroutineContextException', VOID, RuntimeException);
initMetadataForClass(ListClosed, 'ListClosed', VOID, LockFreeLinkedListNode);
initMetadataForClass(CommonThreadLocal, 'CommonThreadLocal', CommonThreadLocal);
//endregion
function AbstractCoroutine(parentContext, initParentJob, active) {
  JobSupport.call(this, active);
  if (initParentJob) {
    this.b1x(parentContext.q8(Key_instance_3));
  }
  this.e1x_1 = parentContext.fh(this);
}
protoOf(AbstractCoroutine).j8 = function () {
  return this.e1x_1;
};
protoOf(AbstractCoroutine).f1x = function () {
  return this.e1x_1;
};
protoOf(AbstractCoroutine).g1x = function () {
  return protoOf(JobSupport).g1x.call(this);
};
protoOf(AbstractCoroutine).h1x = function (value) {
};
protoOf(AbstractCoroutine).i1x = function (cause, handled) {
};
protoOf(AbstractCoroutine).j1x = function () {
  return get_classSimpleName(this) + ' was cancelled';
};
protoOf(AbstractCoroutine).k1x = function (state) {
  if (state instanceof CompletedExceptionally) {
    this.i1x(state.l1x_1, state.n1x());
  } else {
    this.h1x((state == null ? true : !(state == null)) ? state : THROW_CCE());
  }
};
protoOf(AbstractCoroutine).o8 = function (result) {
  var state = this.o1x(toState_0(result));
  if (state === get_COMPLETING_WAITING_CHILDREN())
    return Unit_instance;
  this.p1x(state);
};
protoOf(AbstractCoroutine).p1x = function (state) {
  return this.q1x(state);
};
protoOf(AbstractCoroutine).r1x = function (exception) {
  handleCoroutineException(this.e1x_1, exception);
};
protoOf(AbstractCoroutine).s1x = function () {
  var tmp0_elvis_lhs = get_coroutineName(this.e1x_1);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return protoOf(JobSupport).s1x.call(this);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var coroutineName = tmp;
  return '"' + coroutineName + '":' + protoOf(JobSupport).s1x.call(this);
};
protoOf(AbstractCoroutine).t1x = function (start, receiver, block) {
  start.w1x(block, receiver, this);
};
function launch(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.f1z() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
  coroutine.t1x(start, coroutine, block);
  return coroutine;
}
function async(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = start.f1z() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
  coroutine.t1x(start, coroutine, block);
  return coroutine;
}
function StandaloneCoroutine(parentContext, active) {
  AbstractCoroutine.call(this, parentContext, true, active);
}
protoOf(StandaloneCoroutine).a1z = function (exception) {
  handleCoroutineException(this.e1x_1, exception);
  return true;
};
function LazyStandaloneCoroutine(parentContext, block) {
  StandaloneCoroutine.call(this, parentContext, false);
  this.m1z_1 = createCoroutineUnintercepted(block, this, this);
}
protoOf(LazyStandaloneCoroutine).d1y = function () {
  startCoroutineCancellable_1(this.m1z_1, this);
};
function $awaitCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.v1z_1 = _this__u8e3s4;
}
protoOf($awaitCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.v1z_1.e1z(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function DeferredCoroutine(parentContext, active) {
  AbstractCoroutine.call(this, parentContext, true, active);
}
protoOf(DeferredCoroutine).z1z = function () {
  var tmp = this.d1z();
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(DeferredCoroutine).a20 = function ($completion) {
  var tmp = new $awaitCOROUTINE$(this, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
function LazyDeferredCoroutine(parentContext, block) {
  DeferredCoroutine.call(this, parentContext, false);
  this.e20_1 = createCoroutineUnintercepted(block, this, this);
}
protoOf(LazyDeferredCoroutine).d1y = function () {
  startCoroutineCancellable_1(this.e20_1, this);
};
function CancellableContinuation() {
}
function invokeOnCancellation(_this__u8e3s4, handler) {
  var tmp;
  if (_this__u8e3s4 instanceof CancellableContinuationImpl) {
    _this__u8e3s4.q20(handler);
    tmp = Unit_instance;
  } else {
    throw UnsupportedOperationException_init_$Create$('third-party implementation of CancellableContinuation is not supported');
  }
  return tmp;
}
function disposeOnCancellation(_this__u8e3s4, handle) {
  return invokeOnCancellation(_this__u8e3s4, new DisposeOnCancel(handle));
}
function DisposeOnCancel(handle) {
  this.r20_1 = handle;
}
protoOf(DisposeOnCancel).s20 = function (cause) {
  return this.r20_1.t20();
};
protoOf(DisposeOnCancel).toString = function () {
  return 'DisposeOnCancel[' + toString(this.r20_1) + ']';
};
function getOrCreateCancellableContinuation(delegate) {
  if (!(delegate instanceof DispatchedContinuation)) {
    return new CancellableContinuationImpl(delegate, 1);
  }
  var tmp0_safe_receiver = delegate.a21();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver.b21()) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return new CancellableContinuationImpl(delegate, 2);
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function get_RESUME_TOKEN() {
  _init_properties_CancellableContinuationImpl_kt__6rrtdd();
  return RESUME_TOKEN;
}
var RESUME_TOKEN;
function UserSupplied(handler) {
  this.c21_1 = handler;
}
protoOf(UserSupplied).s20 = function (cause) {
  this.c21_1(cause);
};
protoOf(UserSupplied).toString = function () {
  return 'CancelHandler.UserSupplied[' + get_classSimpleName(this.c21_1) + '@' + get_hexAddress(this) + ']';
};
function CancelHandler() {
}
function _get_parentHandle__f8dcex($this) {
  return $this.p20_1.kotlinx$atomicfu$value;
}
function _get_stateDebugRepresentation__bf18u4($this) {
  var tmp0_subject = $this.z1x();
  var tmp;
  if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
    tmp = 'Active';
  } else {
    if (tmp0_subject instanceof CancelledContinuation) {
      tmp = 'Cancelled';
    } else {
      tmp = 'Completed';
    }
  }
  return tmp;
}
function isReusable($this) {
  var tmp;
  if (get_isReusableMode($this.e21_1)) {
    var tmp_0 = $this.l20_1;
    tmp = (tmp_0 instanceof DispatchedContinuation ? tmp_0 : THROW_CCE()).d21();
  } else {
    tmp = false;
  }
  return tmp;
}
function cancelLater($this, cause) {
  if (!isReusable($this))
    return false;
  var tmp = $this.l20_1;
  var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
  return dispatched.f21(cause);
}
function callSegmentOnCancellation($this, segment, cause) {
  // Inline function 'kotlinx.coroutines.index' call
  var index = $this.n20_1.kotlinx$atomicfu$value & 536870911;
  // Inline function 'kotlin.check' call
  if (!!(index === 536870911)) {
    var message = 'The index for Segment.onCancellation(..) is broken';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
  try {
    segment.k21(index, cause, $this.j8());
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException($this.j8(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + $this.toString(), ex));
    } else {
      throw $p;
    }
  }
}
function trySuspend($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.n20_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.index' call

        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        var tmp$ret$2 = (1 << 29) + (cur & 536870911) | 0;
        if ($this.n20_1.atomicfu$compareAndSet(cur, tmp$ret$2))
          return true;
        break;
      case 2:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already suspended';
        throw IllegalStateException_init_$Create$(toString(message));
    }
  }
}
function tryResume($this) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.n20_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.decision' call
    switch (cur >> 29) {
      case 0:
        // Inline function 'kotlinx.coroutines.index' call

        // Inline function 'kotlinx.coroutines.decisionAndIndex' call

        var tmp$ret$2 = (2 << 29) + (cur & 536870911) | 0;
        if ($this.n20_1.atomicfu$compareAndSet(cur, tmp$ret$2))
          return true;
        break;
      case 1:
        return false;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Already resumed';
        throw IllegalStateException_init_$Create$(toString(message));
    }
  }
}
function installParentHandle($this) {
  var tmp0_elvis_lhs = $this.j8().q8(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var parent = tmp;
  var handle = invokeOnCompletion(parent, VOID, new ChildContinuation($this));
  $this.p20_1.atomicfu$compareAndSet(null, handle);
  return handle;
}
function invokeOnCancellationImpl($this, handler) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.o20_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (state instanceof Active) {
      if ($this.o20_1.atomicfu$compareAndSet(state, handler))
        return Unit_instance;
    } else {
      var tmp;
      if (!(state == null) ? isInterface(state, CancelHandler) : false) {
        tmp = true;
      } else {
        tmp = state instanceof Segment;
      }
      if (tmp) {
        multipleHandlersError($this, handler, state);
      } else {
        if (state instanceof CompletedExceptionally) {
          if (!state.t21()) {
            multipleHandlersError($this, handler, state);
          }
          if (state instanceof CancelledContinuation) {
            var tmp1_safe_receiver = state instanceof CompletedExceptionally ? state : null;
            var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l1x_1;
            if (isInterface(handler, CancelHandler)) {
              $this.q21(handler, cause);
            } else {
              var segment = handler instanceof Segment ? handler : THROW_CCE();
              callSegmentOnCancellation($this, segment, cause);
            }
          }
          return Unit_instance;
        } else {
          if (state instanceof CompletedContinuation) {
            if (!(state.m21_1 == null)) {
              multipleHandlersError($this, handler, state);
            }
            if (handler instanceof Segment)
              return Unit_instance;
            if (!isInterface(handler, CancelHandler))
              THROW_CCE();
            if (state.r21()) {
              $this.q21(handler, state.p21_1);
              return Unit_instance;
            }
            var update = state.s21(VOID, handler);
            if ($this.o20_1.atomicfu$compareAndSet(state, update))
              return Unit_instance;
          } else {
            if (handler instanceof Segment)
              return Unit_instance;
            if (!isInterface(handler, CancelHandler))
              THROW_CCE();
            var update_0 = new CompletedContinuation(state, handler);
            if ($this.o20_1.atomicfu$compareAndSet(state, update_0))
              return Unit_instance;
          }
        }
      }
    }
  }
}
function multipleHandlersError($this, handler, state) {
  // Inline function 'kotlin.error' call
  var message = "It's prohibited to register multiple handlers, tried to register " + toString(handler) + ', already has ' + toString_0(state);
  throw IllegalStateException_init_$Create$(toString(message));
}
function dispatchResume($this, mode) {
  if (tryResume($this))
    return Unit_instance;
  dispatch($this, mode);
}
function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
  var tmp;
  if (proposedUpdate instanceof CompletedExceptionally) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    tmp = proposedUpdate;
  } else {
    if (!get_isCancellableMode(resumeMode) && idempotent == null) {
      tmp = proposedUpdate;
    } else {
      var tmp_0;
      var tmp_1;
      if (!(onCancellation == null)) {
        tmp_1 = true;
      } else {
        tmp_1 = isInterface(state, CancelHandler);
      }
      if (tmp_1) {
        tmp_0 = true;
      } else {
        tmp_0 = !(idempotent == null);
      }
      if (tmp_0) {
        tmp = new CompletedContinuation(proposedUpdate, isInterface(state, CancelHandler) ? state : null, onCancellation, idempotent);
      } else {
        tmp = proposedUpdate;
      }
    }
  }
  return tmp;
}
function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = $this.o20_1;
  while (true) {
    var tmp0 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      if (!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false) {
        var update = resumedState($this, tmp0, proposedUpdate, $this.e21_1, onCancellation, idempotent);
        if (!$this.o20_1.atomicfu$compareAndSet(tmp0, update)) {
          break $l$block;
        }
        detachChildIfNonReusable($this);
        return get_RESUME_TOKEN();
      } else {
        if (tmp0 instanceof CompletedContinuation) {
          var tmp;
          if (!(idempotent == null) && tmp0.o21_1 === idempotent) {
            // Inline function 'kotlinx.coroutines.assert' call
            tmp = get_RESUME_TOKEN();
          } else {
            tmp = null;
          }
          return tmp;
        } else {
          return null;
        }
      }
    }
  }
}
function alreadyResumedError($this, proposedUpdate) {
  // Inline function 'kotlin.error' call
  var message = 'Already resumed, but proposed with update ' + toString_0(proposedUpdate);
  throw IllegalStateException_init_$Create$(toString(message));
}
function detachChildIfNonReusable($this) {
  if (!isReusable($this)) {
    $this.u21();
  }
}
function CancellableContinuationImpl$resume$lambda($onCancellation) {
  return function (cause, _unused_var__etf5q3, _unused_var__etf5q3_0) {
    $onCancellation(cause);
    return Unit_instance;
  };
}
function CancellableContinuationImpl(delegate, resumeMode) {
  DispatchedTask.call(this, resumeMode);
  this.l20_1 = delegate;
  // Inline function 'kotlinx.coroutines.assert' call
  this.m20_1 = this.l20_1.j8();
  var tmp = this;
  // Inline function 'kotlinx.coroutines.decisionAndIndex' call
  var tmp$ret$1 = (0 << 29) + 536870911 | 0;
  tmp.n20_1 = atomic$int$1(tmp$ret$1);
  this.o20_1 = atomic$ref$1(Active_instance);
  this.p20_1 = atomic$ref$1(null);
}
protoOf(CancellableContinuationImpl).v21 = function () {
  return this.l20_1;
};
protoOf(CancellableContinuationImpl).j8 = function () {
  return this.m20_1;
};
protoOf(CancellableContinuationImpl).z1x = function () {
  return this.o20_1.kotlinx$atomicfu$value;
};
protoOf(CancellableContinuationImpl).a1y = function () {
  var tmp = this.z1x();
  return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
};
protoOf(CancellableContinuationImpl).b1y = function () {
  var tmp = this.z1x();
  return tmp instanceof CancelledContinuation;
};
protoOf(CancellableContinuationImpl).w21 = function () {
  var tmp0_elvis_lhs = installParentHandle(this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var handle = tmp;
  if (this.a1y()) {
    handle.t20();
    this.p20_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
  }
};
protoOf(CancellableContinuationImpl).b21 = function () {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var state = this.o20_1.kotlinx$atomicfu$value;
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp;
  if (state instanceof CompletedContinuation) {
    tmp = !(state.o21_1 == null);
  } else {
    tmp = false;
  }
  if (tmp) {
    this.u21();
    return false;
  }
  var tmp_0 = this.n20_1;
  // Inline function 'kotlinx.coroutines.decisionAndIndex' call
  tmp_0.kotlinx$atomicfu$value = (0 << 29) + 536870911 | 0;
  this.o20_1.kotlinx$atomicfu$value = Active_instance;
  return true;
};
protoOf(CancellableContinuationImpl).x21 = function () {
  return this.z1x();
};
protoOf(CancellableContinuationImpl).y21 = function (takenState, cause) {
  var this_0 = this.o20_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (!(state == null) ? isInterface(state, NotCompleted) : false) {
      // Inline function 'kotlin.error' call
      var message = 'Not completed';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      if (state instanceof CompletedExceptionally)
        return Unit_instance;
      else {
        if (state instanceof CompletedContinuation) {
          // Inline function 'kotlin.check' call
          if (!!state.r21()) {
            var message_0 = 'Must be called at most once';
            throw IllegalStateException_init_$Create$(toString(message_0));
          }
          var update = state.s21(VOID, VOID, VOID, VOID, cause);
          if (this.o20_1.atomicfu$compareAndSet(state, update)) {
            state.z21(this, cause);
            return Unit_instance;
          }
        } else {
          if (this.o20_1.atomicfu$compareAndSet(state, new CompletedContinuation(state, VOID, VOID, VOID, cause))) {
            return Unit_instance;
          }
        }
      }
    }
  }
  return Unit_instance;
};
protoOf(CancellableContinuationImpl).a22 = function (cause) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.o20_1;
  while (true) {
    var tmp0 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      if (!(!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false))
        return false;
      var tmp;
      if (isInterface(tmp0, CancelHandler)) {
        tmp = true;
      } else {
        tmp = tmp0 instanceof Segment;
      }
      var update = new CancelledContinuation(this, cause, tmp);
      if (!this.o20_1.atomicfu$compareAndSet(tmp0, update)) {
        break $l$block;
      }
      if (isInterface(tmp0, CancelHandler)) {
        this.q21(tmp0, cause);
      } else {
        if (tmp0 instanceof Segment) {
          callSegmentOnCancellation(this, tmp0, cause);
        }
      }
      detachChildIfNonReusable(this);
      dispatchResume(this, this.e21_1);
      return true;
    }
  }
};
protoOf(CancellableContinuationImpl).b22 = function (cause) {
  if (cancelLater(this, cause))
    return Unit_instance;
  this.a22(cause);
  detachChildIfNonReusable(this);
};
protoOf(CancellableContinuationImpl).q21 = function (handler, cause) {
  // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
  try {
    handler.s20(cause);
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException(this.j8(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + this.toString(), ex));
    } else {
      throw $p;
    }
  }
  return Unit_instance;
};
protoOf(CancellableContinuationImpl).c22 = function (onCancellation, cause, value) {
  try {
    onCancellation(cause, value, this.j8());
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      handleCoroutineException(this.j8(), new CompletionHandlerException('Exception in resume onCancellation handler for ' + this.toString(), ex));
    } else {
      throw $p;
    }
  }
};
protoOf(CancellableContinuationImpl).d22 = function (parent) {
  return parent.e1y();
};
protoOf(CancellableContinuationImpl).e22 = function () {
  var isReusable_0 = isReusable(this);
  if (trySuspend(this)) {
    if (_get_parentHandle__f8dcex(this) == null) {
      installParentHandle(this);
    }
    if (isReusable_0) {
      this.f22();
    }
    return get_COROUTINE_SUSPENDED();
  }
  if (isReusable_0) {
    this.f22();
  }
  var state = this.z1x();
  if (state instanceof CompletedExceptionally)
    throw recoverStackTrace(state.l1x_1, this);
  if (get_isCancellableMode(this.e21_1)) {
    var job = this.j8().q8(Key_instance_3);
    if (!(job == null) && !job.g1x()) {
      var cause = job.e1y();
      this.y21(state, cause);
      throw recoverStackTrace(cause, this);
    }
  }
  return this.g22(state);
};
protoOf(CancellableContinuationImpl).f22 = function () {
  var tmp = this.l20_1;
  var tmp0_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h22(this);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var cancellationCause = tmp_0;
  this.u21();
  this.a22(cancellationCause);
};
protoOf(CancellableContinuationImpl).o8 = function (result) {
  return this.i22(toState(result, this), this.e21_1);
};
protoOf(CancellableContinuationImpl).j22 = function (value, onCancellation) {
  var tmp = this.e21_1;
  var tmp_0;
  if (onCancellation == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = CancellableContinuationImpl$resume$lambda(onCancellation);
  }
  return this.k22(value, tmp, tmp_0);
};
protoOf(CancellableContinuationImpl).j20 = function (value, onCancellation) {
  return this.k22(value, this.e21_1, onCancellation);
};
protoOf(CancellableContinuationImpl).l22 = function (segment, index) {
  var tmp0 = this.n20_1;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.index' call
      // Inline function 'kotlin.check' call
      if (!((cur & 536870911) === 536870911)) {
        var message = 'invokeOnCancellation should be called at most once';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'kotlinx.coroutines.decision' call
      // Inline function 'kotlinx.coroutines.decisionAndIndex' call
      var upd = (cur >> 29 << 29) + index | 0;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        break $l$block;
      }
    }
  }
  invokeOnCancellationImpl(this, segment);
};
protoOf(CancellableContinuationImpl).h20 = function (handler) {
  return invokeOnCancellation(this, new UserSupplied(handler));
};
protoOf(CancellableContinuationImpl).q20 = function (handler) {
  return invokeOnCancellationImpl(this, handler);
};
protoOf(CancellableContinuationImpl).k22 = function (proposedUpdate, resumeMode, onCancellation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.o20_1;
  while (true) {
    var tmp0 = this_0.kotlinx$atomicfu$value;
    $l$block: {
      if (!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false) {
        var update = resumedState(this, tmp0, proposedUpdate, resumeMode, onCancellation, null);
        if (!this.o20_1.atomicfu$compareAndSet(tmp0, update)) {
          break $l$block;
        }
        detachChildIfNonReusable(this);
        dispatchResume(this, resumeMode);
        return Unit_instance;
      } else {
        if (tmp0 instanceof CancelledContinuation) {
          if (tmp0.p22()) {
            if (onCancellation == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              this.c22(onCancellation, tmp0.l1x_1, proposedUpdate);
            }
            return Unit_instance;
          }
        }
      }
      alreadyResumedError(this, proposedUpdate);
    }
  }
};
protoOf(CancellableContinuationImpl).i22 = function (proposedUpdate, resumeMode, onCancellation, $super) {
  onCancellation = onCancellation === VOID ? null : onCancellation;
  var tmp;
  if ($super === VOID) {
    this.k22(proposedUpdate, resumeMode, onCancellation);
    tmp = Unit_instance;
  } else {
    tmp = $super.k22.call(this, proposedUpdate, resumeMode, onCancellation);
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).u21 = function () {
  var tmp0_elvis_lhs = _get_parentHandle__f8dcex(this);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var handle = tmp;
  handle.t20();
  this.p20_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
};
protoOf(CancellableContinuationImpl).f20 = function (value, idempotent, onCancellation) {
  return tryResumeImpl(this, value, idempotent, onCancellation);
};
protoOf(CancellableContinuationImpl).g20 = function (token) {
  // Inline function 'kotlinx.coroutines.assert' call
  dispatchResume(this, this.e21_1);
};
protoOf(CancellableContinuationImpl).i20 = function (_this__u8e3s4, value) {
  var tmp = this.l20_1;
  var dc = tmp instanceof DispatchedContinuation ? tmp : null;
  var tmp_0;
  if ((dc == null ? null : dc.v20_1) === _this__u8e3s4) {
    tmp_0 = 4;
  } else {
    tmp_0 = this.e21_1;
  }
  this.i22(value, tmp_0);
};
protoOf(CancellableContinuationImpl).g22 = function (state) {
  var tmp;
  if (state instanceof CompletedContinuation) {
    var tmp_0 = state.l21_1;
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    tmp = (state == null ? true : !(state == null)) ? state : THROW_CCE();
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).q22 = function (state) {
  var tmp0_safe_receiver = protoOf(DispatchedTask).q22.call(this, state);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = recoverStackTrace(tmp0_safe_receiver, this.l20_1);
  }
  return tmp;
};
protoOf(CancellableContinuationImpl).toString = function () {
  return this.r22() + '(' + toDebugString(this.l20_1) + '){' + _get_stateDebugRepresentation__bf18u4(this) + '}@' + get_hexAddress(this);
};
protoOf(CancellableContinuationImpl).r22 = function () {
  return 'CancellableContinuation';
};
function NotCompleted() {
}
function Active() {
}
protoOf(Active).toString = function () {
  return 'Active';
};
var Active_instance;
function Active_getInstance() {
  return Active_instance;
}
function CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
  cancelHandler = cancelHandler === VOID ? null : cancelHandler;
  onCancellation = onCancellation === VOID ? null : onCancellation;
  idempotentResume = idempotentResume === VOID ? null : idempotentResume;
  cancelCause = cancelCause === VOID ? null : cancelCause;
  this.l21_1 = result;
  this.m21_1 = cancelHandler;
  this.n21_1 = onCancellation;
  this.o21_1 = idempotentResume;
  this.p21_1 = cancelCause;
}
protoOf(CompletedContinuation).r21 = function () {
  return !(this.p21_1 == null);
};
protoOf(CompletedContinuation).z21 = function (cont, cause) {
  var tmp0_safe_receiver = this.m21_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    cont.q21(tmp0_safe_receiver, cause);
  }
  var tmp1_safe_receiver = this.n21_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    cont.c22(tmp1_safe_receiver, cause, this.l21_1);
  }
};
protoOf(CompletedContinuation).u22 = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
  return new CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
};
protoOf(CompletedContinuation).s21 = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $super) {
  result = result === VOID ? this.l21_1 : result;
  cancelHandler = cancelHandler === VOID ? this.m21_1 : cancelHandler;
  onCancellation = onCancellation === VOID ? this.n21_1 : onCancellation;
  idempotentResume = idempotentResume === VOID ? this.o21_1 : idempotentResume;
  cancelCause = cancelCause === VOID ? this.p21_1 : cancelCause;
  return $super === VOID ? this.u22(result, cancelHandler, onCancellation, idempotentResume, cancelCause) : $super.u22.call(this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
};
protoOf(CompletedContinuation).toString = function () {
  return 'CompletedContinuation(result=' + toString_0(this.l21_1) + ', cancelHandler=' + toString_0(this.m21_1) + ', onCancellation=' + toString_0(this.n21_1) + ', idempotentResume=' + toString_0(this.o21_1) + ', cancelCause=' + toString_0(this.p21_1) + ')';
};
protoOf(CompletedContinuation).hashCode = function () {
  var result = this.l21_1 == null ? 0 : hashCode(this.l21_1);
  result = imul(result, 31) + (this.m21_1 == null ? 0 : hashCode(this.m21_1)) | 0;
  result = imul(result, 31) + (this.n21_1 == null ? 0 : hashCode(this.n21_1)) | 0;
  result = imul(result, 31) + (this.o21_1 == null ? 0 : hashCode(this.o21_1)) | 0;
  result = imul(result, 31) + (this.p21_1 == null ? 0 : hashCode(this.p21_1)) | 0;
  return result;
};
protoOf(CompletedContinuation).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CompletedContinuation))
    return false;
  var tmp0_other_with_cast = other instanceof CompletedContinuation ? other : THROW_CCE();
  if (!equals(this.l21_1, tmp0_other_with_cast.l21_1))
    return false;
  if (!equals(this.m21_1, tmp0_other_with_cast.m21_1))
    return false;
  if (!equals(this.n21_1, tmp0_other_with_cast.n21_1))
    return false;
  if (!equals(this.o21_1, tmp0_other_with_cast.o21_1))
    return false;
  if (!equals(this.p21_1, tmp0_other_with_cast.p21_1))
    return false;
  return true;
};
function ChildContinuation(child) {
  JobNode.call(this);
  this.z22_1 = child;
}
protoOf(ChildContinuation).a23 = function () {
  return true;
};
protoOf(ChildContinuation).s20 = function (cause) {
  this.z22_1.b22(this.z22_1.d22(this.f23()));
};
var properties_initialized_CancellableContinuationImpl_kt_xtzb03;
function _init_properties_CancellableContinuationImpl_kt__6rrtdd() {
  if (!properties_initialized_CancellableContinuationImpl_kt_xtzb03) {
    properties_initialized_CancellableContinuationImpl_kt_xtzb03 = true;
    RESUME_TOKEN = new Symbol('RESUME_TOKEN');
  }
}
function CompletableDeferred(parent) {
  parent = parent === VOID ? null : parent;
  return new CompletableDeferredImpl(parent);
}
function $awaitCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.v23_1 = _this__u8e3s4;
}
protoOf($awaitCOROUTINE$_0).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this.v23_1.e1z(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
        case 2:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 2) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function CompletableDeferredImpl(parent) {
  JobSupport.call(this, true);
  this.b1x(parent);
}
protoOf(CompletableDeferredImpl).n1y = function () {
  return true;
};
protoOf(CompletableDeferredImpl).z1z = function () {
  var tmp = this.d1z();
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(CompletableDeferredImpl).a20 = function ($completion) {
  var tmp = new $awaitCOROUTINE$_0(this, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(CompletableDeferredImpl).y23 = function (value) {
  return this.z23(value);
};
protoOf(CompletableDeferredImpl).a24 = function (exception) {
  return this.z23(new CompletedExceptionally(exception));
};
function CompletableJob() {
}
function CompletedExceptionally(cause, handled) {
  handled = handled === VOID ? false : handled;
  this.l1x_1 = cause;
  this.m1x_1 = atomic$boolean$1(handled);
}
protoOf(CompletedExceptionally).n1x = function () {
  return this.m1x_1.kotlinx$atomicfu$value;
};
protoOf(CompletedExceptionally).t21 = function () {
  return this.m1x_1.atomicfu$compareAndSet(false, true);
};
protoOf(CompletedExceptionally).toString = function () {
  return get_classSimpleName(this) + '[' + this.l1x_1.toString() + ']';
};
function CancelledContinuation(continuation, cause, handled) {
  CompletedExceptionally.call(this, cause == null ? CancellationException_init_$Create$('Continuation ' + toString(continuation) + ' was cancelled normally') : cause, handled);
  this.o22_1 = atomic$boolean$1(false);
}
protoOf(CancelledContinuation).p22 = function () {
  return this.o22_1.atomicfu$compareAndSet(false, true);
};
function toState(_this__u8e3s4, caller) {
  // Inline function 'kotlin.getOrElse' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    tmp = new CompletedExceptionally(recoverStackTrace(exception, caller));
  }
  return tmp;
}
function toState_0(_this__u8e3s4) {
  // Inline function 'kotlin.getOrElse' call
  var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
  var tmp;
  if (exception == null) {
    var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
  } else {
    tmp = new CompletedExceptionally(exception);
  }
  return tmp;
}
function CoroutineDispatcher$Key$_init_$lambda_akl8b5(it) {
  return it instanceof CoroutineDispatcher ? it : null;
}
function Key() {
  Key_instance_0 = this;
  var tmp = Key_instance;
  AbstractCoroutineContextKey.call(this, tmp, CoroutineDispatcher$Key$_init_$lambda_akl8b5);
}
var Key_instance_0;
function Key_getInstance() {
  if (Key_instance_0 == null)
    new Key();
  return Key_instance_0;
}
function CoroutineDispatcher() {
  Key_getInstance();
  AbstractCoroutineContextElement.call(this, Key_instance);
}
protoOf(CoroutineDispatcher).d24 = function (context) {
  return true;
};
protoOf(CoroutineDispatcher).r8 = function (continuation) {
  return new DispatchedContinuation(this, continuation);
};
protoOf(CoroutineDispatcher).s8 = function (continuation) {
  var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
  dispatched.f24();
};
protoOf(CoroutineDispatcher).toString = function () {
  return get_classSimpleName(this) + '@' + get_hexAddress(this);
};
function Key_0() {
}
var Key_instance_1;
function Key_getInstance_0() {
  return Key_instance_1;
}
function handleCoroutineException(context, exception) {
  var tmp;
  if (exception instanceof DispatchException) {
    tmp = exception.g24_1;
  } else {
    tmp = exception;
  }
  var reportException = tmp;
  try {
    var tmp0_safe_receiver = context.q8(Key_instance_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.h24(context, reportException);
      return Unit_instance;
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      handleUncaughtCoroutineException(context, handlerException(reportException, t));
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  handleUncaughtCoroutineException(context, reportException);
}
function handlerException(originalException, thrownException) {
  if (originalException === thrownException)
    return originalException;
  // Inline function 'kotlin.apply' call
  var this_0 = RuntimeException_init_$Create$('Exception while trying to handle coroutine exception', thrownException);
  addSuppressed(this_0, originalException);
  return this_0;
}
function Key_1() {
}
var Key_instance_2;
function Key_getInstance_1() {
  return Key_instance_2;
}
function CoroutineName(name) {
  AbstractCoroutineContextElement.call(this, Key_instance_2);
  this.j24_1 = name;
}
protoOf(CoroutineName).toString = function () {
  return 'CoroutineName(' + this.j24_1 + ')';
};
protoOf(CoroutineName).hashCode = function () {
  return getStringHashCode(this.j24_1);
};
protoOf(CoroutineName).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CoroutineName))
    return false;
  var tmp0_other_with_cast = other instanceof CoroutineName ? other : THROW_CCE();
  if (!(this.j24_1 === tmp0_other_with_cast.j24_1))
    return false;
  return true;
};
function CoroutineScope() {
}
function GlobalScope() {
}
protoOf(GlobalScope).f1x = function () {
  return EmptyCoroutineContext_instance;
};
var GlobalScope_instance;
function GlobalScope_getInstance() {
  return GlobalScope_instance;
}
function CoroutineScope_0(context) {
  return new ContextScope(!(context.q8(Key_instance_3) == null) ? context : context.fh(Job_0()));
}
function cancel(_this__u8e3s4, message, cause) {
  cause = cause === VOID ? null : cause;
  return cancel_0(_this__u8e3s4, CancellationException_0(message, cause));
}
function cancel_0(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_elvis_lhs = _this__u8e3s4.f1x().q8(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = 'Scope cannot be cancelled because it does not have a job: ' + toString(_this__u8e3s4);
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var job = tmp;
  job.o1y(cause);
}
function MainScope() {
  return new ContextScope(SupervisorJob().fh(Dispatchers_getInstance().o24()));
}
var CoroutineStart_DEFAULT_instance;
var CoroutineStart_LAZY_instance;
var CoroutineStart_ATOMIC_instance;
var CoroutineStart_UNDISPATCHED_instance;
var CoroutineStart_entriesInitialized;
function CoroutineStart_initEntries() {
  if (CoroutineStart_entriesInitialized)
    return Unit_instance;
  CoroutineStart_entriesInitialized = true;
  CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
  CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
  CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
  CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
}
function CoroutineStart(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(CoroutineStart).w1x = function (block, receiver, completion) {
  var tmp;
  switch (this.j2_1) {
    case 0:
      startCoroutineCancellable_0(block, receiver, completion);
      tmp = Unit_instance;
      break;
    case 2:
      startCoroutine(block, receiver, completion);
      tmp = Unit_instance;
      break;
    case 3:
      startCoroutineUndispatched(block, receiver, completion);
      tmp = Unit_instance;
      break;
    case 1:
      tmp = Unit_instance;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(CoroutineStart).f1z = function () {
  return this === CoroutineStart_LAZY_getInstance();
};
function CoroutineStart_DEFAULT_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_DEFAULT_instance;
}
function CoroutineStart_LAZY_getInstance() {
  CoroutineStart_initEntries();
  return CoroutineStart_LAZY_instance;
}
function CopyableThrowable() {
}
function delay(timeMillis, $completion) {
  if (timeMillis <= 0n)
    return Unit_instance;
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.w21();
  if (timeMillis < 9223372036854775807n) {
    get_delay(cancellable.j8()).q24(timeMillis, cancellable);
  }
  return cancellable.e22();
}
function Delay() {
}
function get_delay(_this__u8e3s4) {
  var tmp = _this__u8e3s4.q8(Key_instance);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
}
function delta($this, unconfined) {
  return unconfined ? 4294967296n : 1n;
}
function EventLoop() {
  CoroutineDispatcher.call(this);
  this.s24_1 = 0n;
  this.t24_1 = false;
  this.u24_1 = null;
}
protoOf(EventLoop).v24 = function () {
  var tmp0_elvis_lhs = this.u24_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var queue = tmp;
  var tmp1_elvis_lhs = queue.ze();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var task = tmp_0;
  task.s22();
  return true;
};
protoOf(EventLoop).w24 = function (task) {
  var tmp0_elvis_lhs = this.u24_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = ArrayDeque_init_$Create$();
    this.u24_1 = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var queue = tmp;
  queue.xe(task);
};
protoOf(EventLoop).x24 = function () {
  return this.s24_1 >= delta(this, true);
};
protoOf(EventLoop).y24 = function () {
  var tmp0_safe_receiver = this.u24_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q();
  return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
};
protoOf(EventLoop).z24 = function (unconfined) {
  this.s24_1 = add(this.s24_1, delta(this, unconfined));
  if (!unconfined)
    this.t24_1 = true;
};
protoOf(EventLoop).a25 = function (unconfined) {
  this.s24_1 = subtract(this.s24_1, delta(this, unconfined));
  if (this.s24_1 > 0n)
    return Unit_instance;
  // Inline function 'kotlinx.coroutines.assert' call
  if (this.t24_1) {
    this.b25();
  }
};
protoOf(EventLoop).b25 = function () {
};
function ThreadLocalEventLoop() {
  ThreadLocalEventLoop_instance = this;
  this.c25_1 = commonThreadLocal(new Symbol('ThreadLocalEventLoop'));
}
protoOf(ThreadLocalEventLoop).d25 = function () {
  var tmp0_elvis_lhs = this.c25_1.f25();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = createEventLoop();
    ThreadLocalEventLoop_getInstance().c25_1.g25(this_0);
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
var ThreadLocalEventLoop_instance;
function ThreadLocalEventLoop_getInstance() {
  if (ThreadLocalEventLoop_instance == null)
    new ThreadLocalEventLoop();
  return ThreadLocalEventLoop_instance;
}
function CompletionHandlerException(message, cause) {
  RuntimeException_init_$Init$(message, cause, this);
  captureStack(this, CompletionHandlerException);
}
function CoroutinesInternalError(message, cause) {
  Error_init_$Init$(message, cause, this);
  captureStack(this, CoroutinesInternalError);
}
function Key_2() {
}
var Key_instance_3;
function Key_getInstance_2() {
  return Key_instance_3;
}
function Job() {
}
function cancel_1(_this__u8e3s4, message, cause) {
  cause = cause === VOID ? null : cause;
  return _this__u8e3s4.o1y(CancellationException_0(message, cause));
}
function get_job(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.q8(Key_instance_3);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var message = "Current context doesn't contain Job in it: " + toString(_this__u8e3s4);
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function cancel_2(_this__u8e3s4, cause) {
  cause = cause === VOID ? null : cause;
  var tmp0_safe_receiver = _this__u8e3s4.q8(Key_instance_3);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.o1y(cause);
  }
}
function Job_0(parent) {
  parent = parent === VOID ? null : parent;
  return new JobImpl(parent);
}
function invokeOnCompletion(_this__u8e3s4, invokeImmediately, handler) {
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  var tmp;
  if (_this__u8e3s4 instanceof JobSupport) {
    tmp = _this__u8e3s4.k1y(invokeImmediately, handler);
  } else {
    var tmp_0 = handler.a23();
    tmp = _this__u8e3s4.i1y(tmp_0, invokeImmediately, JobNode$invoke$ref(handler));
  }
  return tmp;
}
function ensureActive(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.q8(Key_instance_3);
  if (tmp0_safe_receiver == null)
    null;
  else {
    ensureActive_0(tmp0_safe_receiver);
  }
}
function NonDisposableHandle() {
}
protoOf(NonDisposableHandle).t20 = function () {
};
protoOf(NonDisposableHandle).s1y = function (cause) {
  return false;
};
protoOf(NonDisposableHandle).toString = function () {
  return 'NonDisposableHandle';
};
var NonDisposableHandle_instance;
function NonDisposableHandle_getInstance() {
  return NonDisposableHandle_instance;
}
function ensureActive_0(_this__u8e3s4) {
  if (!_this__u8e3s4.g1x())
    throw _this__u8e3s4.e1y();
}
function ParentJob() {
}
function JobNode$invoke$ref(p0) {
  var l = function (_this__u8e3s4) {
    p0.s20(_this__u8e3s4);
    return Unit_instance;
  };
  l.callableName = 'invoke';
  return l;
}
function get_COMPLETING_ALREADY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_ALREADY;
}
var COMPLETING_ALREADY;
function get_COMPLETING_WAITING_CHILDREN() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_WAITING_CHILDREN;
}
var COMPLETING_WAITING_CHILDREN;
function get_COMPLETING_RETRY() {
  _init_properties_JobSupport_kt__68f172();
  return COMPLETING_RETRY;
}
var COMPLETING_RETRY;
function get_TOO_LATE_TO_CANCEL() {
  _init_properties_JobSupport_kt__68f172();
  return TOO_LATE_TO_CANCEL;
}
var TOO_LATE_TO_CANCEL;
function get_SEALED() {
  _init_properties_JobSupport_kt__68f172();
  return SEALED;
}
var SEALED;
function get_EMPTY_NEW() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_NEW;
}
var EMPTY_NEW;
function get_EMPTY_ACTIVE() {
  _init_properties_JobSupport_kt__68f172();
  return EMPTY_ACTIVE;
}
var EMPTY_ACTIVE;
function JobNode() {
  LockFreeLinkedListNode.call(this);
}
protoOf(JobNode).f23 = function () {
  var tmp = this.e23_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('job');
  }
};
protoOf(JobNode).g1x = function () {
  return true;
};
protoOf(JobNode).g23 = function () {
  return null;
};
protoOf(JobNode).t20 = function () {
  return this.f23().m1y(this);
};
protoOf(JobNode).toString = function () {
  return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.f23()) + ']';
};
function unboxState(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h25_1;
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
function _set_exceptionsHolder__tqm22h($this, value) {
  $this.l25_1.kotlinx$atomicfu$value = value;
}
function _get_exceptionsHolder__nhszp($this) {
  return $this.l25_1.kotlinx$atomicfu$value;
}
function allocateList($this) {
  return ArrayList_init_$Create$(4);
}
function finalizeFinishingState($this, state, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l1x_1;
  var wasCancelling;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  wasCancelling = state.m25();
  var exceptions = state.n25(proposedException);
  var finalCause = getFinalRootCause($this, state, exceptions);
  if (!(finalCause == null)) {
    addSuppressedExceptions($this, finalCause, exceptions);
  }
  var finalException = finalCause;
  var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new CompletedExceptionally(finalException);
  if (!(finalException == null)) {
    var handled = cancelParent($this, finalException) || $this.a1z(finalException);
    if (handled) {
      (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).t21();
    }
  }
  if (!wasCancelling) {
    $this.x1y(finalException);
  }
  $this.k1x(finalState);
  var casSuccess = $this.z1w_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
  // Inline function 'kotlinx.coroutines.assert' call
  completeStateFinalization($this, state, finalState);
  return finalState;
}
function getFinalRootCause($this, state, exceptions) {
  if (exceptions.q()) {
    if (state.m25()) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      return new JobCancellationException(null == null ? $this.j1x() : null, null, $this);
    }
    return null;
  }
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = exceptions.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      if (!(element instanceof CancellationException)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var firstNonCancellation = tmp$ret$2;
  if (!(firstNonCancellation == null))
    return firstNonCancellation;
  var first = exceptions.p(0);
  if (first instanceof TimeoutCancellationException) {
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = exceptions.l();
      while (_iterator__ex2g4s_0.m()) {
        var element_0 = _iterator__ex2g4s_0.n();
        var tmp;
        if (!(element_0 === first)) {
          tmp = element_0 instanceof TimeoutCancellationException;
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$4 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$4 = null;
    }
    var detailedTimeoutException = tmp$ret$4;
    if (!(detailedTimeoutException == null))
      return detailedTimeoutException;
  }
  return first;
}
function addSuppressedExceptions($this, rootCause, exceptions) {
  if (exceptions.o() <= 1)
    return Unit_instance;
  var seenExceptions = identitySet(exceptions.o());
  var unwrappedCause = unwrap(rootCause);
  var _iterator__ex2g4s = exceptions.l();
  while (_iterator__ex2g4s.m()) {
    var exception = _iterator__ex2g4s.n();
    var unwrapped = unwrap(exception);
    var tmp;
    var tmp_0;
    if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
      tmp_0 = !(unwrapped instanceof CancellationException);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = seenExceptions.j(unwrapped);
    } else {
      tmp = false;
    }
    if (tmp) {
      addSuppressed(rootCause, unwrapped);
    }
  }
}
function tryFinalizeSimpleState($this, state, update) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  if (!$this.z1w_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
    return false;
  $this.x1y(null);
  $this.k1x(update);
  completeStateFinalization($this, state, update);
  return true;
}
function completeStateFinalization($this, state, update) {
  var tmp0_safe_receiver = $this.y1x();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    tmp0_safe_receiver.t20();
    $this.x1x(NonDisposableHandle_instance);
  }
  var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
  var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l1x_1;
  if (state instanceof JobNode) {
    try {
      state.s20(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        $this.r1x(new CompletionHandlerException('Exception in completion handler ' + state.toString() + ' for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  } else {
    var tmp2_safe_receiver = state.g23();
    if (tmp2_safe_receiver == null)
      null;
    else {
      notifyCompletion($this, tmp2_safe_receiver, cause);
    }
  }
}
function notifyCancelling($this, list, cause) {
  $this.x1y(cause);
  list.o25(4);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = list.h23_1;
  while (!equals(cur, list)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      tmp = node.a23();
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.s20(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.h23_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.r1x(tmp0_safe_receiver_0);
  }
  cancelParent($this, cause);
}
function cancelParent($this, cause) {
  if ($this.y1y())
    return true;
  var isCancellation = cause instanceof CancellationException;
  var parent = $this.y1x();
  if (parent === null || parent === NonDisposableHandle_instance) {
    return isCancellation;
  }
  return parent.s1y(cause) || isCancellation;
}
function notifyCompletion($this, _this__u8e3s4, cause) {
  _this__u8e3s4.o25(1);
  // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
  var exception = null;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = _this__u8e3s4.h23_1;
  while (!equals(cur, _this__u8e3s4)) {
    var node = cur;
    var tmp;
    if (node instanceof JobNode) {
      tmp = true;
    } else {
      tmp = false;
    }
    if (tmp) {
      try {
        node.s20(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          var tmp0_safe_receiver = exception;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.apply' call
            addSuppressed(tmp0_safe_receiver, ex);
            tmp_0 = tmp0_safe_receiver;
          }
          if (tmp_0 == null) {
            // Inline function 'kotlin.run' call
            exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
          }
        } else {
          throw $p;
        }
      }
    }
    cur = cur.h23_1;
  }
  var tmp0_safe_receiver_0 = exception;
  if (tmp0_safe_receiver_0 == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.r1x(tmp0_safe_receiver_0);
  }
}
function startInternal($this, state) {
  if (state instanceof Empty) {
    if (state.q25_1)
      return 0;
    if (!$this.z1w_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
      return -1;
    $this.d1y();
    return 1;
  } else {
    if (state instanceof InactiveNodeList) {
      if (!$this.z1w_1.atomicfu$compareAndSet(state, state.p25_1))
        return -1;
      $this.d1y();
      return 1;
    } else {
      return 0;
    }
  }
}
function promoteEmptyToNodeList($this, state) {
  var list = new NodeList();
  var update = state.q25_1 ? list : new InactiveNodeList(list);
  $this.z1w_1.atomicfu$compareAndSet(state, update);
}
function promoteSingleToNodeList($this, state) {
  state.m23(new NodeList());
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
  var list = state.h23_1;
  $this.z1w_1.atomicfu$compareAndSet(state, list);
}
function joinInternal($this) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.z1x();
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return false;
    if (startInternal($this, state) >= 0)
      return true;
  }
}
function joinSuspend($this, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.w21();
  disposeOnCancellation(cancellable, invokeOnCompletion($this, VOID, new ResumeOnCompletion(cancellable)));
  return cancellable.e22();
}
function cancelMakeCompleting($this, cause) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = $this.z1x();
    var tmp;
    if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing) {
        tmp_0 = state.r25();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      return get_COMPLETING_ALREADY();
    }
    var proposedUpdate = new CompletedExceptionally(createCauseException($this, cause));
    var finalState = tryMakeCompleting($this, state, proposedUpdate);
    if (!(finalState === get_COMPLETING_RETRY()))
      return finalState;
  }
}
function createCauseException($this, cause) {
  var tmp;
  if (cause == null ? true : cause instanceof Error) {
    var tmp_0;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp_0 = new JobCancellationException(null == null ? $this.j1x() : null, null, $this);
    } else {
      tmp_0 = cause;
    }
    tmp = tmp_0;
  } else {
    tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).v1y();
  }
  return tmp;
}
function makeCancelling($this, cause) {
  var causeExceptionCache = null;
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp0 = $this.z1x();
    $l$block: {
      if (tmp0 instanceof Finishing) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        if (tmp0.s25())
          return get_TOO_LATE_TO_CANCEL();
        var wasCancelling = tmp0.m25();
        if (!(cause == null) || !wasCancelling) {
          var tmp0_elvis_lhs = causeExceptionCache;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = createCauseException($this, cause);
            causeExceptionCache = this_0;
            tmp = this_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var causeException = tmp;
          tmp0.t25(causeException);
        }
        // Inline function 'kotlin.takeIf' call
        var this_1 = tmp0.u25();
        var tmp_0;
        if (!wasCancelling) {
          tmp_0 = this_1;
        } else {
          tmp_0 = null;
        }
        var notifyRootCause = tmp_0;
        if (notifyRootCause == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          notifyCancelling($this, tmp0.i25_1, notifyRootCause);
        }
        return get_COMPLETING_ALREADY();
      } else {
        if (!(tmp0 == null) ? isInterface(tmp0, Incomplete) : false) {
          var tmp2_elvis_lhs = causeExceptionCache;
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_2 = createCauseException($this, cause);
            causeExceptionCache = this_2;
            tmp_1 = this_2;
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var causeException_0 = tmp_1;
          if (tmp0.g1x()) {
            if (tryMakeCancelling($this, tmp0, causeException_0))
              return get_COMPLETING_ALREADY();
          } else {
            var finalState = tryMakeCompleting($this, tmp0, new CompletedExceptionally(causeException_0));
            if (finalState === get_COMPLETING_ALREADY()) {
              // Inline function 'kotlin.error' call
              var message = 'Cannot happen in ' + toString(tmp0);
              throw IllegalStateException_init_$Create$(toString(message));
            } else if (finalState === get_COMPLETING_RETRY()) {
              break $l$block;
            } else
              return finalState;
          }
        } else {
          return get_TOO_LATE_TO_CANCEL();
        }
      }
    }
  }
}
function getOrPromoteCancellingList($this, state) {
  var tmp0_elvis_lhs = state.g23();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    if (state instanceof Empty) {
      tmp_0 = new NodeList();
    } else {
      if (state instanceof JobNode) {
        promoteSingleToNodeList($this, state);
        tmp_0 = null;
      } else {
        var message = 'State should have list: ' + toString(state);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function tryMakeCancelling($this, state, rootCause) {
  // Inline function 'kotlinx.coroutines.assert' call
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var cancelling = new Finishing(list, false, rootCause);
  if (!$this.z1w_1.atomicfu$compareAndSet(state, cancelling))
    return false;
  notifyCancelling($this, list, rootCause);
  return true;
}
function tryMakeCompleting($this, state, proposedUpdate) {
  if (!(!(state == null) ? isInterface(state, Incomplete) : false))
    return get_COMPLETING_ALREADY();
  var tmp;
  var tmp_0;
  var tmp_1;
  if (state instanceof Empty) {
    tmp_1 = true;
  } else {
    tmp_1 = state instanceof JobNode;
  }
  if (tmp_1) {
    tmp_0 = !(state instanceof ChildHandleNode);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = !(proposedUpdate instanceof CompletedExceptionally);
  } else {
    tmp = false;
  }
  if (tmp) {
    if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
      return proposedUpdate;
    }
    return get_COMPLETING_RETRY();
  }
  return tryMakeCompletingSlowPath($this, state, proposedUpdate);
}
function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
  var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return get_COMPLETING_RETRY();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var list = tmp;
  var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
  var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
  var notifyRootCause;
  // Inline function 'kotlinx.coroutines.internal.synchronized' call
  // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
  if (finishing.r25())
    return get_COMPLETING_ALREADY();
  finishing.v25(true);
  if (!(finishing === state)) {
    if (!$this.z1w_1.atomicfu$compareAndSet(state, finishing))
      return get_COMPLETING_RETRY();
  }
  // Inline function 'kotlinx.coroutines.assert' call
  var wasCancelling = finishing.m25();
  var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    finishing.t25(tmp0_safe_receiver.l1x_1);
  }
  // Inline function 'kotlin.takeIf' call
  var this_0 = finishing.u25();
  var tmp_0;
  if (!wasCancelling) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  notifyRootCause = tmp_0;
  if (notifyRootCause == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    notifyCancelling($this, list, notifyRootCause);
  }
  var child = nextChild($this, list);
  if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  list.o25(2);
  var anotherChild = nextChild($this, list);
  if (!(anotherChild == null) && tryWaitForChild($this, finishing, anotherChild, proposedUpdate))
    return get_COMPLETING_WAITING_CHILDREN();
  return finalizeFinishingState($this, finishing, proposedUpdate);
}
function _get_exceptionOrNull__b3j7js($this, _this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4 instanceof CompletedExceptionally ? _this__u8e3s4 : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l1x_1;
}
function tryWaitForChild($this, state, child, proposedUpdate) {
  var $this_0 = $this;
  var state_0 = state;
  var child_0 = child;
  var proposedUpdate_0 = proposedUpdate;
  $l$1: do {
    $l$0: do {
      var handle = invokeOnCompletion(child_0.a26_1, false, new ChildCompletion($this_0, state_0, child_0, proposedUpdate_0));
      if (!(handle === NonDisposableHandle_instance))
        return true;
      var tmp0_elvis_lhs = nextChild($this_0, child_0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var nextChild_0 = tmp;
      var tmp0 = $this_0;
      var tmp1 = state_0;
      var tmp3 = proposedUpdate_0;
      $this_0 = tmp0;
      state_0 = tmp1;
      child_0 = nextChild_0;
      proposedUpdate_0 = tmp3;
      continue $l$0;
    }
     while (false);
  }
   while (true);
}
function continueCompleting($this, state, lastChild, proposedUpdate) {
  // Inline function 'kotlinx.coroutines.assert' call
  var waitChild = nextChild($this, lastChild);
  if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate))
    return Unit_instance;
  state.i25_1.o25(2);
  var waitChildAgain = nextChild($this, lastChild);
  if (!(waitChildAgain == null) && tryWaitForChild($this, state, waitChildAgain, proposedUpdate)) {
    return Unit_instance;
  }
  var finalState = finalizeFinishingState($this, state, proposedUpdate);
  $this.q1x(finalState);
}
function nextChild($this, _this__u8e3s4) {
  var cur = _this__u8e3s4;
  $l$loop: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (!cur.j23_1) {
      break $l$loop;
    }
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.prevNode' call
    cur = cur.i23_1;
  }
  $l$loop_0: while (true) {
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
    cur = cur.h23_1;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
    if (cur.j23_1)
      continue $l$loop_0;
    if (cur instanceof ChildHandleNode)
      return cur;
    if (cur instanceof NodeList)
      return null;
  }
}
function stateString($this, state) {
  var tmp;
  if (state instanceof Finishing) {
    tmp = state.m25() ? 'Cancelling' : state.r25() ? 'Completing' : 'Active';
  } else {
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.g1x() ? 'Active' : 'New';
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
  }
  return tmp;
}
function Finishing(list, isCompleting, rootCause) {
  SynchronizedObject.call(this);
  this.i25_1 = list;
  this.j25_1 = atomic$boolean$1(isCompleting);
  this.k25_1 = atomic$ref$1(rootCause);
  this.l25_1 = atomic$ref$1(null);
}
protoOf(Finishing).g23 = function () {
  return this.i25_1;
};
protoOf(Finishing).v25 = function (value) {
  this.j25_1.kotlinx$atomicfu$value = value;
};
protoOf(Finishing).r25 = function () {
  return this.j25_1.kotlinx$atomicfu$value;
};
protoOf(Finishing).b26 = function (value) {
  this.k25_1.kotlinx$atomicfu$value = value;
};
protoOf(Finishing).u25 = function () {
  return this.k25_1.kotlinx$atomicfu$value;
};
protoOf(Finishing).s25 = function () {
  return _get_exceptionsHolder__nhszp(this) === get_SEALED();
};
protoOf(Finishing).m25 = function () {
  return !(this.u25() == null);
};
protoOf(Finishing).g1x = function () {
  return this.u25() == null;
};
protoOf(Finishing).n25 = function (proposedException) {
  var eh = _get_exceptionsHolder__nhszp(this);
  var tmp;
  if (eh == null) {
    tmp = allocateList(this);
  } else {
    if (eh instanceof Error) {
      // Inline function 'kotlin.also' call
      var this_0 = allocateList(this);
      this_0.j(eh);
      tmp = this_0;
    } else {
      if (eh instanceof ArrayList) {
        tmp = eh instanceof ArrayList ? eh : THROW_CCE();
      } else {
        var message = 'State is ' + toString_0(eh);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  var list = tmp;
  var rootCause = this.u25();
  if (rootCause == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    list.y1(0, rootCause);
  }
  if (!(proposedException == null) && !equals(proposedException, rootCause)) {
    list.j(proposedException);
  }
  _set_exceptionsHolder__tqm22h(this, get_SEALED());
  return list;
};
protoOf(Finishing).t25 = function (exception) {
  var rootCause = this.u25();
  if (rootCause == null) {
    this.b26(exception);
    return Unit_instance;
  }
  if (exception === rootCause)
    return Unit_instance;
  var eh = _get_exceptionsHolder__nhszp(this);
  if (eh == null) {
    _set_exceptionsHolder__tqm22h(this, exception);
  } else {
    if (eh instanceof Error) {
      if (exception === eh)
        return Unit_instance;
      // Inline function 'kotlin.apply' call
      var this_0 = allocateList(this);
      this_0.j(eh);
      this_0.j(exception);
      _set_exceptionsHolder__tqm22h(this, this_0);
    } else {
      if (eh instanceof ArrayList) {
        (eh instanceof ArrayList ? eh : THROW_CCE()).j(exception);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'State is ' + toString_0(eh);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
};
protoOf(Finishing).toString = function () {
  return 'Finishing[cancelling=' + this.m25() + ', completing=' + this.r25() + ', rootCause=' + toString_0(this.u25()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.i25_1.toString() + ']';
};
function ChildCompletion(parent, state, child, proposedUpdate) {
  JobNode.call(this);
  this.g26_1 = parent;
  this.h26_1 = state;
  this.i26_1 = child;
  this.j26_1 = proposedUpdate;
}
protoOf(ChildCompletion).a23 = function () {
  return false;
};
protoOf(ChildCompletion).s20 = function (cause) {
  continueCompleting(this.g26_1, this.h26_1, this.i26_1, this.j26_1);
};
function AwaitContinuation(delegate, job) {
  CancellableContinuationImpl.call(this, delegate, 1);
  this.q26_1 = job;
}
protoOf(AwaitContinuation).d22 = function (parent) {
  var state = this.q26_1.z1x();
  if (state instanceof Finishing) {
    var tmp0_safe_receiver = state.u25();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
  }
  if (state instanceof CompletedExceptionally)
    return state.l1x_1;
  return parent.e1y();
};
protoOf(AwaitContinuation).r22 = function () {
  return 'AwaitContinuation';
};
function awaitSuspend($this, $completion) {
  var cont = new AwaitContinuation(intercepted($completion), $this);
  cont.w21();
  disposeOnCancellation(cont, invokeOnCompletion($this, VOID, new ResumeAwaitOnCompletion(cont)));
  return cont.e22();
}
function JobSupport(active) {
  this.z1w_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
  this.a1x_1 = atomic$ref$1(null);
}
protoOf(JobSupport).v = function () {
  return Key_instance_3;
};
protoOf(JobSupport).x1x = function (value) {
  this.a1x_1.kotlinx$atomicfu$value = value;
};
protoOf(JobSupport).y1x = function () {
  return this.a1x_1.kotlinx$atomicfu$value;
};
protoOf(JobSupport).b1x = function (parent) {
  // Inline function 'kotlinx.coroutines.assert' call
  if (parent == null) {
    this.x1x(NonDisposableHandle_instance);
    return Unit_instance;
  }
  parent.c1y();
  var handle = parent.w1y(this);
  this.x1x(handle);
  if (this.a1y()) {
    handle.t20();
    this.x1x(NonDisposableHandle_instance);
  }
};
protoOf(JobSupport).z1x = function () {
  return this.z1w_1.kotlinx$atomicfu$value;
};
protoOf(JobSupport).g1x = function () {
  var state = this.z1x();
  var tmp;
  if (!(state == null) ? isInterface(state, Incomplete) : false) {
    tmp = state.g1x();
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(JobSupport).a1y = function () {
  var tmp = this.z1x();
  return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
};
protoOf(JobSupport).b1y = function () {
  var state = this.z1x();
  var tmp;
  if (state instanceof CompletedExceptionally) {
    tmp = true;
  } else {
    var tmp_0;
    if (state instanceof Finishing) {
      tmp_0 = state.m25();
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(JobSupport).c1y = function () {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = this.z1x();
    var tmp0_subject = startInternal(this, state);
    if (tmp0_subject === 0)
      return false;
    else if (tmp0_subject === 1)
      return true;
  }
};
protoOf(JobSupport).d1y = function () {
};
protoOf(JobSupport).e1y = function () {
  var state = this.z1x();
  var tmp;
  if (state instanceof Finishing) {
    var tmp0_safe_receiver = state.u25();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.f1y(tmp0_safe_receiver, get_classSimpleName(this) + ' is cancelling');
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message = 'Job is still new or active: ' + this.toString();
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    tmp = tmp_0;
  } else {
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      var message_0 = 'Job is still new or active: ' + this.toString();
      throw IllegalStateException_init_$Create$(toString(message_0));
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = this.g1y(state.l1x_1);
      } else {
        tmp = new JobCancellationException(get_classSimpleName(this) + ' has completed normally', null, this);
      }
    }
  }
  return tmp;
};
protoOf(JobSupport).f1y = function (_this__u8e3s4, message) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
    tmp = new JobCancellationException(message == null ? this.j1x() : message, _this__u8e3s4, this);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(JobSupport).g1y = function (_this__u8e3s4, message, $super) {
  message = message === VOID ? null : message;
  return $super === VOID ? this.f1y(_this__u8e3s4, message) : $super.f1y.call(this, _this__u8e3s4, message);
};
protoOf(JobSupport).h1y = function (handler) {
  return this.k1y(true, new InvokeOnCompletion(handler));
};
protoOf(JobSupport).i1y = function (onCancelling, invokeImmediately, handler) {
  var tmp;
  if (onCancelling) {
    tmp = new InvokeOnCancelling(handler);
  } else {
    tmp = new InvokeOnCompletion(handler);
  }
  return this.k1y(invokeImmediately, tmp);
};
protoOf(JobSupport).k1y = function (invokeImmediately, node) {
  node.e23_1 = this;
  var tmp$ret$0;
  $l$block_1: {
    // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.z1x();
      if (state instanceof Empty) {
        if (state.q25_1) {
          if (this.z1w_1.atomicfu$compareAndSet(state, node)) {
            tmp$ret$0 = true;
            break $l$block_1;
          }
        } else {
          promoteEmptyToNodeList(this, state);
        }
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var list = state.g23();
          if (list == null) {
            promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
          } else {
            var tmp;
            if (node.a23()) {
              var tmp0_safe_receiver = state instanceof Finishing ? state : null;
              var rootCause = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u25();
              var tmp_0;
              if (rootCause == null) {
                tmp_0 = list.k23(node, 5);
              } else {
                if (invokeImmediately) {
                  node.s20(rootCause);
                }
                return NonDisposableHandle_instance;
              }
              tmp = tmp_0;
            } else {
              tmp = list.k23(node, 1);
            }
            if (tmp) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
          }
        } else {
          tmp$ret$0 = false;
          break $l$block_1;
        }
      }
    }
  }
  var added = tmp$ret$0;
  if (added)
    return node;
  else if (invokeImmediately) {
    var tmp_1 = this.z1x();
    var tmp0_safe_receiver_0 = tmp_1 instanceof CompletedExceptionally ? tmp_1 : null;
    node.s20(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.l1x_1);
  }
  return NonDisposableHandle_instance;
};
protoOf(JobSupport).l1y = function ($completion) {
  if (!joinInternal(this)) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.j8();
    ensureActive(tmp$ret$0);
    return Unit_instance;
  }
  return joinSuspend(this, $completion);
};
protoOf(JobSupport).m1y = function (node) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var state = this.z1x();
    if (state instanceof JobNode) {
      if (!(state === node))
        return Unit_instance;
      if (this.z1w_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
        return Unit_instance;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        if (!(state.g23() == null)) {
          node.l23();
        }
        return Unit_instance;
      } else {
        return Unit_instance;
      }
    }
  }
};
protoOf(JobSupport).n1y = function () {
  return false;
};
protoOf(JobSupport).o1y = function (cause) {
  var tmp;
  if (cause == null) {
    // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
    tmp = new JobCancellationException(null == null ? this.j1x() : null, null, this);
  } else {
    tmp = cause;
  }
  this.q1y(tmp);
};
protoOf(JobSupport).j1x = function () {
  return 'Job was cancelled';
};
protoOf(JobSupport).q1y = function (cause) {
  this.u1y(cause);
};
protoOf(JobSupport).r1y = function (parentJob) {
  this.u1y(parentJob);
};
protoOf(JobSupport).s1y = function (cause) {
  if (cause instanceof CancellationException)
    return true;
  return this.u1y(cause) && this.z1y();
};
protoOf(JobSupport).t1y = function (cause) {
  return this.u1y(cause);
};
protoOf(JobSupport).u1y = function (cause) {
  var finalState = get_COMPLETING_ALREADY();
  if (this.n1y()) {
    finalState = cancelMakeCompleting(this, cause);
    if (finalState === get_COMPLETING_WAITING_CHILDREN())
      return true;
  }
  if (finalState === get_COMPLETING_ALREADY()) {
    finalState = makeCancelling(this, cause);
  }
  var tmp;
  if (finalState === get_COMPLETING_ALREADY()) {
    tmp = true;
  } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
    tmp = true;
  } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
    tmp = false;
  } else {
    this.q1x(finalState);
    tmp = true;
  }
  return tmp;
};
protoOf(JobSupport).v1y = function () {
  var state = this.z1x();
  var tmp;
  if (state instanceof Finishing) {
    tmp = state.u25();
  } else {
    if (state instanceof CompletedExceptionally) {
      tmp = state.l1x_1;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var message = 'Cannot be cancelling child in this state: ' + toString(state);
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp = null;
      }
    }
  }
  var rootCause = tmp;
  var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
  return tmp1_elvis_lhs == null ? new JobCancellationException('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
};
protoOf(JobSupport).z23 = function (proposedUpdate) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp0 = this.z1x();
    $l$block: {
      var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
      if (finalState === get_COMPLETING_ALREADY())
        return false;
      else if (finalState === get_COMPLETING_WAITING_CHILDREN())
        return true;
      else if (finalState === get_COMPLETING_RETRY()) {
        break $l$block;
      } else {
        this.q1x(finalState);
        return true;
      }
    }
  }
};
protoOf(JobSupport).o1x = function (proposedUpdate) {
  // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
  while (true) {
    var tmp0 = this.z1x();
    $l$block: {
      var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
      if (finalState === get_COMPLETING_ALREADY())
        throw IllegalStateException_init_$Create$_0('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(this, proposedUpdate));
      else if (finalState === get_COMPLETING_RETRY()) {
        break $l$block;
      } else
        return finalState;
    }
  }
};
protoOf(JobSupport).w1y = function (child) {
  // Inline function 'kotlin.also' call
  var this_0 = new ChildHandleNode(child);
  this_0.e23_1 = this;
  var node = this_0;
  var tmp$ret$2;
  $l$block_1: {
    // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.z1x();
      if (state instanceof Empty) {
        if (state.q25_1) {
          if (this.z1w_1.atomicfu$compareAndSet(state, node)) {
            tmp$ret$2 = true;
            break $l$block_1;
          }
        } else {
          promoteEmptyToNodeList(this, state);
        }
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var list = state.g23();
          if (list == null) {
            promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
          } else {
            var addedBeforeCancellation = list.k23(node, 7);
            var tmp;
            if (addedBeforeCancellation) {
              tmp = true;
            } else {
              var addedBeforeCompletion = list.k23(node, 3);
              var latestState = this.z1x();
              var tmp_0;
              if (latestState instanceof Finishing) {
                tmp_0 = latestState.u25();
              } else {
                // Inline function 'kotlinx.coroutines.assert' call
                var tmp0_safe_receiver = latestState instanceof CompletedExceptionally ? latestState : null;
                tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l1x_1;
              }
              var rootCause = tmp_0;
              node.s20(rootCause);
              var tmp_1;
              if (addedBeforeCompletion) {
                // Inline function 'kotlinx.coroutines.assert' call
                tmp_1 = true;
              } else {
                return NonDisposableHandle_instance;
              }
              tmp = tmp_1;
            }
            if (tmp) {
              tmp$ret$2 = true;
              break $l$block_1;
            }
          }
        } else {
          tmp$ret$2 = false;
          break $l$block_1;
        }
      }
    }
  }
  var added = tmp$ret$2;
  if (added)
    return node;
  var tmp_2 = this.z1x();
  var tmp0_safe_receiver_0 = tmp_2 instanceof CompletedExceptionally ? tmp_2 : null;
  node.s20(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.l1x_1);
  return NonDisposableHandle_instance;
};
protoOf(JobSupport).r1x = function (exception) {
  throw exception;
};
protoOf(JobSupport).x1y = function (cause) {
};
protoOf(JobSupport).y1y = function () {
  return false;
};
protoOf(JobSupport).z1y = function () {
  return true;
};
protoOf(JobSupport).a1z = function (exception) {
  return false;
};
protoOf(JobSupport).k1x = function (state) {
};
protoOf(JobSupport).q1x = function (state) {
};
protoOf(JobSupport).toString = function () {
  return this.b1z() + '@' + get_hexAddress(this);
};
protoOf(JobSupport).b1z = function () {
  return this.s1x() + '{' + stateString(this, this.z1x()) + '}';
};
protoOf(JobSupport).s1x = function () {
  return get_classSimpleName(this);
};
protoOf(JobSupport).c1z = function () {
  var state = this.z1x();
  // Inline function 'kotlin.check' call
  if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
    var message = 'This job has not completed yet';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  return _get_exceptionOrNull__b3j7js(this, state);
};
protoOf(JobSupport).d1z = function () {
  var state = this.z1x();
  // Inline function 'kotlin.check' call
  if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
    var message = 'This job has not completed yet';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  if (state instanceof CompletedExceptionally)
    throw state.l1x_1;
  return unboxState(state);
};
protoOf(JobSupport).e1z = function ($completion) {
  $l$loop: while (true) {
    var state = this.z1x();
    if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      if (state instanceof CompletedExceptionally) {
        // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
        throw state.l1x_1;
      }
      return unboxState(state);
    }
    if (startInternal(this, state) >= 0)
      break $l$loop;
  }
  return awaitSuspend(this, $completion);
};
function handlesExceptionF($this) {
  var tmp = $this.y1x();
  var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f23();
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parentJob = tmp_0;
  while (true) {
    if (parentJob.z1y())
      return true;
    var tmp_1 = parentJob.y1x();
    var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.f23();
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      return false;
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    parentJob = tmp_2;
  }
}
function JobImpl(parent) {
  JobSupport.call(this, true);
  this.b1x(parent);
  this.t26_1 = handlesExceptionF(this);
}
protoOf(JobImpl).n1y = function () {
  return true;
};
protoOf(JobImpl).z1y = function () {
  return this.t26_1;
};
protoOf(JobImpl).b24 = function () {
  return this.z23(Unit_instance);
};
protoOf(JobImpl).a24 = function (exception) {
  return this.z23(new CompletedExceptionally(exception));
};
function Empty(isActive) {
  this.q25_1 = isActive;
}
protoOf(Empty).g1x = function () {
  return this.q25_1;
};
protoOf(Empty).g23 = function () {
  return null;
};
protoOf(Empty).toString = function () {
  return 'Empty{' + (this.q25_1 ? 'Active' : 'New') + '}';
};
function Incomplete() {
}
function NodeList() {
  LockFreeLinkedListHead.call(this);
}
protoOf(NodeList).g1x = function () {
  return true;
};
protoOf(NodeList).g23 = function () {
  return this;
};
protoOf(NodeList).x26 = function (state) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.k7('List{');
  this_0.k7(state);
  this_0.k7('}[');
  var first = true;
  // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
  var cur = this.h23_1;
  while (!equals(cur, this)) {
    var node = cur;
    if (node instanceof JobNode) {
      if (first) {
        first = false;
      } else
        this_0.k7(', ');
      this_0.j7(node);
    }
    cur = cur.h23_1;
  }
  this_0.k7(']');
  return this_0.toString();
};
protoOf(NodeList).toString = function () {
  return get_DEBUG() ? this.x26('Active') : protoOf(LockFreeLinkedListHead).toString.call(this);
};
function IncompleteStateBox(state) {
  this.h25_1 = state;
}
function boxIncomplete(_this__u8e3s4) {
  _init_properties_JobSupport_kt__68f172();
  var tmp;
  if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete) : false) {
    tmp = new IncompleteStateBox(_this__u8e3s4);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function InactiveNodeList(list) {
  this.p25_1 = list;
}
protoOf(InactiveNodeList).g23 = function () {
  return this.p25_1;
};
protoOf(InactiveNodeList).g1x = function () {
  return false;
};
protoOf(InactiveNodeList).toString = function () {
  return get_DEBUG() ? this.p25_1.x26('New') : anyToString(this);
};
function InvokeOnCompletion(handler) {
  JobNode.call(this);
  this.c27_1 = handler;
}
protoOf(InvokeOnCompletion).a23 = function () {
  return false;
};
protoOf(InvokeOnCompletion).s20 = function (cause) {
  return this.c27_1(cause);
};
function InvokeOnCancelling(handler) {
  JobNode.call(this);
  this.h27_1 = handler;
  this.i27_1 = atomic$boolean$1(false);
}
protoOf(InvokeOnCancelling).a23 = function () {
  return true;
};
protoOf(InvokeOnCancelling).s20 = function (cause) {
  if (this.i27_1.atomicfu$compareAndSet(false, true))
    this.h27_1(cause);
};
function ResumeOnCompletion(continuation) {
  JobNode.call(this);
  this.n27_1 = continuation;
}
protoOf(ResumeOnCompletion).a23 = function () {
  return false;
};
protoOf(ResumeOnCompletion).s20 = function (cause) {
  // Inline function 'kotlin.coroutines.resume' call
  var this_0 = this.n27_1;
  // Inline function 'kotlin.Companion.success' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
  this_0.o8(tmp$ret$0);
  return Unit_instance;
};
function ChildHandleNode(childJob) {
  JobNode.call(this);
  this.a26_1 = childJob;
}
protoOf(ChildHandleNode).a23 = function () {
  return true;
};
protoOf(ChildHandleNode).s20 = function (cause) {
  return this.a26_1.r1y(this.f23());
};
protoOf(ChildHandleNode).s1y = function (cause) {
  return this.f23().s1y(cause);
};
function ResumeAwaitOnCompletion(continuation) {
  JobNode.call(this);
  this.s27_1 = continuation;
}
protoOf(ResumeAwaitOnCompletion).a23 = function () {
  return false;
};
protoOf(ResumeAwaitOnCompletion).s20 = function (cause) {
  var state = this.f23().z1x();
  // Inline function 'kotlinx.coroutines.assert' call
  if (state instanceof CompletedExceptionally) {
    var tmp0 = this.s27_1;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = state.l1x_1;
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.o8(tmp$ret$1);
  } else {
    var tmp0_0 = this.s27_1;
    var tmp = unboxState(state);
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    var tmp$ret$3 = _Result___init__impl__xyqfz8(value);
    tmp0_0.o8(tmp$ret$3);
  }
};
var properties_initialized_JobSupport_kt_5iq8a4;
function _init_properties_JobSupport_kt__68f172() {
  if (!properties_initialized_JobSupport_kt_5iq8a4) {
    properties_initialized_JobSupport_kt_5iq8a4 = true;
    COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
    COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
    COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
    TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
    SEALED = new Symbol('SEALED');
    EMPTY_NEW = new Empty(false);
    EMPTY_ACTIVE = new Empty(true);
  }
}
function MainCoroutineDispatcher() {
  CoroutineDispatcher.call(this);
}
protoOf(MainCoroutineDispatcher).toString = function () {
  var tmp0_elvis_lhs = this.v27();
  return tmp0_elvis_lhs == null ? get_classSimpleName(this) + '@' + get_hexAddress(this) : tmp0_elvis_lhs;
};
protoOf(MainCoroutineDispatcher).v27 = function () {
  var main = Dispatchers_getInstance().o24();
  if (this === main)
    return 'Dispatchers.Main';
  var tmp;
  try {
    tmp = main.u27();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof UnsupportedOperationException) {
      var e = $p;
      tmp_0 = null;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  var immediate = tmp;
  if (this === immediate)
    return 'Dispatchers.Main.immediate';
  return null;
};
function SupervisorJob(parent) {
  parent = parent === VOID ? null : parent;
  return new SupervisorJobImpl(parent);
}
function SupervisorJobImpl(parent) {
  JobImpl.call(this, parent);
}
protoOf(SupervisorJobImpl).s1y = function (cause) {
  return false;
};
function TimeoutCancellationException() {
}
function Unconfined() {
  Unconfined_instance = this;
  CoroutineDispatcher.call(this);
}
protoOf(Unconfined).d24 = function (context) {
  return false;
};
protoOf(Unconfined).e24 = function (context, block) {
  var yieldContext = context.q8(Key_instance_4);
  if (!(yieldContext == null)) {
    yieldContext.b28_1 = true;
    return Unit_instance;
  }
  throw UnsupportedOperationException_init_$Create$('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
};
protoOf(Unconfined).toString = function () {
  return 'Dispatchers.Unconfined';
};
var Unconfined_instance;
function Unconfined_getInstance() {
  if (Unconfined_instance == null)
    new Unconfined();
  return Unconfined_instance;
}
function Key_3() {
}
var Key_instance_4;
function Key_getInstance_3() {
  return Key_instance_4;
}
function Waiter() {
}
var BufferOverflow_SUSPEND_instance;
var BufferOverflow_DROP_OLDEST_instance;
var BufferOverflow_DROP_LATEST_instance;
var BufferOverflow_entriesInitialized;
function BufferOverflow_initEntries() {
  if (BufferOverflow_entriesInitialized)
    return Unit_instance;
  BufferOverflow_entriesInitialized = true;
  BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
  BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
  BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
}
function BufferOverflow(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function BufferOverflow_SUSPEND_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_SUSPEND_instance;
}
function BufferOverflow_DROP_OLDEST_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_DROP_OLDEST_instance;
}
function BufferOverflow_DROP_LATEST_getInstance() {
  BufferOverflow_initEntries();
  return BufferOverflow_DROP_LATEST_instance;
}
function get_NULL_SEGMENT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NULL_SEGMENT;
}
var NULL_SEGMENT;
function get_SEGMENT_SIZE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SEGMENT_SIZE;
}
var SEGMENT_SIZE;
function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
}
var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
function get_BUFFERED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return BUFFERED;
}
var BUFFERED;
function get_IN_BUFFER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return IN_BUFFER;
}
var IN_BUFFER;
function get_RESUMING_BY_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_RCV;
}
var RESUMING_BY_RCV;
function get_RESUMING_BY_EB() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return RESUMING_BY_EB;
}
var RESUMING_BY_EB;
function get_POISONED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return POISONED;
}
var POISONED;
function get_DONE_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return DONE_RCV;
}
var DONE_RCV;
function get_INTERRUPTED_SEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_SEND;
}
var INTERRUPTED_SEND;
function get_INTERRUPTED_RCV() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return INTERRUPTED_RCV;
}
var INTERRUPTED_RCV;
function get_CHANNEL_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CHANNEL_CLOSED;
}
var CHANNEL_CLOSED;
function get_SUSPEND() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND;
}
var SUSPEND;
function get_SUSPEND_NO_WAITER() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return SUSPEND_NO_WAITER;
}
var SUSPEND_NO_WAITER;
function get_FAILED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return FAILED;
}
var FAILED;
function get_NO_RECEIVE_RESULT() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_RECEIVE_RESULT;
}
var NO_RECEIVE_RESULT;
function get_CLOSE_HANDLER_CLOSED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_CLOSED;
}
var CLOSE_HANDLER_CLOSED;
function get_CLOSE_HANDLER_INVOKED() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return CLOSE_HANDLER_INVOKED;
}
var CLOSE_HANDLER_INVOKED;
function get_NO_CLOSE_CAUSE() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return NO_CLOSE_CAUSE;
}
var NO_CLOSE_CAUSE;
function setElementLazy($this, index, value) {
  // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
  $this.h28_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
}
function ChannelSegment(id, prev, channel, pointers) {
  Segment.call(this, id, prev, pointers);
  this.g28_1 = channel;
  this.h28_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
}
protoOf(ChannelSegment).i28 = function () {
  return ensureNotNull(this.g28_1);
};
protoOf(ChannelSegment).j28 = function () {
  return get_SEGMENT_SIZE();
};
protoOf(ChannelSegment).k28 = function (index, element) {
  setElementLazy(this, index, element);
};
protoOf(ChannelSegment).l28 = function (index) {
  var tmp = this.h28_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(ChannelSegment).m28 = function (index) {
  // Inline function 'kotlin.also' call
  var this_0 = this.l28(index);
  this.n28(index);
  return this_0;
};
protoOf(ChannelSegment).n28 = function (index) {
  setElementLazy(this, index, null);
};
protoOf(ChannelSegment).o28 = function (index) {
  return this.h28_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
};
protoOf(ChannelSegment).p28 = function (index, value) {
  this.h28_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
};
protoOf(ChannelSegment).q28 = function (index, from, to) {
  return this.h28_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
};
protoOf(ChannelSegment).r28 = function (index, update) {
  return this.h28_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
};
protoOf(ChannelSegment).k21 = function (index, cause, context) {
  var isSender = index >= get_SEGMENT_SIZE();
  var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
  var element = this.l28(index_0);
  $l$loop: while (true) {
    var cur = this.o28(index_0);
    var tmp;
    if (!(cur == null) ? isInterface(cur, Waiter) : false) {
      tmp = true;
    } else {
      tmp = cur instanceof WaiterEB;
    }
    if (tmp) {
      var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
      if (this.q28(index_0, cur, update)) {
        this.n28(index_0);
        this.e29(index_0, !isSender);
        if (isSender) {
          var tmp0_safe_receiver = this.i28().t28_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            callUndeliveredElement(tmp0_safe_receiver, element, context);
          }
        }
        return Unit_instance;
      }
    } else {
      if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
        this.n28(index_0);
        if (isSender) {
          var tmp1_safe_receiver = this.i28().t28_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            callUndeliveredElement(tmp1_safe_receiver, element, context);
          }
        }
        return Unit_instance;
      } else {
        if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV())
          continue $l$loop;
        else {
          if (cur === get_DONE_RCV() || cur === get_BUFFERED())
            return Unit_instance;
          else {
            if (cur === get_CHANNEL_CLOSED())
              return Unit_instance;
            else {
              // Inline function 'kotlin.error' call
              var message = 'unexpected state: ' + toString_0(cur);
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
      }
    }
  }
};
protoOf(ChannelSegment).e29 = function (index, receiver) {
  if (receiver) {
    var tmp = this.i28();
    var tmp0 = this.i21_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    // Inline function 'kotlin.Long.plus' call
    var this_0 = multiply(tmp0, fromInt(other));
    var tmp$ret$1 = add(this_0, fromInt(index));
    tmp.f29(tmp$ret$1);
  }
  this.g29();
};
function onClosedHasNext($this) {
  $this.s29_1 = get_CHANNEL_CLOSED();
  var tmp0_elvis_lhs = $this.u29_1.v29();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var cause = tmp;
  throw recoverStackTrace_0(cause);
}
function hasNextOnNoWaiterSuspend($this, segment, index, r, $completion) {
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    $this.t29_1 = cancellable;
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
    var this_0 = $this.u29_1;
    var updCellResult = updateCellReceive(this_0, segment, index, r, $this);
    if (updCellResult === get_SUSPEND()) {
      prepareReceiverForSuspension(this_0, $this, segment, index);
    } else if (updCellResult === get_FAILED()) {
      if (r < this_0.w29()) {
        segment.q29();
      }
      $l$block_0: {
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
        var segment_0 = this_0.z28_1.kotlinx$atomicfu$value;
        $l$loop_0: while (true) {
          if (this_0.x29()) {
            onClosedHasNextNoWaiterSuspend($this);
            break $l$block_0;
          }
          var r_0 = this_0.v28_1.atomicfu$getAndIncrement$long();
          // Inline function 'kotlin.Long.div' call
          var other = get_SEGMENT_SIZE();
          var id = divide(r_0, fromInt(other));
          // Inline function 'kotlin.Long.rem' call
          var other_0 = get_SEGMENT_SIZE();
          var tmp$ret$3 = modulo(r_0, fromInt(other_0));
          var i = convertToInt(tmp$ret$3);
          if (!(segment_0.i21_1 === id)) {
            var tmp0_elvis_lhs = findSegmentReceive(this_0, id, segment_0);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            segment_0 = tmp;
          }
          var updCellResult_0 = updateCellReceive(this_0, segment_0, i, r_0, $this);
          if (updCellResult_0 === get_SUSPEND()) {
            var tmp1_safe_receiver = (!($this == null) ? isInterface($this, Waiter) : false) ? $this : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              prepareReceiverForSuspension(this_0, tmp1_safe_receiver, segment_0, i);
            }
          } else if (updCellResult_0 === get_FAILED()) {
            if (r_0 < this_0.w29()) {
              segment_0.q29();
            }
            continue $l$loop_0;
          } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
            // Inline function 'kotlin.error' call
            var message = 'unexpected';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            segment_0.q29();
            var element = (updCellResult_0 == null ? true : !(updCellResult_0 == null)) ? updCellResult_0 : THROW_CCE();
            $this.s29_1 = element;
            $this.t29_1 = null;
            var tmp0_safe_receiver = $this.u29_1.t28_1;
            cancellable.j20(true, tmp0_safe_receiver == null ? null : bindCancellationFun($this.u29_1, tmp0_safe_receiver, element));
          }
          break $l$block_0;
        }
      }
    } else {
      segment.q29();
      var element_0 = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
      $this.s29_1 = element_0;
      $this.t29_1 = null;
      var tmp0_safe_receiver_0 = $this.u29_1.t28_1;
      cancellable.j20(true, tmp0_safe_receiver_0 == null ? null : bindCancellationFun($this.u29_1, tmp0_safe_receiver_0, element_0));
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.f22();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.e22();
}
function onClosedHasNextNoWaiterSuspend($this) {
  var cont = ensureNotNull($this.t29_1);
  $this.t29_1 = null;
  $this.s29_1 = get_CHANNEL_CLOSED();
  var cause = $this.u29_1.v29();
  if (cause == null) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
    cont.o8(tmp$ret$0);
  } else {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace(cause, cont);
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.o8(tmp$ret$2);
  }
}
function $hasNextCOROUTINE$(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.g2a_1 = _this__u8e3s4;
}
protoOf($hasNextCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 8;
          if (!(this.g2a_1.s29_1 === get_NO_RECEIVE_RESULT()) && !(this.g2a_1.s29_1 === get_CHANNEL_CLOSED())) {
            var tmp_0 = this;
            tmp_0.h2a_1 = true;
            this.d8_1 = 11;
            continue $sm;
          } else {
            var tmp_1 = this;
            tmp_1.r2a_1 = this.g2a_1.u29_1;
            var tmp_2 = this;
            tmp_2.q2a_1 = null;
            this.d8_1 = 1;
            continue $sm;
          }

        case 1:
          this.n2a_1 = this.r2a_1;
          this.o2a_1 = this.q2a_1;
          this.k2a_1 = this.n2a_1.z28_1.kotlinx$atomicfu$value;
          this.d8_1 = 2;
          continue $sm;
        case 2:
          if (!true) {
            this.d8_1 = 9;
            continue $sm;
          }

          if (this.n2a_1.x29()) {
            var tmp_3 = this;
            tmp_3.i2a_1 = onClosedHasNext(this.g2a_1);
            this.d8_1 = 10;
            continue $sm;
          } else {
            this.d8_1 = 3;
            continue $sm;
          }

        case 3:
          this.l2a_1 = this.n2a_1.v28_1.atomicfu$getAndIncrement$long();
          var tmp0 = this.l2a_1;
          var other = get_SEGMENT_SIZE();
          var id = divide(tmp0, fromInt(other));
          var tmp_4 = this;
          var tmp0_0 = this.l2a_1;
          var other_0 = get_SEGMENT_SIZE();
          tmp_4.m2a_1 = convertToInt(modulo(tmp0_0, fromInt(other_0)));
          if (!(this.k2a_1.i21_1 === id)) {
            var tmp0_elvis_lhs = findSegmentReceive(this.n2a_1, id, this.k2a_1);
            if (tmp0_elvis_lhs == null) {
              this.d8_1 = 2;
              var tmp_5 = this;
              continue $sm;
            } else {
              this.p2a_1 = tmp0_elvis_lhs;
              this.d8_1 = 4;
              continue $sm;
            }
          } else {
            this.d8_1 = 5;
            continue $sm;
          }

        case 4:
          this.k2a_1 = this.p2a_1;
          this.d8_1 = 5;
          continue $sm;
        case 5:
          var updCellResult = updateCellReceive(this.n2a_1, this.k2a_1, this.m2a_1, this.l2a_1, this.o2a_1);
          if (updCellResult === get_SUSPEND()) {
            var tmp_6 = this;
            var tmp_7 = this.o2a_1;
            var tmp1_safe_receiver = (!(tmp_7 == null) ? isInterface(tmp_7, Waiter) : false) ? tmp_7 : null;
            if (tmp1_safe_receiver == null)
              null;
            else {
              prepareReceiverForSuspension(this.n2a_1, tmp1_safe_receiver, this.k2a_1, this.m2a_1);
            }
            this.k2a_1;
            this.m2a_1;
            this.l2a_1;
            var message = 'unreachable';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            if (updCellResult === get_FAILED()) {
              if (this.l2a_1 < this.n2a_1.w29()) {
                this.k2a_1.q29();
              }
              this.d8_1 = 2;
              var tmp_8 = this;
              continue $sm;
            } else {
              if (updCellResult === get_SUSPEND_NO_WAITER()) {
                var tmp0_1 = this.k2a_1;
                var tmp2 = this.m2a_1;
                var r = this.l2a_1;
                this.d8_1 = 6;
                suspendResult = hasNextOnNoWaiterSuspend(this.g2a_1, tmp0_1, tmp2, r, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_9 = this;
                this.k2a_1.q29();
                var element = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
                this.g2a_1.s29_1 = element;
                tmp_9.j2a_1 = true;
                this.d8_1 = 7;
                continue $sm;
              }
            }
          }

        case 6:
          var tmp_10 = this;
          return suspendResult;
        case 7:
          this.i2a_1 = this.j2a_1;
          this.d8_1 = 10;
          continue $sm;
        case 8:
          throw this.g8_1;
        case 9:
          if (false) {
            this.d8_1 = 1;
            continue $sm;
          }

          this.d8_1 = 10;
          continue $sm;
        case 10:
          this.h2a_1 = this.i2a_1;
          this.d8_1 = 11;
          continue $sm;
        case 11:
          return this.h2a_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 8) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function _get_bufferEndCounter__2d4hee($this) {
  return $this.w28_1.kotlinx$atomicfu$value;
}
function _get_isRendezvousOrUnlimited__3mdufi($this) {
  // Inline function 'kotlin.let' call
  var it = _get_bufferEndCounter__2d4hee($this);
  return it === 0n || it === 9223372036854775807n;
}
function onClosedSend($this, element, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.w21();
  $l$block: {
    var tmp0_safe_receiver = $this.t28_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      addSuppressed(tmp1_safe_receiver, $this.s2a());
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(tmp1_safe_receiver, cancellable);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      cancellable.o8(tmp$ret$0);
      break $l$block;
    }
    // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
    var exception_0 = $this.s2a();
    // Inline function 'kotlin.Companion.failure' call
    var exception_1 = recoverStackTrace(exception_0, cancellable);
    var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(exception_1));
    cancellable.o8(tmp$ret$4);
  }
  return cancellable.e22();
}
function sendOnNoWaiterSuspend($this, segment, index, element, s, $completion) {
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter' call
    switch (updateCellSend($this, segment, index, element, s, cancellable, false)) {
      case 0:
        segment.q29();
        // Inline function 'kotlin.coroutines.resume' call

        // Inline function 'kotlin.Companion.success' call

        var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.o8(tmp$ret$0);
        break;
      case 1:
        // Inline function 'kotlin.coroutines.resume' call

        // Inline function 'kotlin.Companion.success' call

        var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.o8(tmp$ret$3);
        break;
      case 2:
        prepareSenderForSuspension($this, cancellable, segment, index);
        break;
      case 4:
        if (s < $this.t2a()) {
          segment.q29();
        }

        onClosedSendOnNoWaiterSuspend($this, element, cancellable);
        break;
      case 5:
        segment.q29();
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
          var segment_0 = $this.y28_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            var sendersAndCloseStatusCur = $this.u28_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
            var s_0 = sendersAndCloseStatusCur & 1152921504606846975n;
            var closed = _get_isClosedForSend0__kxgf9m($this, sendersAndCloseStatusCur);
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(s_0, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$9 = modulo(s_0, fromInt(other_0));
            var i = convertToInt(tmp$ret$9);
            if (!(segment_0.i21_1 === id)) {
              var tmp0_elvis_lhs = findSegmentSend($this, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                var tmp_0;
                if (closed) {
                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                } else {
                  continue $l$loop_0;
                }
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            switch (updateCellSend($this, segment_0, i, element, s_0, cancellable, closed)) {
              case 0:
                segment_0.q29();
                // Inline function 'kotlin.coroutines.resume' call

                // Inline function 'kotlin.Companion.success' call

                var tmp$ret$12 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.o8(tmp$ret$12);
                break $l$block_5;
              case 1:
                // Inline function 'kotlin.coroutines.resume' call

                // Inline function 'kotlin.Companion.success' call

                var tmp$ret$15 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.o8(tmp$ret$15);
                break $l$block_5;
              case 2:
                if (closed) {
                  segment_0.g29();
                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                }

                var tmp2_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  prepareSenderForSuspension($this, tmp2_safe_receiver, segment_0, i);
                }

                break $l$block_5;
              case 4:
                if (s_0 < $this.t2a()) {
                  segment_0.q29();
                }

                onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                break $l$block_5;
              case 5:
                segment_0.q29();
                continue $l$loop_0;
              case 3:
                // Inline function 'kotlin.error' call

                var message = 'unexpected';
                throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }

        break;
      default:
        // Inline function 'kotlin.error' call

        var message_0 = 'unexpected';
        throw IllegalStateException_init_$Create$(toString(message_0));
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.f22();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.e22();
}
function prepareSenderForSuspension($this, _this__u8e3s4, segment, index) {
  _this__u8e3s4.l22(segment, index + get_SEGMENT_SIZE() | 0);
}
function onClosedSendOnNoWaiterSuspend($this, element, cont) {
  var tmp0_safe_receiver = $this.t28_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    callUndeliveredElement(tmp0_safe_receiver, element, cont.j8());
  }
  // Inline function 'kotlin.coroutines.resumeWithException' call
  // Inline function 'kotlin.Companion.failure' call
  var exception = recoverStackTrace($this.s2a(), cont);
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
  cont.o8(tmp$ret$0);
}
function SendBroadcast() {
}
function updateCellSend($this, segment, index, element, s, waiter, closed) {
  segment.k28(index, element);
  if (closed)
    return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
  var state = segment.o28(index);
  if (state === null) {
    if (bufferOrRendezvousSend($this, s)) {
      if (segment.q28(index, null, get_BUFFERED())) {
        return 1;
      }
    } else {
      if (waiter == null) {
        return 3;
      } else {
        if (segment.q28(index, null, waiter))
          return 2;
      }
    }
  } else {
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      segment.n28(index);
      var tmp;
      if (tryResumeReceiver($this, state, element)) {
        segment.p28(index, get_DONE_RCV());
        $this.u2a();
        tmp = 0;
      } else {
        if (!(segment.r28(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.e29(index, true);
        }
        tmp = 5;
      }
      return tmp;
    }
  }
  return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
}
function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
  while (true) {
    var state = segment.o28(index);
    if (state === null) {
      if (bufferOrRendezvousSend($this, s) && !closed) {
        if (segment.q28(index, null, get_BUFFERED())) {
          return 1;
        }
      } else {
        if (closed) {
          if (segment.q28(index, null, get_INTERRUPTED_SEND())) {
            segment.e29(index, false);
            return 4;
          }
        } else if (waiter == null)
          return 3;
        else if (segment.q28(index, null, waiter))
          return 2;
      }
    } else if (state === get_IN_BUFFER()) {
      if (segment.q28(index, state, get_BUFFERED())) {
        return 1;
      }
    } else if (state === get_INTERRUPTED_RCV()) {
      segment.n28(index);
      return 5;
    } else if (state === get_POISONED()) {
      segment.n28(index);
      return 5;
    } else if (state === get_CHANNEL_CLOSED()) {
      segment.n28(index);
      completeCloseOrCancel($this);
      return 4;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      segment.n28(index);
      var tmp;
      if (state instanceof WaiterEB) {
        tmp = state.v2a_1;
      } else {
        tmp = state;
      }
      var receiver = tmp;
      var tmp_0;
      if (tryResumeReceiver($this, receiver, element)) {
        segment.p28(index, get_DONE_RCV());
        $this.u2a();
        tmp_0 = 0;
      } else {
        if (!(segment.r28(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
          segment.e29(index, true);
        }
        tmp_0 = 5;
      }
      return tmp_0;
    }
  }
}
function shouldSendSuspend0($this, curSendersAndCloseStatus) {
  if (_get_isClosedForSend0__kxgf9m($this, curSendersAndCloseStatus))
    return false;
  // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
  var tmp$ret$0 = curSendersAndCloseStatus & 1152921504606846975n;
  return !bufferOrRendezvousSend($this, tmp$ret$0);
}
function bufferOrRendezvousSend($this, curSenders) {
  var tmp;
  if (curSenders < _get_bufferEndCounter__2d4hee($this)) {
    tmp = true;
  } else {
    var tmp0 = $this.t2a();
    // Inline function 'kotlin.Long.plus' call
    var other = $this.s28_1;
    tmp = curSenders < add(tmp0, fromInt(other));
  }
  return tmp;
}
function tryResumeReceiver($this, _this__u8e3s4, element) {
  var tmp;
  if (isInterface(_this__u8e3s4, SelectInstance)) {
    tmp = _this__u8e3s4.a2b($this, element);
  } else {
    if (_this__u8e3s4 instanceof ReceiveCatching) {
      if (!(_this__u8e3s4 instanceof ReceiveCatching))
        THROW_CCE();
      var tmp_0 = Companion_getInstance().y2a(element);
      var tmp1_safe_receiver = $this.t28_1;
      tmp = tryResume0(_this__u8e3s4.z2a_1, new ChannelResult(tmp_0), tmp1_safe_receiver == null ? null : bindCancellationFunResult($this, tmp1_safe_receiver));
    } else {
      if (_this__u8e3s4 instanceof BufferedChannelIterator) {
        if (!(_this__u8e3s4 instanceof BufferedChannelIterator))
          THROW_CCE();
        tmp = _this__u8e3s4.w2a(element);
      } else {
        if (isInterface(_this__u8e3s4, CancellableContinuation)) {
          if (!isInterface(_this__u8e3s4, CancellableContinuation))
            THROW_CCE();
          var tmp2_safe_receiver = $this.t28_1;
          tmp = tryResume0(_this__u8e3s4, element, tmp2_safe_receiver == null ? null : bindCancellationFun_0($this, tmp2_safe_receiver));
        } else {
          var message = 'Unexpected receiver type: ' + toString(_this__u8e3s4);
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
    }
  }
  return tmp;
}
function prepareReceiverForSuspension($this, _this__u8e3s4, segment, index) {
  $this.b2b();
  _this__u8e3s4.l22(segment, index);
}
function updateCellReceive($this, segment, index, r, waiter) {
  var state = segment.o28(index);
  if (state === null) {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var senders = $this.u28_1.kotlinx$atomicfu$value & 1152921504606846975n;
    if (r >= senders) {
      if (waiter === null) {
        return get_SUSPEND_NO_WAITER();
      }
      if (segment.q28(index, state, waiter)) {
        expandBuffer($this);
        return get_SUSPEND();
      }
    }
  } else if (state === get_BUFFERED())
    if (segment.q28(index, state, get_DONE_RCV())) {
      expandBuffer($this);
      return segment.m28(index);
    }
  return updateCellReceiveSlow($this, segment, index, r, waiter);
}
function updateCellReceiveSlow($this, segment, index, r, waiter) {
  $l$loop: while (true) {
    var state = segment.o28(index);
    if (state === null || state === get_IN_BUFFER()) {
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var senders = $this.u28_1.kotlinx$atomicfu$value & 1152921504606846975n;
      if (r < senders) {
        if (segment.q28(index, state, get_POISONED())) {
          expandBuffer($this);
          return get_FAILED();
        }
      } else {
        if (waiter === null) {
          return get_SUSPEND_NO_WAITER();
        }
        if (segment.q28(index, state, waiter)) {
          expandBuffer($this);
          return get_SUSPEND();
        }
      }
    } else if (state === get_BUFFERED()) {
      if (segment.q28(index, state, get_DONE_RCV())) {
        expandBuffer($this);
        return segment.m28(index);
      }
    } else if (state === get_INTERRUPTED_SEND())
      return get_FAILED();
    else if (state === get_POISONED())
      return get_FAILED();
    else if (state === get_CHANNEL_CLOSED()) {
      expandBuffer($this);
      return get_FAILED();
    } else if (state === get_RESUMING_BY_EB())
      continue $l$loop;
    else {
      if (segment.q28(index, state, get_RESUMING_BY_RCV())) {
        var helpExpandBuffer = state instanceof WaiterEB;
        var tmp;
        if (state instanceof WaiterEB) {
          tmp = state.v2a_1;
        } else {
          tmp = state;
        }
        var sender = tmp;
        var tmp_0;
        if (tryResumeSender($this, sender, segment, index)) {
          segment.p28(index, get_DONE_RCV());
          expandBuffer($this);
          tmp_0 = segment.m28(index);
        } else {
          segment.p28(index, get_INTERRUPTED_SEND());
          segment.e29(index, false);
          if (helpExpandBuffer) {
            expandBuffer($this);
          }
          tmp_0 = get_FAILED();
        }
        return tmp_0;
      }
    }
  }
}
function tryResumeSender($this, _this__u8e3s4, segment, index) {
  var tmp;
  if (isInterface(_this__u8e3s4, CancellableContinuation)) {
    if (!isInterface(_this__u8e3s4, CancellableContinuation))
      THROW_CCE();
    tmp = tryResume0(_this__u8e3s4, Unit_instance);
  } else {
    if (isInterface(_this__u8e3s4, SelectInstance)) {
      if (!(_this__u8e3s4 instanceof SelectImplementation))
        THROW_CCE();
      var trySelectResult = _this__u8e3s4.g2b($this, Unit_instance);
      if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) {
        segment.n28(index);
      }
      tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
    } else {
      if (_this__u8e3s4 instanceof SendBroadcast) {
        tmp = tryResume0(_this__u8e3s4.c2b_1, true);
      } else {
        var message = 'Unexpected waiter: ' + toString(_this__u8e3s4);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  return tmp;
}
function expandBuffer($this) {
  if (_get_isRendezvousOrUnlimited__3mdufi($this))
    return Unit_instance;
  var segment = $this.a29_1.kotlinx$atomicfu$value;
  try_again: while (true) {
    var b = $this.w28_1.atomicfu$getAndIncrement$long();
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = divide(b, fromInt(other));
    var s = $this.w29();
    if (s <= b) {
      if (segment.i21_1 < id && !(segment.m29() == null)) {
        moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
      }
      incCompletedExpandBufferAttempts$default($this);
      return Unit_instance;
    }
    if (!(segment.i21_1 === id)) {
      var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue try_again;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var tmp$ret$1 = modulo(b, fromInt(other_0));
    var i = convertToInt(tmp$ret$1);
    if (updateCellExpandBuffer($this, segment, i, b)) {
      incCompletedExpandBufferAttempts$default($this);
      return Unit_instance;
    } else {
      incCompletedExpandBufferAttempts$default($this);
      continue try_again;
    }
  }
}
function updateCellExpandBuffer($this, segment, index, b) {
  var state = segment.o28(index);
  if (!(state == null) ? isInterface(state, Waiter) : false) {
    if (b >= $this.v28_1.kotlinx$atomicfu$value) {
      if (segment.q28(index, state, get_RESUMING_BY_EB())) {
        var tmp;
        if (tryResumeSender($this, state, segment, index)) {
          segment.p28(index, get_BUFFERED());
          tmp = true;
        } else {
          segment.p28(index, get_INTERRUPTED_SEND());
          segment.e29(index, false);
          tmp = false;
        }
        return tmp;
      }
    }
  }
  return updateCellExpandBufferSlow($this, segment, index, b);
}
function updateCellExpandBufferSlow($this, segment, index, b) {
  $l$loop: while (true) {
    var state = segment.o28(index);
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      if (b < $this.v28_1.kotlinx$atomicfu$value) {
        if (segment.q28(index, state, new WaiterEB(state)))
          return true;
      } else {
        if (segment.q28(index, state, get_RESUMING_BY_EB())) {
          var tmp;
          if (tryResumeSender($this, state, segment, index)) {
            segment.p28(index, get_BUFFERED());
            tmp = true;
          } else {
            segment.p28(index, get_INTERRUPTED_SEND());
            segment.e29(index, false);
            tmp = false;
          }
          return tmp;
        }
      }
    } else {
      if (state === get_INTERRUPTED_SEND())
        return false;
      else {
        if (state === null) {
          if (segment.q28(index, state, get_IN_BUFFER()))
            return true;
        } else {
          if (state === get_BUFFERED())
            return true;
          else {
            if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV())
              return true;
            else {
              if (state === get_CHANNEL_CLOSED())
                return true;
              else {
                if (state === get_RESUMING_BY_RCV())
                  continue $l$loop;
                else {
                  // Inline function 'kotlin.error' call
                  var message = 'Unexpected cell state: ' + toString_0(state);
                  throw IllegalStateException_init_$Create$(toString(message));
                }
              }
            }
          }
        }
      }
    }
  }
}
function incCompletedExpandBufferAttempts($this, nAttempts) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
  if (!(($this.x28_1.atomicfu$addAndGet$long(nAttempts) & 4611686018427387904n) === 0n)) {
    $l$loop: while (true) {
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      if (!!(($this.x28_1.kotlinx$atomicfu$value & 4611686018427387904n) === 0n)) {
        break $l$loop;
      }
    }
  }
}
function incCompletedExpandBufferAttempts$default($this, nAttempts, $super) {
  nAttempts = nAttempts === VOID ? 1n : nAttempts;
  return incCompletedExpandBufferAttempts($this, nAttempts);
}
function BufferedChannelIterator($outer) {
  this.u29_1 = $outer;
  this.s29_1 = get_NO_RECEIVE_RESULT();
  this.t29_1 = null;
}
protoOf(BufferedChannelIterator).h2b = function ($completion) {
  var tmp = new $hasNextCOROUTINE$(this, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(BufferedChannelIterator).l22 = function (segment, index) {
  var tmp0_safe_receiver = this.t29_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.l22(segment, index);
  }
};
protoOf(BufferedChannelIterator).n = function () {
  var result = this.s29_1;
  // Inline function 'kotlin.check' call
  if (!!(result === get_NO_RECEIVE_RESULT())) {
    var message = '`hasNext()` has not been invoked';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  this.s29_1 = get_NO_RECEIVE_RESULT();
  if (result === get_CHANNEL_CLOSED())
    throw recoverStackTrace_0(_get_receiveException__foorc1(this.u29_1));
  return (result == null ? true : !(result == null)) ? result : THROW_CCE();
};
protoOf(BufferedChannelIterator).w2a = function (element) {
  var cont = ensureNotNull(this.t29_1);
  this.t29_1 = null;
  this.s29_1 = element;
  var tmp0_safe_receiver = this.u29_1.t28_1;
  return tryResume0(cont, true, tmp0_safe_receiver == null ? null : bindCancellationFun(this.u29_1, tmp0_safe_receiver, element));
};
protoOf(BufferedChannelIterator).i2b = function () {
  var cont = ensureNotNull(this.t29_1);
  this.t29_1 = null;
  this.s29_1 = get_CHANNEL_CLOSED();
  var cause = this.u29_1.v29();
  if (cause == null) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
    cont.o8(tmp$ret$0);
  } else {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace(cause, cont);
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.o8(tmp$ret$2);
  }
};
function _get_receiveException__foorc1($this) {
  var tmp0_elvis_lhs = $this.v29();
  return tmp0_elvis_lhs == null ? new ClosedReceiveChannelException('Channel was closed') : tmp0_elvis_lhs;
}
function invokeCloseHandler($this) {
  var tmp0 = $this.d29_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.getAndUpdate' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      if (cur === null) {
        tmp = get_CLOSE_HANDLER_CLOSED();
      } else {
        tmp = get_CLOSE_HANDLER_INVOKED();
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$1 = cur;
        break $l$block;
      }
    }
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var closeHandler = tmp_0;
  if (typeof closeHandler !== 'function')
    THROW_CCE();
  closeHandler($this.v29());
}
function markClosed($this) {
  var tmp0 = $this.u28_1;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      var tmp;
      switch (convertToInt(shiftRight(cur, 60))) {
        case 0:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$1 = cur & 1152921504606846975n;
          tmp = constructSendersAndCloseStatus(tmp$ret$1, 2);
          break;
        case 1:
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

          var tmp$ret$2 = cur & 1152921504606846975n;
          tmp = constructSendersAndCloseStatus(tmp$ret$2, 3);
          break;
        default:
          return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$4 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$4 = Unit_instance;
  }
  return tmp$ret$4;
}
function markCancelled($this) {
  var tmp0 = $this.u28_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var tmp$ret$0 = cur & 1152921504606846975n;
      var upd = constructSendersAndCloseStatus(tmp$ret$0, 3);
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$2 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$2 = Unit_instance;
  }
  return tmp$ret$2;
}
function markCancellationStarted($this) {
  var tmp0 = $this.u28_1;
  var tmp$ret$3;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      var tmp;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      if (convertToInt(shiftRight(cur, 60)) === 0) {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var tmp$ret$1 = cur & 1152921504606846975n;
        tmp = constructSendersAndCloseStatus(tmp$ret$1, 1);
      } else {
        return Unit_instance;
      }
      var upd = tmp;
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        tmp$ret$3 = Unit_instance;
        break $l$block;
      }
    }
    tmp$ret$3 = Unit_instance;
  }
  return tmp$ret$3;
}
function completeCloseOrCancel($this) {
  $this.j2b();
}
function completeClose($this, sendersCur) {
  var lastSegment = closeLinkedList($this);
  if ($this.l2b()) {
    var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
    if (!(lastBufferedCellGlobalIndex === -1n)) {
      $this.k2b(lastBufferedCellGlobalIndex);
    }
  }
  cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
  return lastSegment;
}
function completeCancel($this, sendersCur) {
  var lastSegment = completeClose($this, sendersCur);
  removeUnprocessedElements($this, lastSegment);
}
function closeLinkedList($this) {
  var lastSegment = $this.a29_1.kotlinx$atomicfu$value;
  // Inline function 'kotlin.let' call
  var it = $this.y28_1.kotlinx$atomicfu$value;
  if (it.i21_1 > lastSegment.i21_1)
    lastSegment = it;
  // Inline function 'kotlin.let' call
  var it_0 = $this.z28_1.kotlinx$atomicfu$value;
  if (it_0.i21_1 > lastSegment.i21_1)
    lastSegment = it_0;
  return close(lastSegment);
}
function markAllEmptyCellsAsClosed($this, lastSegment) {
  var segment = lastSegment;
  while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.i21_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        var globalIndex = add(this_0, fromInt(index));
        if (globalIndex < $this.t2a())
          return -1n;
        cell_update: while (true) {
          var state = segment.o28(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.q28(index, state, get_CHANNEL_CLOSED())) {
              segment.g29();
              break cell_update;
            }
          } else if (state === get_BUFFERED())
            return globalIndex;
          else
            break cell_update;
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.p29();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return -1n;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
}
function removeUnprocessedElements($this, lastSegment) {
  var onUndeliveredElement = $this.t28_1;
  var undeliveredElementException = null;
  var suspendedSenders = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (true) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.i21_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        var globalIndex = add(this_0, fromInt(index));
        update_cell: while (true) {
          var state = segment.o28(index);
          if (state === get_DONE_RCV())
            break process_segments;
          else {
            if (state === get_BUFFERED()) {
              if (globalIndex < $this.t2a())
                break process_segments;
              if (segment.q28(index, state, get_CHANNEL_CLOSED())) {
                if (!(onUndeliveredElement == null)) {
                  var element = segment.l28(index);
                  undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                }
                segment.n28(index);
                segment.g29();
                break update_cell;
              }
            } else {
              if (state === get_IN_BUFFER() || state === null) {
                if (segment.q28(index, state, get_CHANNEL_CLOSED())) {
                  segment.g29();
                  break update_cell;
                }
              } else {
                var tmp;
                if (!(state == null) ? isInterface(state, Waiter) : false) {
                  tmp = true;
                } else {
                  tmp = state instanceof WaiterEB;
                }
                if (tmp) {
                  if (globalIndex < $this.t2a())
                    break process_segments;
                  var tmp_0;
                  if (state instanceof WaiterEB) {
                    tmp_0 = state.v2a_1;
                  } else {
                    tmp_0 = (!(state == null) ? isInterface(state, Waiter) : false) ? state : THROW_CCE();
                  }
                  var sender = tmp_0;
                  if (segment.q28(index, state, get_CHANNEL_CLOSED())) {
                    if (!(onUndeliveredElement == null)) {
                      var element_0 = segment.l28(index);
                      undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                    }
                    suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                    segment.n28(index);
                    segment.g29();
                    break update_cell;
                  }
                } else {
                  if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV())
                    break process_segments;
                  else {
                    if (state === get_RESUMING_BY_EB())
                      continue update_cell;
                    else {
                      break update_cell;
                    }
                  }
                }
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    var tmp0_elvis_lhs = segment.p29();
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      break process_segments;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    segment = tmp_1;
  }
  var tmp0_0 = suspendedSenders;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList)) {
        var tmp_2 = access$_get_holder__kkflen(tmp0_0);
        var it = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
        resumeSenderOnCancelledChannel($this, it);
      } else {
        var tmp_3 = access$_get_holder__kkflen(tmp0_0);
        var list = tmp_3 instanceof ArrayList ? tmp_3 : THROW_CCE();
        var inductionVariable_0 = list.o() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.p(i);
            resumeSenderOnCancelledChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  var tmp1_safe_receiver = undeliveredElementException;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    throw tmp1_safe_receiver;
  }
}
function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
  var suspendedReceivers = _InlineList___init__impl__z8n56();
  var segment = lastSegment;
  process_segments: while (!(segment == null)) {
    var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = segment.i21_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_0 = multiply(tmp0, fromInt(other));
        if (add(this_0, fromInt(index)) < sendersCounter)
          break process_segments;
        cell_update: while (true) {
          var state = segment.o28(index);
          if (state === null || state === get_IN_BUFFER()) {
            if (segment.q28(index, state, get_CHANNEL_CLOSED())) {
              segment.g29();
              break cell_update;
            }
          } else {
            if (state instanceof WaiterEB) {
              if (segment.q28(index, state, get_CHANNEL_CLOSED())) {
                suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.v2a_1);
                segment.e29(index, true);
                break cell_update;
              }
            } else {
              if (!(state == null) ? isInterface(state, Waiter) : false) {
                if (segment.q28(index, state, get_CHANNEL_CLOSED())) {
                  suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                  segment.e29(index, true);
                  break cell_update;
                }
              } else {
                break cell_update;
              }
            }
          }
        }
      }
       while (0 <= inductionVariable);
    segment = segment.p29();
  }
  var tmp0_0 = suspendedReceivers;
  $l$block: {
    // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
    var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
    if (tmp0_subject == null) {
      break $l$block;
    } else {
      if (!(tmp0_subject instanceof ArrayList)) {
        var tmp = access$_get_holder__kkflen(tmp0_0);
        var it = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        resumeReceiverOnClosedChannel($this, it);
      } else {
        var tmp_0 = access$_get_holder__kkflen(tmp0_0);
        var list = tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE();
        var inductionVariable_0 = list.o() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            var it_0 = list.p(i);
            resumeReceiverOnClosedChannel($this, it_0);
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
}
function resumeReceiverOnClosedChannel($this, _this__u8e3s4) {
  return resumeWaiterOnClosedChannel($this, _this__u8e3s4, true);
}
function resumeSenderOnCancelledChannel($this, _this__u8e3s4) {
  return resumeWaiterOnClosedChannel($this, _this__u8e3s4, false);
}
function resumeWaiterOnClosedChannel($this, _this__u8e3s4, receiver) {
  if (_this__u8e3s4 instanceof SendBroadcast) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = _this__u8e3s4.c2b_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
    this_0.o8(tmp$ret$0);
  } else {
    if (isInterface(_this__u8e3s4, CancellableContinuation)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = receiver ? _get_receiveException__foorc1($this) : $this.s2a();
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      _this__u8e3s4.o8(tmp$ret$2);
    } else {
      if (_this__u8e3s4 instanceof ReceiveCatching) {
        var tmp0 = _this__u8e3s4.z2a_1;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = new ChannelResult(Companion_getInstance().m2b($this.v29()));
        var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
        tmp0.o8(tmp$ret$4);
      } else {
        if (_this__u8e3s4 instanceof BufferedChannelIterator) {
          _this__u8e3s4.i2b();
        } else {
          if (isInterface(_this__u8e3s4, SelectInstance))
            _this__u8e3s4.a2b($this, get_CHANNEL_CLOSED());
          else {
            // Inline function 'kotlin.error' call
            var message = 'Unexpected waiter: ' + toString(_this__u8e3s4);
            throw IllegalStateException_init_$Create$(toString(message));
          }
        }
      }
    }
  }
}
function _get_isClosedForSend0__kxgf9m($this, _this__u8e3s4) {
  return isClosed($this, _this__u8e3s4, false);
}
function _get_isClosedForReceive0__f7qknl($this, _this__u8e3s4) {
  return isClosed($this, _this__u8e3s4, true);
}
function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
  // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
  var tmp;
  switch (convertToInt(shiftRight(sendersAndCloseStatusCur, 60))) {
    case 0:
      tmp = false;
      break;
    case 1:
      tmp = false;
      break;
    case 2:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$1 = sendersAndCloseStatusCur & 1152921504606846975n;
      completeClose($this, tmp$ret$1);
      tmp = isClosedForReceive ? !$this.n2b() : true;
      break;
    case 3:
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

      var tmp$ret$2 = sendersAndCloseStatusCur & 1152921504606846975n;
      completeCancel($this, tmp$ret$2);
      tmp = true;
      break;
    default:
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call

      var message = 'unexpected close status: ' + convertToInt(shiftRight(sendersAndCloseStatusCur, 60));
      throw IllegalStateException_init_$Create$(toString(message));
  }
  return tmp;
}
function isCellNonEmpty($this, segment, index, globalIndex) {
  while (true) {
    var state = segment.o28(index);
    if (state === null || state === get_IN_BUFFER()) {
      if (segment.q28(index, state, get_POISONED())) {
        expandBuffer($this);
        return false;
      }
    } else if (state === get_BUFFERED())
      return true;
    else if (state === get_INTERRUPTED_SEND())
      return false;
    else if (state === get_CHANNEL_CLOSED())
      return false;
    else if (state === get_DONE_RCV())
      return false;
    else if (state === get_POISONED())
      return false;
    else if (state === get_RESUMING_BY_EB())
      return true;
    else if (state === get_RESUMING_BY_RCV())
      return false;
    else
      return globalIndex === $this.t2a();
  }
}
function findSegmentSend($this, id, startFrom) {
  var tmp0 = $this.y28_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.i21_1 >= tmp2.i21_1) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (!tmp2.i29()) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.j29()) {
                cur.k3();
              }
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (tmp2.j29()) {
              tmp2.k3();
            }
          }
          tmp$ret$0 = Unit_instance;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$2;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.i21_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    if (multiply(tmp0_0, fromInt(other)) < $this.t2a()) {
      startFrom.q29();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.i21_1 > id) {
      var tmp0_1 = segment.i21_1;
      // Inline function 'kotlin.Long.times' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$4 = multiply(tmp0_1, fromInt(other_0));
      updateSendersCounterIfLower($this, tmp$ret$4);
      var tmp0_2 = segment.i21_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      if (multiply(tmp0_2, fromInt(other_1)) < $this.t2a()) {
        segment.q29();
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function findSegmentReceive($this, id, startFrom) {
  var tmp0 = $this.z28_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.i21_1 >= tmp2.i21_1) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (!tmp2.i29()) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.j29()) {
                cur.k3();
              }
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (tmp2.j29()) {
              tmp2.k3();
            }
          }
          tmp$ret$0 = Unit_instance;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$2;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    var tmp0_0 = startFrom.i21_1;
    // Inline function 'kotlin.Long.times' call
    var other = get_SEGMENT_SIZE();
    if (multiply(tmp0_0, fromInt(other)) < $this.w29()) {
      startFrom.q29();
    }
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
      var tmp0_1 = _get_bufferEndCounter__2d4hee($this);
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      tmp_1 = id <= divide(tmp0_1, fromInt(other_0));
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp0_2 = $this.a29_1;
      $l$block_5: {
        // Inline function 'kotlinx.coroutines.internal.moveForward' call
        while (true) {
          var cur_0 = tmp0_2.kotlinx$atomicfu$value;
          if (cur_0.i21_1 >= segment.i21_1) {
            break $l$block_5;
          }
          if (!segment.i29()) {
            break $l$block_5;
          }
          if (tmp0_2.atomicfu$compareAndSet(cur_0, segment)) {
            if (cur_0.j29()) {
              cur_0.k3();
            }
            break $l$block_5;
          }
          if (segment.j29()) {
            segment.k3();
          }
        }
      }
    }
    var tmp_2;
    if (segment.i21_1 > id) {
      var tmp0_3 = segment.i21_1;
      // Inline function 'kotlin.Long.times' call
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$7 = multiply(tmp0_3, fromInt(other_1));
      updateReceiversCounterIfLower($this, tmp$ret$7);
      var tmp0_4 = segment.i21_1;
      // Inline function 'kotlin.Long.times' call
      var other_2 = get_SEGMENT_SIZE();
      if (multiply(tmp0_4, fromInt(other_2)) < $this.w29()) {
        segment.q29();
      }
      tmp_2 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_2 = segment;
    }
    tmp_0 = tmp_2;
  }
  return tmp_0;
}
function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
  var tmp0 = $this.a29_1;
  var tmp6 = createSegmentFunction();
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(startFrom, id, tmp6);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.i21_1 >= tmp2.i21_1) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (!tmp2.i29()) {
              tmp$ret$0 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.j29()) {
                cur.k3();
              }
              tmp$ret$0 = true;
              break $l$block_1;
            }
            if (tmp2.j29()) {
              tmp2.k3();
            }
          }
          tmp$ret$0 = Unit_instance;
        }
        tmp = tmp$ret$0;
      }
      if (tmp) {
        tmp$ret$2 = s;
        break $l$block_2;
      }
    }
  }
  // Inline function 'kotlin.let' call
  var it = tmp$ret$2;
  var tmp_0;
  if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
    completeCloseOrCancel($this);
    moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
    incCompletedExpandBufferAttempts$default($this);
    tmp_0 = null;
  } else {
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
    var tmp_1;
    if (segment.i21_1 > id) {
      // Inline function 'kotlin.Long.plus' call
      var tmp_2 = add(currentBufferEndCounter, fromInt(1));
      var tmp0_0 = segment.i21_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      var tmp$ret$4 = multiply(tmp0_0, fromInt(other));
      if ($this.w28_1.atomicfu$compareAndSet(tmp_2, tmp$ret$4)) {
        var tmp0_1 = segment.i21_1;
        // Inline function 'kotlin.Long.times' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$5 = multiply(tmp0_1, fromInt(other_0));
        incCompletedExpandBufferAttempts($this, subtract(tmp$ret$5, currentBufferEndCounter));
      } else {
        incCompletedExpandBufferAttempts$default($this);
      }
      tmp_1 = null;
    } else {
      // Inline function 'kotlinx.coroutines.assert' call
      tmp_1 = segment;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
  var segment = startFrom;
  $l$loop: while (segment.i21_1 < id) {
    var tmp0_elvis_lhs = segment.m29();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    segment = tmp;
  }
  while (true) {
    $l$loop_0: while (segment.h29()) {
      var tmp1_elvis_lhs = segment.m29();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      segment = tmp_0;
    }
    var tmp0 = $this.a29_1;
    var tmp2 = segment;
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.internal.moveForward' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (cur.i21_1 >= tmp2.i21_1) {
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (!tmp2.i29()) {
          tmp$ret$0 = false;
          break $l$block_1;
        }
        if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
          if (cur.j29()) {
            cur.k3();
          }
          tmp$ret$0 = true;
          break $l$block_1;
        }
        if (tmp2.j29()) {
          tmp2.k3();
        }
      }
      tmp$ret$0 = Unit_instance;
    }
    if (tmp$ret$0)
      return Unit_instance;
  }
}
function updateSendersCounterIfLower($this, value) {
  var this_0 = $this.u28_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var curCounter = cur & 1152921504606846975n;
    if (curCounter >= value)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp$ret$1 = convertToInt(shiftRight(cur, 60));
    var update = constructSendersAndCloseStatus(curCounter, tmp$ret$1);
    if ($this.u28_1.atomicfu$compareAndSet(cur, update))
      return Unit_instance;
  }
  return Unit_instance;
}
function updateReceiversCounterIfLower($this, value) {
  var this_0 = $this.v28_1;
  while (true) {
    var cur = this_0.kotlinx$atomicfu$value;
    if (cur >= value)
      return Unit_instance;
    if ($this.v28_1.atomicfu$compareAndSet(cur, value))
      return Unit_instance;
  }
  return Unit_instance;
}
function bindCancellationFunResult($this, _this__u8e3s4) {
  return BufferedChannel$onCancellationChannelResultImplDoNotCall$ref($this);
}
function onCancellationChannelResultImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.t28_1), ensureNotNull(ChannelResult__getOrNull_impl_f5e07h(element)), context);
}
function bindCancellationFun($this, _this__u8e3s4, element) {
  return BufferedChannel$bindCancellationFun$lambda(_this__u8e3s4, element);
}
function bindCancellationFun_0($this, _this__u8e3s4) {
  return BufferedChannel$onCancellationImplDoNotCall$ref($this);
}
function onCancellationImplDoNotCall($this, cause, element, context) {
  callUndeliveredElement(ensureNotNull($this.t28_1), element, context);
}
function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda($element, this$0, $select) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    var tmp;
    if (!($element === get_CHANNEL_CLOSED())) {
      callUndeliveredElement(this$0.t28_1, ($element == null ? true : !($element == null)) ? $element : THROW_CCE(), $select.j8());
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this$0) {
  return function (select, _unused_var__etf5q3, element) {
    return BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda(element, this$0, select);
  };
}
function BufferedChannel$onCancellationChannelResultImplDoNotCall$ref(p0) {
  var l = function (_this__u8e3s4, p0_0, p1) {
    var tmp0 = p0;
    onCancellationChannelResultImplDoNotCall(tmp0, _this__u8e3s4, p0_0.p2b_1, p1);
    return Unit_instance;
  };
  l.callableName = 'onCancellationChannelResultImplDoNotCall';
  return l;
}
function BufferedChannel$bindCancellationFun$lambda($this_bindCancellationFun, $element) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, context) {
    callUndeliveredElement($this_bindCancellationFun, $element, context);
    return Unit_instance;
  };
}
function BufferedChannel$onCancellationImplDoNotCall$ref(p0) {
  var l = function (_this__u8e3s4, p0_0, p1) {
    var tmp0 = p0;
    onCancellationImplDoNotCall(tmp0, _this__u8e3s4, p0_0, p1);
    return Unit_instance;
  };
  l.callableName = 'onCancellationImplDoNotCall';
  return l;
}
function $sendCOROUTINE$(_this__u8e3s4, element, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.y2b_1 = _this__u8e3s4;
  this.z2b_1 = element;
}
protoOf($sendCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 11;
          var tmp_0 = this;
          tmp_0.k2c_1 = this.y2b_1;
          var tmp_1 = this;
          tmp_1.j2c_1 = this.z2b_1;
          var tmp_2 = this;
          tmp_2.i2c_1 = null;
          this.d8_1 = 1;
          continue $sm;
        case 1:
          this.c2c_1 = this.k2c_1;
          this.f2c_1 = this.j2c_1;
          this.d2c_1 = this.i2c_1;
          this.b2c_1 = this.c2c_1.y28_1.kotlinx$atomicfu$value;
          this.d8_1 = 2;
          continue $sm;
        case 2:
          if (!true) {
            this.d8_1 = 12;
            continue $sm;
          }

          var sendersAndCloseStatusCur = this.c2c_1.u28_1.atomicfu$getAndIncrement$long();
          var tmp_3 = this;
          tmp_3.e2c_1 = sendersAndCloseStatusCur & 1152921504606846975n;
          this.g2c_1 = _get_isClosedForSend0__kxgf9m(this.c2c_1, sendersAndCloseStatusCur);
          var tmp0 = this.e2c_1;
          var other = get_SEGMENT_SIZE();
          var id = divide(tmp0, fromInt(other));
          var tmp_4 = this;
          var tmp0_0 = this.e2c_1;
          var other_0 = get_SEGMENT_SIZE();
          tmp_4.a2c_1 = convertToInt(modulo(tmp0_0, fromInt(other_0)));
          if (!(this.b2c_1.i21_1 === id)) {
            var tmp0_elvis_lhs = findSegmentSend(this.c2c_1, id, this.b2c_1);
            if (tmp0_elvis_lhs == null) {
              if (this.g2c_1) {
                this.d8_1 = 10;
                suspendResult = onClosedSend(this.y2b_1, this.z2b_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.d8_1 = 2;
                var tmp_5 = this;
                continue $sm;
              }
            } else {
              this.h2c_1 = tmp0_elvis_lhs;
              this.d8_1 = 3;
              continue $sm;
            }
          } else {
            this.d8_1 = 4;
            continue $sm;
          }

        case 3:
          this.b2c_1 = this.h2c_1;
          this.d8_1 = 4;
          continue $sm;
        case 4:
          var tmp1_subject = updateCellSend(this.c2c_1, this.b2c_1, this.a2c_1, this.f2c_1, this.e2c_1, this.d2c_1, this.g2c_1);
          if (tmp1_subject === 0) {
            this.b2c_1.q29();
            this.d8_1 = 13;
            continue $sm;
          } else {
            if (tmp1_subject === 1) {
              this.d8_1 = 13;
              continue $sm;
            } else {
              if (tmp1_subject === 2) {
                if (this.g2c_1) {
                  this.b2c_1.g29();
                  this.d8_1 = 9;
                  suspendResult = onClosedSend(this.y2b_1, this.z2b_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.d8_1 = 8;
                  continue $sm;
                }
              } else {
                if (tmp1_subject === 4) {
                  if (this.e2c_1 < this.c2c_1.t2a()) {
                    this.b2c_1.q29();
                  }
                  this.d8_1 = 7;
                  suspendResult = onClosedSend(this.y2b_1, this.z2b_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp1_subject === 5) {
                    this.b2c_1.q29();
                    this.d8_1 = 2;
                    continue $sm;
                  } else {
                    if (tmp1_subject === 3) {
                      var tmp0_1 = this.b2c_1;
                      var tmp2 = this.a2c_1;
                      var tmp4 = this.f2c_1;
                      var s = this.e2c_1;
                      this.d8_1 = 6;
                      suspendResult = sendOnNoWaiterSuspend(this.y2b_1, tmp0_1, tmp2, tmp4, s, this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      this.d8_1 = 5;
                      continue $sm;
                    }
                  }
                }
              }
            }
          }

        case 5:
          this.d8_1 = 2;
          continue $sm;
        case 6:
          this.d8_1 = 13;
          continue $sm;
        case 7:
          this.d8_1 = 13;
          continue $sm;
        case 8:
          var tmp_6 = this.d2c_1;
          var tmp2_safe_receiver = (!(tmp_6 == null) ? isInterface(tmp_6, Waiter) : false) ? tmp_6 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            prepareSenderForSuspension(this.c2c_1, tmp2_safe_receiver, this.b2c_1, this.a2c_1);
          }

          this.b2c_1;
          this.a2c_1;
          this.d8_1 = 13;
          continue $sm;
        case 9:
          this.d8_1 = 13;
          continue $sm;
        case 10:
          this.d8_1 = 13;
          continue $sm;
        case 11:
          throw this.g8_1;
        case 12:
          if (false) {
            this.d8_1 = 1;
            continue $sm;
          }

          this.d8_1 = 13;
          continue $sm;
        case 13:
          return Unit_instance;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 11) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function BufferedChannel(capacity, onUndeliveredElement) {
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  this.s28_1 = capacity;
  this.t28_1 = onUndeliveredElement;
  // Inline function 'kotlin.require' call
  if (!(this.s28_1 >= 0)) {
    var message = 'Invalid channel capacity: ' + this.s28_1 + ', should be >=0';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  this.u28_1 = atomic$long$1(0n);
  this.v28_1 = atomic$long$1(0n);
  this.w28_1 = atomic$long$1(initialBufferEnd(this.s28_1));
  this.x28_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
  var firstSegment = new ChannelSegment(0n, null, this, 3);
  this.y28_1 = atomic$ref$1(firstSegment);
  this.z28_1 = atomic$ref$1(firstSegment);
  var tmp = this;
  var tmp_0;
  if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
    var tmp_1 = get_NULL_SEGMENT();
    tmp_0 = tmp_1 instanceof ChannelSegment ? tmp_1 : THROW_CCE();
  } else {
    tmp_0 = firstSegment;
  }
  tmp.a29_1 = atomic$ref$1(tmp_0);
  var tmp_2 = this;
  var tmp_3;
  if (this.t28_1 == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this);
  }
  tmp_2.b29_1 = tmp_3;
  this.c29_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
  this.d29_1 = atomic$ref$1(null);
}
protoOf(BufferedChannel).w29 = function () {
  // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
  return this.u28_1.kotlinx$atomicfu$value & 1152921504606846975n;
};
protoOf(BufferedChannel).t2a = function () {
  return this.v28_1.kotlinx$atomicfu$value;
};
protoOf(BufferedChannel).l2c = function (element, $completion) {
  var tmp = new $sendCOROUTINE$(this, element, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(BufferedChannel).m2c = function (element) {
  if (shouldSendSuspend0(this, this.u28_1.kotlinx$atomicfu$value))
    return Companion_getInstance().n2c();
  var tmp4 = get_INTERRUPTED_SEND();
  var tmp$ret$4;
  $l$block_4: {
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
    var segment = this.y28_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var sendersAndCloseStatusCur = this.u28_1.atomicfu$getAndIncrement$long();
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var s = sendersAndCloseStatusCur & 1152921504606846975n;
      var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = divide(s, fromInt(other));
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$2 = modulo(s, fromInt(other_0));
      var i = convertToInt(tmp$ret$2);
      if (!(segment.i21_1 === id)) {
        var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (closed) {
            tmp$ret$4 = Companion_getInstance().m2b(this.s2a());
            break $l$block_4;
          } else {
            continue $l$loop_0;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      switch (updateCellSend(this, segment, i, element, s, tmp4, closed)) {
        case 0:
          segment.q29();
          tmp$ret$4 = Companion_getInstance().y2a(Unit_instance);
          break $l$block_4;
        case 1:
          tmp$ret$4 = Companion_getInstance().y2a(Unit_instance);
          break $l$block_4;
        case 2:
          if (closed) {
            segment.g29();
            tmp$ret$4 = Companion_getInstance().m2b(this.s2a());
            break $l$block_4;
          }

          var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter) : false) ? tmp4 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
          }

          segment.g29();
          tmp$ret$4 = Companion_getInstance().n2c();
          break $l$block_4;
        case 4:
          if (s < this.t2a()) {
            segment.q29();
          }

          tmp$ret$4 = Companion_getInstance().m2b(this.s2a());
          break $l$block_4;
        case 5:
          segment.q29();
          continue $l$loop_0;
        case 3:
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  return tmp$ret$4;
};
protoOf(BufferedChannel).o2c = function (element) {
  var tmp$ret$3;
  // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
  var waiter = get_BUFFERED();
  var segment = this.y28_1.kotlinx$atomicfu$value;
  $l$loop_0: while (true) {
    var sendersAndCloseStatusCur = this.u28_1.atomicfu$getAndIncrement$long();
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var s = sendersAndCloseStatusCur & 1152921504606846975n;
    var closed = _get_isClosedForSend0__kxgf9m(this, sendersAndCloseStatusCur);
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = divide(s, fromInt(other));
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var tmp$ret$2 = modulo(s, fromInt(other_0));
    var i = convertToInt(tmp$ret$2);
    if (!(segment.i21_1 === id)) {
      var tmp0_elvis_lhs = findSegmentSend(this, id, segment);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp_0;
        if (closed) {
          return Companion_getInstance().m2b(this.s2a());
        } else {
          continue $l$loop_0;
        }
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    switch (updateCellSend(this, segment, i, element, s, waiter, closed)) {
      case 0:
        segment.q29();
        return Companion_getInstance().y2a(Unit_instance);
      case 1:
        return Companion_getInstance().y2a(Unit_instance);
      case 2:
        if (closed) {
          segment.g29();
          return Companion_getInstance().m2b(this.s2a());
        }

        var tmp2_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter) : false) ? waiter : null;
        if (tmp2_safe_receiver == null)
          null;
        else {
          prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
        }

        var tmp0 = segment.i21_1;
        // Inline function 'kotlin.Long.times' call

        var other_1 = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call

        var this_0 = multiply(tmp0, fromInt(other_1));
        var tmp$ret$5 = add(this_0, fromInt(i));
        this.k2b(tmp$ret$5);
        return Companion_getInstance().y2a(Unit_instance);
      case 4:
        if (s < this.t2a()) {
          segment.q29();
        }

        return Companion_getInstance().m2b(this.s2a());
      case 5:
        segment.q29();
        continue $l$loop_0;
      case 3:
        var message = 'unexpected';
        throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  return tmp$ret$3;
};
protoOf(BufferedChannel).b2b = function () {
};
protoOf(BufferedChannel).u2a = function () {
};
protoOf(BufferedChannel).k2b = function (globalCellIndex) {
  // Inline function 'kotlinx.coroutines.assert' call
  var segment = this.z28_1.kotlinx$atomicfu$value;
  $l$loop_0: while (true) {
    var r = this.v28_1.kotlinx$atomicfu$value;
    // Inline function 'kotlin.Long.plus' call
    var other = this.s28_1;
    var tmp0 = add(r, fromInt(other));
    // Inline function 'kotlin.math.max' call
    var b = _get_bufferEndCounter__2d4hee(this);
    if (globalCellIndex < (tmp0 >= b ? tmp0 : b))
      return Unit_instance;
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$3 = add(r, fromInt(1));
    if (!this.v28_1.atomicfu$compareAndSet(r, tmp$ret$3))
      continue $l$loop_0;
    // Inline function 'kotlin.Long.div' call
    var other_0 = get_SEGMENT_SIZE();
    var id = divide(r, fromInt(other_0));
    // Inline function 'kotlin.Long.rem' call
    var other_1 = get_SEGMENT_SIZE();
    var tmp$ret$5 = modulo(r, fromInt(other_1));
    var i = convertToInt(tmp$ret$5);
    if (!(segment.i21_1 === id)) {
      var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    var updCellResult = updateCellReceive(this, segment, i, r, null);
    if (updCellResult === get_FAILED()) {
      if (r < this.w29()) {
        segment.q29();
      }
    } else {
      segment.q29();
      var tmp1_safe_receiver = this.t28_1;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp_0 = callUndeliveredElementCatchingException(tmp1_safe_receiver, (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE());
      }
      var tmp2_safe_receiver = tmp_0;
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        throw tmp2_safe_receiver;
      }
    }
  }
};
protoOf(BufferedChannel).f29 = function (globalIndex) {
  if (_get_isRendezvousOrUnlimited__3mdufi(this))
    return Unit_instance;
  while (_get_bufferEndCounter__2d4hee(this) <= globalIndex) {
  }
  // Inline function 'kotlin.repeat' call
  var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = _get_bufferEndCounter__2d4hee(this);
      // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
      var ebCompleted = this.x28_1.kotlinx$atomicfu$value & 4611686018427387903n;
      if (b === ebCompleted && b === _get_bufferEndCounter__2d4hee(this))
        return Unit_instance;
    }
     while (inductionVariable < times);
  var tmp0 = this.x28_1;
  $l$block: {
    // Inline function 'kotlinx.atomicfu.update' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
      var tmp$ret$3 = cur & 4611686018427387903n;
      var upd = constructEBCompletedAndPauseFlag(tmp$ret$3, true);
      if (tmp0.atomicfu$compareAndSet(cur, upd)) {
        break $l$block;
      }
    }
  }
  while (true) {
    var b_0 = _get_bufferEndCounter__2d4hee(this);
    var ebCompletedAndBit = this.x28_1.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
    var ebCompleted_0 = ebCompletedAndBit & 4611686018427387903n;
    // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
    var pauseExpandBuffers = !((ebCompletedAndBit & 4611686018427387904n) === 0n);
    if (b_0 === ebCompleted_0 && b_0 === _get_bufferEndCounter__2d4hee(this)) {
      var tmp0_0 = this.x28_1;
      $l$block_0: {
        // Inline function 'kotlinx.atomicfu.update' call
        while (true) {
          var cur_0 = tmp0_0.kotlinx$atomicfu$value;
          // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
          var tmp$ret$8 = cur_0 & 4611686018427387903n;
          var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$8, false);
          if (tmp0_0.atomicfu$compareAndSet(cur_0, upd_0)) {
            break $l$block_0;
          }
        }
      }
      return Unit_instance;
    }
    if (!pauseExpandBuffers) {
      this.x28_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
    }
  }
};
protoOf(BufferedChannel).l = function () {
  return new BufferedChannelIterator(this);
};
protoOf(BufferedChannel).v29 = function () {
  var tmp = this.c29_1.kotlinx$atomicfu$value;
  return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
};
protoOf(BufferedChannel).s2a = function () {
  var tmp0_elvis_lhs = this.v29();
  return tmp0_elvis_lhs == null ? new ClosedSendChannelException('Channel was closed') : tmp0_elvis_lhs;
};
protoOf(BufferedChannel).p2c = function () {
};
protoOf(BufferedChannel).q2c = function (cause) {
  return this.r2c(cause, false);
};
protoOf(BufferedChannel).o1y = function (cause) {
  this.t2c(cause);
};
protoOf(BufferedChannel).t2c = function (cause) {
  return this.r2c(cause == null ? CancellationException_init_$Create$('Channel was cancelled') : cause, true);
};
protoOf(BufferedChannel).r2c = function (cause, cancel) {
  if (cancel) {
    markCancellationStarted(this);
  }
  var closedByThisOperation = this.c29_1.atomicfu$compareAndSet(get_NO_CLOSE_CAUSE(), cause);
  if (cancel) {
    markCancelled(this);
  } else {
    markClosed(this);
  }
  completeCloseOrCancel(this);
  // Inline function 'kotlin.also' call
  this.p2c();
  if (closedByThisOperation) {
    invokeCloseHandler(this);
  }
  return closedByThisOperation;
};
protoOf(BufferedChannel).l2b = function () {
  return false;
};
protoOf(BufferedChannel).j2b = function () {
  return _get_isClosedForSend0__kxgf9m(this, this.u28_1.kotlinx$atomicfu$value);
};
protoOf(BufferedChannel).x29 = function () {
  return _get_isClosedForReceive0__f7qknl(this, this.u28_1.kotlinx$atomicfu$value);
};
protoOf(BufferedChannel).n2b = function () {
  $l$loop: while (true) {
    var segment = this.z28_1.kotlinx$atomicfu$value;
    var r = this.t2a();
    var s = this.w29();
    if (s <= r)
      return false;
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE();
    var id = divide(r, fromInt(other));
    if (!(segment.i21_1 === id)) {
      var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp_0;
        if (this.z28_1.kotlinx$atomicfu$value.i21_1 < id) {
          return false;
        } else {
          continue $l$loop;
        }
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    segment.q29();
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE();
    var tmp$ret$1 = modulo(r, fromInt(other_0));
    var i = convertToInt(tmp$ret$1);
    if (isCellNonEmpty(this, segment, i, r))
      return true;
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$2 = add(r, fromInt(1));
    this.v28_1.atomicfu$compareAndSet(r, tmp$ret$2);
  }
};
protoOf(BufferedChannel).toString = function () {
  var sb = StringBuilder_init_$Create$();
  // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
  var this_0 = this.u28_1.kotlinx$atomicfu$value;
  var tmp0_subject = convertToInt(shiftRight(this_0, 60));
  if (tmp0_subject === 2) {
    sb.k7('closed,');
  } else if (tmp0_subject === 3) {
    sb.k7('cancelled,');
  }
  sb.k7('capacity=' + this.s28_1 + ',');
  sb.k7('data=[');
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = listOf([this.z28_1.kotlinx$atomicfu$value, this.y28_1.kotlinx$atomicfu$value, this.a29_1.kotlinx$atomicfu$value]);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    if (!(element === get_NULL_SEGMENT())) {
      destination.j(element);
    }
  }
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.minBy' call
    var iterator = destination.l();
    if (!iterator.m())
      throw NoSuchElementException_init_$Create$();
    var minElem = iterator.n();
    if (!iterator.m()) {
      tmp$ret$4 = minElem;
      break $l$block;
    }
    var minValue = minElem.i21_1;
    do {
      var e = iterator.n();
      var v = e.i21_1;
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.m());
    tmp$ret$4 = minElem;
  }
  var firstSegment = tmp$ret$4;
  var r = this.t2a();
  var s = this.w29();
  var segment = firstSegment;
  append_elements: while (true) {
    var inductionVariable = 0;
    var last_0 = get_SEGMENT_SIZE();
    if (inductionVariable < last_0)
      process_cell: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_0 = segment.i21_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        // Inline function 'kotlin.Long.plus' call
        var this_1 = multiply(tmp0_0, fromInt(other));
        var globalCellIndex = add(this_1, fromInt(i));
        if (globalCellIndex >= s && globalCellIndex >= r)
          break append_elements;
        var cellState = segment.o28(i);
        var element_0 = segment.l28(i);
        var tmp;
        if (!(cellState == null) ? isInterface(cellState, CancellableContinuation) : false) {
          tmp = globalCellIndex < r && globalCellIndex >= s ? 'receive' : globalCellIndex < s && globalCellIndex >= r ? 'send' : 'cont';
        } else {
          if (!(cellState == null) ? isInterface(cellState, SelectInstance) : false) {
            tmp = globalCellIndex < r && globalCellIndex >= s ? 'onReceive' : globalCellIndex < s && globalCellIndex >= r ? 'onSend' : 'select';
          } else {
            if (cellState instanceof ReceiveCatching) {
              tmp = 'receiveCatching';
            } else {
              if (cellState instanceof SendBroadcast) {
                tmp = 'sendBroadcast';
              } else {
                if (cellState instanceof WaiterEB) {
                  tmp = 'EB(' + cellState.toString() + ')';
                } else {
                  if (equals(cellState, get_RESUMING_BY_RCV()) || equals(cellState, get_RESUMING_BY_EB())) {
                    tmp = 'resuming_sender';
                  } else {
                    if (cellState == null || (equals(cellState, get_IN_BUFFER()) || equals(cellState, get_DONE_RCV())) || (equals(cellState, get_POISONED()) || equals(cellState, get_INTERRUPTED_RCV()) || (equals(cellState, get_INTERRUPTED_SEND()) || equals(cellState, get_CHANNEL_CLOSED())))) {
                      continue process_cell;
                    } else {
                      tmp = toString(cellState);
                    }
                  }
                }
              }
            }
          }
        }
        var cellStateString = tmp;
        if (!(element_0 == null)) {
          sb.k7('(' + cellStateString + ',' + toString_0(element_0) + '),');
        } else {
          sb.k7(cellStateString + ',');
        }
      }
       while (inductionVariable < last_0);
    var tmp2_elvis_lhs = segment.m29();
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      break append_elements;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    segment = tmp_0;
  }
  if (last(sb) === _Char___init__impl__6a9atx(44)) {
    sb.ec(sb.a() - 1 | 0);
  }
  sb.k7(']');
  return sb.toString();
};
function WaiterEB(waiter) {
  this.v2a_1 = waiter;
}
protoOf(WaiterEB).toString = function () {
  return 'WaiterEB(' + toString(this.v2a_1) + ')';
};
function initialBufferEnd(capacity) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  switch (capacity) {
    case 0:
      return 0n;
    case 2147483647:
      return 9223372036854775807n;
    default:
      return fromInt(capacity);
  }
}
function ReceiveCatching() {
}
function tryResume0(_this__u8e3s4, value, onCancellation) {
  onCancellation = onCancellation === VOID ? null : onCancellation;
  _init_properties_BufferedChannel_kt__d6uc4y();
  // Inline function 'kotlin.let' call
  var token = _this__u8e3s4.f20(value, null, onCancellation);
  var tmp;
  if (!(token == null)) {
    _this__u8e3s4.g20(token);
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
function constructEBCompletedAndPauseFlag(counter, pauseEB) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return add(pauseEB ? 4611686018427387904n : 0n, counter);
}
function constructSendersAndCloseStatus(counter, closeStatus) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return add(shiftLeft(fromInt(closeStatus), 60), counter);
}
function createSegmentFunction() {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return createSegment$ref();
}
function createSegment(id, prev) {
  _init_properties_BufferedChannel_kt__d6uc4y();
  return new ChannelSegment(id, prev, prev.i28(), 0);
}
function createSegment$ref() {
  var l = function (p0, p1) {
    return createSegment(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
var properties_initialized_BufferedChannel_kt_58tjvw;
function _init_properties_BufferedChannel_kt__d6uc4y() {
  if (!properties_initialized_BufferedChannel_kt_58tjvw) {
    properties_initialized_BufferedChannel_kt_58tjvw = true;
    NULL_SEGMENT = new ChannelSegment(-1n, null, null, 0);
    SEGMENT_SIZE = systemProp('kotlinx.coroutines.bufferedChannel.segmentSize', 32);
    EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp('kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations', 10000);
    BUFFERED = new Symbol('BUFFERED');
    IN_BUFFER = new Symbol('SHOULD_BUFFER');
    RESUMING_BY_RCV = new Symbol('S_RESUMING_BY_RCV');
    RESUMING_BY_EB = new Symbol('RESUMING_BY_EB');
    POISONED = new Symbol('POISONED');
    DONE_RCV = new Symbol('DONE_RCV');
    INTERRUPTED_SEND = new Symbol('INTERRUPTED_SEND');
    INTERRUPTED_RCV = new Symbol('INTERRUPTED_RCV');
    CHANNEL_CLOSED = new Symbol('CHANNEL_CLOSED');
    SUSPEND = new Symbol('SUSPEND');
    SUSPEND_NO_WAITER = new Symbol('SUSPEND_NO_WAITER');
    FAILED = new Symbol('FAILED');
    NO_RECEIVE_RESULT = new Symbol('NO_RECEIVE_RESULT');
    CLOSE_HANDLER_CLOSED = new Symbol('CLOSE_HANDLER_CLOSED');
    CLOSE_HANDLER_INVOKED = new Symbol('CLOSE_HANDLER_INVOKED');
    NO_CLOSE_CAUSE = new Symbol('NO_CLOSE_CAUSE');
  }
}
function Factory() {
  Factory_instance = this;
  this.v2c_1 = 2147483647;
  this.w2c_1 = 0;
  this.x2c_1 = -1;
  this.y2c_1 = -2;
  this.z2c_1 = -3;
  this.a2d_1 = 'kotlinx.coroutines.channels.defaultBuffer';
  this.b2d_1 = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
}
var Factory_instance;
function Factory_getInstance() {
  if (Factory_instance == null)
    new Factory();
  return Factory_instance;
}
function Channel(capacity, onBufferOverflow, onUndeliveredElement) {
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  var tmp;
  switch (capacity) {
    case 0:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(0, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
      break;
    case -1:
      // Inline function 'kotlin.require' call

      if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
        var message = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }

      tmp = new ConflatedBufferedChannel(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
      break;
    case 2147483647:
      tmp = new BufferedChannel(2147483647, onUndeliveredElement);
      break;
    case -2:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(Factory_getInstance().b2d_1, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
      break;
    default:
      tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new BufferedChannel(capacity, onUndeliveredElement) : new ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement);
      break;
  }
  return tmp;
}
function ReceiveChannel() {
}
function SendChannel() {
}
function _ChannelResult___init__impl__siwsuf(holder) {
  return holder;
}
function _ChannelResult___get_holder__impl__pm9gzw($this) {
  return $this;
}
function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return !(tmp instanceof Failed);
}
function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return tmp instanceof Closed;
}
function ChannelResult__getOrNull_impl_f5e07h($this) {
  var tmp;
  var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
  if (!(tmp_0 instanceof Failed)) {
    var tmp_1 = _ChannelResult___get_holder__impl__pm9gzw($this);
    tmp = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
  } else {
    tmp = null;
  }
  return tmp;
}
function ChannelResult__exceptionOrNull_impl_16ei30($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c2d_1;
}
function Failed() {
}
protoOf(Failed).toString = function () {
  return 'Failed';
};
function Closed(cause) {
  Failed.call(this);
  this.c2d_1 = cause;
}
protoOf(Closed).equals = function (other) {
  var tmp;
  if (other instanceof Closed) {
    tmp = equals(this.c2d_1, other.c2d_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(Closed).hashCode = function () {
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver = this.c2d_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
};
protoOf(Closed).toString = function () {
  return 'Closed(' + toString_0(this.c2d_1) + ')';
};
function Companion() {
  Companion_instance_0 = this;
  this.x2a_1 = new Failed();
}
protoOf(Companion).y2a = function (value) {
  return _ChannelResult___init__impl__siwsuf(value);
};
protoOf(Companion).n2c = function () {
  return _ChannelResult___init__impl__siwsuf(this.x2a_1);
};
protoOf(Companion).m2b = function (cause) {
  return _ChannelResult___init__impl__siwsuf(new Closed(cause));
};
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 == null)
    new Companion();
  return Companion_instance_0;
}
function ChannelResult__toString_impl_rrcqu7($this) {
  var tmp;
  if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed) {
    tmp = _ChannelResult___get_holder__impl__pm9gzw($this).toString();
  } else {
    tmp = 'Value(' + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ')';
  }
  return tmp;
}
function ChannelResult__hashCode_impl_lilec2($this) {
  return $this == null ? 0 : hashCode($this);
}
function ChannelResult__equals_impl_f471ri($this, other) {
  if (!(other instanceof ChannelResult))
    return false;
  var tmp0_other_with_cast = other instanceof ChannelResult ? other.p2b_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function ChannelResult(holder) {
  Companion_getInstance();
  this.p2b_1 = holder;
}
protoOf(ChannelResult).toString = function () {
  return ChannelResult__toString_impl_rrcqu7(this.p2b_1);
};
protoOf(ChannelResult).hashCode = function () {
  return ChannelResult__hashCode_impl_lilec2(this.p2b_1);
};
protoOf(ChannelResult).equals = function (other) {
  return ChannelResult__equals_impl_f471ri(this.p2b_1, other);
};
function ClosedReceiveChannelException(message) {
  NoSuchElementException_init_$Init$(message, this);
  captureStack(this, ClosedReceiveChannelException);
}
function ClosedSendChannelException(message) {
  IllegalStateException_init_$Init$(message, this);
  captureStack(this, ClosedSendChannelException);
}
function ChannelCoroutine(parentContext, _channel, initParentJob, active) {
  AbstractCoroutine.call(this, parentContext, initParentJob, active);
  this.g2d_1 = _channel;
}
protoOf(ChannelCoroutine).o1y = function (cause) {
  if (this.b1y())
    return Unit_instance;
  var tmp;
  if (cause == null) {
    // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
    tmp = new JobCancellationException(null == null ? this.j1x() : null, null, this);
  } else {
    tmp = cause;
  }
  this.q1y(tmp);
};
protoOf(ChannelCoroutine).u2c = function (cause, $super) {
  return this.p1y(cause, ($super == null ? true : $super instanceof ChannelCoroutine) ? $super : THROW_CCE());
};
protoOf(ChannelCoroutine).q1y = function (cause) {
  var exception = this.g1y(cause);
  this.g2d_1.o1y(exception);
  this.t1y(exception);
};
protoOf(ChannelCoroutine).l2c = function (element, $completion) {
  return this.g2d_1.l2c(element, $completion);
};
protoOf(ChannelCoroutine).m2c = function (element) {
  return this.g2d_1.m2c(element);
};
protoOf(ChannelCoroutine).q2c = function (cause) {
  return this.g2d_1.q2c(cause);
};
protoOf(ChannelCoroutine).l = function () {
  return this.g2d_1.l();
};
function cancelConsumed(_this__u8e3s4, cause) {
  var tmp;
  if (cause == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_elvis_lhs = cause instanceof CancellationException ? cause : null;
    tmp = tmp0_elvis_lhs == null ? CancellationException_0('Channel was consumed, consumer had failed', cause) : tmp0_elvis_lhs;
  }
  _this__u8e3s4.o1y(tmp);
}
function trySendImpl($this, element, isSendOp) {
  return $this.u2d_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : $this.o2c(element);
}
function trySendDropLatest($this, element, isSendOp) {
  var result = protoOf(BufferedChannel).m2c.call($this, element);
  if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result))
    return result;
  if (isSendOp) {
    var tmp0_safe_receiver = $this.t28_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp1_safe_receiver;
    }
  }
  return Companion_getInstance().y2a(Unit_instance);
}
function ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement) {
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  BufferedChannel.call(this, capacity, onUndeliveredElement);
  this.t2d_1 = capacity;
  this.u2d_1 = onBufferOverflow;
  // Inline function 'kotlin.require' call
  if (!!(this.u2d_1 === BufferOverflow_SUSPEND_getInstance())) {
    var message = 'This implementation does not support suspension for senders, use ' + getKClass(BufferedChannel).ea() + ' instead';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.t2d_1 >= 1)) {
    var message_0 = 'Buffered channel capacity must be at least 1, but ' + this.t2d_1 + ' was specified';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(ConflatedBufferedChannel).l2b = function () {
  return this.u2d_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
};
protoOf(ConflatedBufferedChannel).l2c = function (element, $completion) {
  // Inline function 'kotlinx.coroutines.channels.onClosed' call
  var this_0 = trySendImpl(this, element, true);
  var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
  if (tmp instanceof Closed) {
    ChannelResult__exceptionOrNull_impl_16ei30(this_0);
    var tmp0_safe_receiver = this.t28_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      addSuppressed(tmp1_safe_receiver, this.s2a());
      throw tmp1_safe_receiver;
    }
    throw this.s2a();
  }
  return Unit_instance;
};
protoOf(ConflatedBufferedChannel).m2c = function (element) {
  return trySendImpl(this, element, false);
};
function produce(_this__u8e3s4, context, capacity, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? 0 : capacity;
  return produce_0(_this__u8e3s4, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
}
function ProducerScope() {
}
function produce_0(_this__u8e3s4, context, capacity, onBufferOverflow, start, onCompletion, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  onCompletion = onCompletion === VOID ? null : onCompletion;
  var channel = Channel(capacity, onBufferOverflow);
  var newContext = newCoroutineContext(_this__u8e3s4, context);
  var coroutine = new ProducerCoroutine(newContext, channel);
  if (!(onCompletion == null)) {
    coroutine.h1y(onCompletion);
  }
  coroutine.t1x(start, coroutine, block);
  return coroutine;
}
function ProducerCoroutine(parentContext, channel) {
  ChannelCoroutine.call(this, parentContext, channel, true, true);
}
protoOf(ProducerCoroutine).g1x = function () {
  return protoOf(ChannelCoroutine).g1x.call(this);
};
protoOf(ProducerCoroutine).z2d = function (value) {
  this.g2d_1.s2c();
};
protoOf(ProducerCoroutine).h1x = function (value) {
  return this.z2d(value instanceof Unit ? value : THROW_CCE());
};
protoOf(ProducerCoroutine).i1x = function (cause, handled) {
  var processed = this.g2d_1.q2c(cause);
  if (!processed && !handled) {
    handleCoroutineException(this.e1x_1, cause);
  }
};
protoOf(ProducerCoroutine).u2c = function (cause, $super) {
  return this.p1y(cause, ($super == null ? true : $super instanceof ProducerCoroutine) ? $super : THROW_CCE());
};
function asFlow(_this__u8e3s4) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new asFlow$$inlined$unsafeFlow$1(_this__u8e3s4);
}
function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.i2e_1 = _this__u8e3s4;
  this.j2e_1 = collector;
}
protoOf($collectCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.k2e_1 = this.j2e_1;
          this.l2e_1 = this.i2e_1.m2e_1.l();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!this.l2e_1.m()) {
            this.d8_1 = 3;
            continue $sm;
          }

          var element = this.l2e_1.n();
          this.d8_1 = 2;
          suspendResult = this.k2e_1.n2e(element, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.d8_1 = 1;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function asFlow$$inlined$unsafeFlow$1($this_asFlow) {
  this.m2e_1 = $this_asFlow;
}
protoOf(asFlow$$inlined$unsafeFlow$1).o2e = function (collector, $completion) {
  var tmp = new $collectCOROUTINE$(this, collector, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(asFlow$$inlined$unsafeFlow$1).p2e = function (collector, $completion) {
  return this.o2e(collector, $completion);
};
function FlowCollector() {
}
function checkOwnership(_this__u8e3s4, owner) {
  if (!(_this__u8e3s4.q2e_1 === owner))
    throw _this__u8e3s4;
}
function firstOrNull(_this__u8e3s4, predicate, $completion) {
  var tmp = new $firstOrNullCOROUTINE$(_this__u8e3s4, predicate, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function $emitCOROUTINE$(_this__u8e3s4, value, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.l2f_1 = _this__u8e3s4;
  this.m2f_1 = value;
}
protoOf($emitCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.o2f_1 = this.m2f_1;
          this.d8_1 = 1;
          suspendResult = this.l2f_1.p2f_1(this.o2f_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          if (suspendResult) {
            var tmp_0 = this;
            this.l2f_1.q2f_1._v = this.o2f_1;
            tmp_0.n2f_1 = false;
            this.d8_1 = 2;
            continue $sm;
          } else {
            var tmp_1 = this;
            tmp_1.n2f_1 = true;
            this.d8_1 = 2;
            continue $sm;
          }

        case 2:
          if (!this.n2f_1) {
            throw new AbortFlowException(this.l2f_1);
          } else {
            this.d8_1 = 3;
            continue $sm;
          }

        case 3:
          return Unit_instance;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 4) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function firstOrNull$$inlined$collectWhile$1($predicate, $result) {
  this.p2f_1 = $predicate;
  this.q2f_1 = $result;
}
protoOf(firstOrNull$$inlined$collectWhile$1).r2f = function (value, $completion) {
  var tmp = new $emitCOROUTINE$(this, value, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(firstOrNull$$inlined$collectWhile$1).n2e = function (value, $completion) {
  return this.r2f((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
};
function $firstOrNullCOROUTINE$(_this__u8e3s4, predicate, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.z2e_1 = _this__u8e3s4;
  this.a2f_1 = predicate;
}
protoOf($firstOrNullCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 4;
          this.b2f_1 = {_v: null};
          var this_0 = this.z2e_1;
          var tmp_0 = this;
          tmp_0.c2f_1 = new firstOrNull$$inlined$collectWhile$1(this.a2f_1, this.b2f_1);
          this.e8_1 = 2;
          this.d8_1 = 1;
          suspendResult = this_0.p2e(this.c2f_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.e8_1 = 4;
          this.d8_1 = 3;
          continue $sm;
        case 2:
          this.e8_1 = 4;
          var tmp_1 = this.g8_1;
          if (tmp_1 instanceof AbortFlowException) {
            var e = this.g8_1;
            checkOwnership(e, this.c2f_1);
            ensureActive(this.j8());
            this.d8_1 = 3;
            continue $sm;
          } else {
            throw this.g8_1;
          }

        case 3:
          this.e8_1 = 4;
          return this.b2f_1._v;
        case 4:
          throw this.g8_1;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.e8_1 === 4) {
        throw e_0;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e_0;
      }
    }
   while (true);
};
function get_CLOSED() {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  return CLOSED;
}
var CLOSED;
function Segment(id, prev, pointers) {
  ConcurrentLinkedListNode.call(this, prev);
  this.i21_1 = id;
  this.j21_1 = atomic$int$1(pointers << 16);
}
protoOf(Segment).h29 = function () {
  return this.j21_1.kotlinx$atomicfu$value === this.j28() && !this.o29();
};
protoOf(Segment).i29 = function () {
  var tmp0 = this.j21_1;
  var tmp$ret$1;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.internal.addConditionally' call
    while (true) {
      var cur = tmp0.kotlinx$atomicfu$value;
      if (!(!(cur === this.j28()) || this.o29())) {
        tmp$ret$1 = false;
        break $l$block_0;
      }
      if (tmp0.atomicfu$compareAndSet(cur, cur + 65536 | 0)) {
        tmp$ret$1 = true;
        break $l$block_0;
      }
    }
  }
  return tmp$ret$1;
};
protoOf(Segment).j29 = function () {
  return this.j21_1.atomicfu$addAndGet(-65536) === this.j28() && !this.o29();
};
protoOf(Segment).g29 = function () {
  if (this.j21_1.atomicfu$incrementAndGet() === this.j28()) {
    this.k3();
  }
};
function close(_this__u8e3s4) {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  var cur = _this__u8e3s4;
  while (true) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    var this_0 = cur;
    // Inline function 'kotlin.let' call
    var it = access$_get_nextOrClosed__ywzond(this_0);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return cur;
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    var next = tmp;
    if (next === null) {
      if (cur.r29())
        return cur;
    } else {
      cur = next;
    }
  }
}
function _SegmentOrClosed___init__impl__jnexvb(value) {
  return value;
}
function _get_value__a43j40($this) {
  return $this;
}
function _SegmentOrClosed___get_isClosed__impl__qmxmlo($this) {
  return _get_value__a43j40($this) === get_CLOSED();
}
function _SegmentOrClosed___get_segment__impl__jvcr9l($this) {
  var tmp;
  if (_get_value__a43j40($this) === get_CLOSED()) {
    var message = 'Does not contain segment';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    var tmp_0 = _get_value__a43j40($this);
    tmp = tmp_0 instanceof Segment ? tmp_0 : THROW_CCE();
  }
  return tmp;
}
function SegmentOrClosed__toString_impl_pzb2an($this) {
  return 'SegmentOrClosed(value=' + toString_0($this) + ')';
}
function SegmentOrClosed__hashCode_impl_4855hs($this) {
  return $this == null ? 0 : hashCode($this);
}
function SegmentOrClosed__equals_impl_6erq1g($this, other) {
  if (!(other instanceof SegmentOrClosed))
    return false;
  var tmp0_other_with_cast = other instanceof SegmentOrClosed ? other.o2b_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function SegmentOrClosed(value) {
  this.o2b_1 = value;
}
protoOf(SegmentOrClosed).toString = function () {
  return SegmentOrClosed__toString_impl_pzb2an(this.o2b_1);
};
protoOf(SegmentOrClosed).hashCode = function () {
  return SegmentOrClosed__hashCode_impl_4855hs(this.o2b_1);
};
protoOf(SegmentOrClosed).equals = function (other) {
  return SegmentOrClosed__equals_impl_6erq1g(this.o2b_1, other);
};
function _get_nextOrClosed__w0gmuv($this) {
  return $this.k29_1.kotlinx$atomicfu$value;
}
function _get_aliveSegmentLeft__mr4ndu($this) {
  var cur = $this.p29();
  while (!(cur === null) && cur.h29())
    cur = cur.l29_1.kotlinx$atomicfu$value;
  return cur;
}
function _get_aliveSegmentRight__7ulr0b($this) {
  // Inline function 'kotlinx.coroutines.assert' call
  var cur = ensureNotNull($this.m29());
  while (cur.h29()) {
    var tmp0_elvis_lhs = cur.m29();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return cur;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    cur = tmp;
  }
  return cur;
}
function access$_get_nextOrClosed__ywzond($this) {
  return _get_nextOrClosed__w0gmuv($this);
}
function ConcurrentLinkedListNode(prev) {
  this.k29_1 = atomic$ref$1(null);
  this.l29_1 = atomic$ref$1(prev);
}
protoOf(ConcurrentLinkedListNode).m29 = function () {
  // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
  // Inline function 'kotlin.let' call
  var it = access$_get_nextOrClosed__ywzond(this);
  var tmp;
  if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
    return null;
  } else {
    tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
  }
  return tmp;
};
protoOf(ConcurrentLinkedListNode).n29 = function (value) {
  return this.k29_1.atomicfu$compareAndSet(null, value);
};
protoOf(ConcurrentLinkedListNode).o29 = function () {
  return this.m29() == null;
};
protoOf(ConcurrentLinkedListNode).p29 = function () {
  return this.l29_1.kotlinx$atomicfu$value;
};
protoOf(ConcurrentLinkedListNode).q29 = function () {
  // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
  this.l29_1.kotlinx$atomicfu$value = null;
};
protoOf(ConcurrentLinkedListNode).r29 = function () {
  return this.k29_1.atomicfu$compareAndSet(null, get_CLOSED());
};
protoOf(ConcurrentLinkedListNode).k3 = function () {
  // Inline function 'kotlinx.coroutines.assert' call
  if (this.o29())
    return Unit_instance;
  $l$loop_0: while (true) {
    var prev = _get_aliveSegmentLeft__mr4ndu(this);
    var next = _get_aliveSegmentRight__7ulr0b(this);
    var tmp0 = next.l29_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        var upd = cur === null ? null : prev;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    if (!(prev === null))
      prev.k29_1.kotlinx$atomicfu$value = next;
    if (next.h29() && !next.o29())
      continue $l$loop_0;
    if (!(prev === null) && prev.h29())
      continue $l$loop_0;
    return Unit_instance;
  }
};
function findSegmentInternal(_this__u8e3s4, id, createNewSegment) {
  _init_properties_ConcurrentLinkedList_kt__5gcgzy();
  var cur = _this__u8e3s4;
  $l$loop: while (cur.i21_1 < id || cur.h29()) {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    var this_0 = cur;
    // Inline function 'kotlin.let' call
    var it = access$_get_nextOrClosed__ywzond(this_0);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return _SegmentOrClosed___init__impl__jnexvb(get_CLOSED());
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    var next = tmp;
    if (!(next == null)) {
      cur = next;
      continue $l$loop;
    }
    // Inline function 'kotlin.Long.plus' call
    var this_1 = cur.i21_1;
    var newTail = createNewSegment(add(this_1, fromInt(1)), cur);
    if (cur.n29(newTail)) {
      if (cur.h29()) {
        cur.k3();
      }
      cur = newTail;
    }
  }
  return _SegmentOrClosed___init__impl__jnexvb(cur);
}
function access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy() {
  return get_CLOSED();
}
var properties_initialized_ConcurrentLinkedList_kt_kwt434;
function _init_properties_ConcurrentLinkedList_kt__5gcgzy() {
  if (!properties_initialized_ConcurrentLinkedList_kt_kwt434) {
    properties_initialized_ConcurrentLinkedList_kt_kwt434 = true;
    CLOSED = new Symbol('CLOSED');
  }
}
function handleUncaughtCoroutineException(context, exception) {
  var _iterator__ex2g4s = get_platformExceptionHandlers().l();
  while (_iterator__ex2g4s.m()) {
    var handler = _iterator__ex2g4s.n();
    try {
      handler.h24(context, exception);
    } catch ($p) {
      if ($p instanceof ExceptionSuccessfullyProcessed) {
        var _unused_var__etf5q3 = $p;
        return Unit_instance;
      } else {
        if ($p instanceof Error) {
          var t = $p;
          propagateExceptionFinalResort(handlerException(exception, t));
        } else {
          throw $p;
        }
      }
    }
  }
  try {
    addSuppressed(exception, new DiagnosticCoroutineContextException(context));
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  propagateExceptionFinalResort(exception);
}
function ExceptionSuccessfullyProcessed() {
}
function get_UNDEFINED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return UNDEFINED;
}
var UNDEFINED;
function get_REUSABLE_CLAIMED() {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  return REUSABLE_CLAIMED;
}
var REUSABLE_CLAIMED;
function resumeCancellableWith(_this__u8e3s4, result) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  var tmp;
  if (_this__u8e3s4 instanceof DispatchedContinuation) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith' call
    var state = toState_0(result);
    if (safeIsDispatchNeeded(_this__u8e3s4.v20_1, _this__u8e3s4.j8())) {
      _this__u8e3s4.x20_1 = state;
      _this__u8e3s4.e21_1 = 1;
      safeDispatch(_this__u8e3s4.v20_1, _this__u8e3s4.j8(), _this__u8e3s4);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().d25();
        if (false && eventLoop.y24()) {
          break $l$block;
        }
        var tmp_0;
        if (eventLoop.x24()) {
          _this__u8e3s4.x20_1 = state;
          _this__u8e3s4.e21_1 = 1;
          eventLoop.w24(_this__u8e3s4);
          tmp_0 = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.z24(true);
          try {
            var tmp$ret$4;
            $l$block_0: {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
              var job = _this__u8e3s4.j8().q8(Key_instance_3);
              if (!(job == null) && !job.g1x()) {
                var cause = job.e1y();
                _this__u8e3s4.y21(state, cause);
                // Inline function 'kotlin.coroutines.resumeWithException' call
                // Inline function 'kotlin.Companion.failure' call
                var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(cause));
                _this__u8e3s4.o8(tmp$ret$2);
                tmp$ret$4 = true;
                break $l$block_0;
              }
              tmp$ret$4 = false;
            }
            if (!tmp$ret$4) {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
              _this__u8e3s4.w20_1;
              // Inline function 'kotlinx.coroutines.withContinuationContext' call
              _this__u8e3s4.y20_1;
              _this__u8e3s4.w20_1.o8(result);
            }
            $l$loop: while (eventLoop.v24()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              _this__u8e3s4.t22(e);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.a25(true);
          }
          tmp_0 = false;
        }
      }
    }
    tmp = Unit_instance;
  } else {
    _this__u8e3s4.o8(result);
    tmp = Unit_instance;
  }
  return tmp;
}
function _get_reusableCancellableContinuation__9qex09($this) {
  var tmp = $this.z20_1.kotlinx$atomicfu$value;
  return tmp instanceof CancellableContinuationImpl ? tmp : null;
}
function DispatchedContinuation(dispatcher, continuation) {
  DispatchedTask.call(this, -1);
  this.v20_1 = dispatcher;
  this.w20_1 = continuation;
  this.x20_1 = get_UNDEFINED();
  this.y20_1 = threadContextElements(this.j8());
  this.z20_1 = atomic$ref$1(null);
}
protoOf(DispatchedContinuation).d21 = function () {
  return !(this.z20_1.kotlinx$atomicfu$value == null);
};
protoOf(DispatchedContinuation).s2f = function () {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.z20_1;
  while (true) {
    if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED()))
      return Unit_instance;
  }
};
protoOf(DispatchedContinuation).f24 = function () {
  this.s2f();
  var tmp0_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.u21();
  }
};
protoOf(DispatchedContinuation).a21 = function () {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.z20_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (state === null) {
      this.z20_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
      return null;
    } else {
      if (state instanceof CancellableContinuationImpl) {
        if (this.z20_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) {
          return state instanceof CancellableContinuationImpl ? state : THROW_CCE();
        }
      } else {
        if (state !== get_REUSABLE_CLAIMED()) {
          if (!(state instanceof Error)) {
            // Inline function 'kotlin.error' call
            var message = 'Inconsistent state ' + toString_0(state);
            throw IllegalStateException_init_$Create$(toString(message));
          }
        }
      }
    }
  }
};
protoOf(DispatchedContinuation).h22 = function (continuation) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.z20_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (state === get_REUSABLE_CLAIMED()) {
      if (this.z20_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation))
        return null;
    } else {
      if (state instanceof Error) {
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!this.z20_1.atomicfu$compareAndSet(state, null)) {
          var message = 'Failed requirement.';
          throw IllegalArgumentException_init_$Create$(toString(message));
        }
        return state;
      } else {
        // Inline function 'kotlin.error' call
        var message_0 = 'Inconsistent state ' + toString_0(state);
        throw IllegalStateException_init_$Create$(toString(message_0));
      }
    }
  }
};
protoOf(DispatchedContinuation).f21 = function (cause) {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.z20_1;
  while (true) {
    var state = this_0.kotlinx$atomicfu$value;
    if (equals(state, get_REUSABLE_CLAIMED())) {
      if (this.z20_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause))
        return true;
    } else {
      if (state instanceof Error)
        return true;
      else {
        if (this.z20_1.atomicfu$compareAndSet(state, null))
          return false;
      }
    }
  }
};
protoOf(DispatchedContinuation).x21 = function () {
  var state = this.x20_1;
  // Inline function 'kotlinx.coroutines.assert' call
  this.x20_1 = get_UNDEFINED();
  return state;
};
protoOf(DispatchedContinuation).v21 = function () {
  return this;
};
protoOf(DispatchedContinuation).o8 = function (result) {
  var state = toState_0(result);
  if (safeIsDispatchNeeded(this.v20_1, this.j8())) {
    this.x20_1 = state;
    this.e21_1 = 0;
    safeDispatch(this.v20_1, this.j8(), this);
  } else {
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
      // Inline function 'kotlinx.coroutines.assert' call
      var eventLoop = ThreadLocalEventLoop_getInstance().d25();
      if (false && eventLoop.y24()) {
        break $l$block;
      }
      var tmp;
      if (eventLoop.x24()) {
        this.x20_1 = state;
        this.e21_1 = 0;
        eventLoop.w24(this);
        tmp = true;
      } else {
        // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
        eventLoop.z24(true);
        try {
          this.j8();
          // Inline function 'kotlinx.coroutines.withCoroutineContext' call
          this.y20_1;
          this.w20_1.o8(result);
          $l$loop: while (eventLoop.v24()) {
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            this.t22(e);
          } else {
            throw $p;
          }
        }
        finally {
          eventLoop.a25(true);
        }
        tmp = false;
      }
    }
  }
};
protoOf(DispatchedContinuation).toString = function () {
  return 'DispatchedContinuation[' + this.v20_1.toString() + ', ' + toDebugString(this.w20_1) + ']';
};
protoOf(DispatchedContinuation).j8 = function () {
  return this.w20_1.j8();
};
function safeDispatch(_this__u8e3s4, context, runnable) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    _this__u8e3s4.e24(context, runnable);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw new DispatchException(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
function safeIsDispatchNeeded(_this__u8e3s4, context) {
  _init_properties_DispatchedContinuation_kt__tnmqc0();
  try {
    return _this__u8e3s4.d24(context);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      throw new DispatchException(e, _this__u8e3s4, context);
    } else {
      throw $p;
    }
  }
}
var properties_initialized_DispatchedContinuation_kt_2siadq;
function _init_properties_DispatchedContinuation_kt__tnmqc0() {
  if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
    properties_initialized_DispatchedContinuation_kt_2siadq = true;
    UNDEFINED = new Symbol('UNDEFINED');
    REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
  }
}
function DispatchedTask(resumeMode) {
  SchedulerTask.call(this);
  this.e21_1 = resumeMode;
}
protoOf(DispatchedTask).y21 = function (takenState, cause) {
};
protoOf(DispatchedTask).g22 = function (state) {
  return (state == null ? true : !(state == null)) ? state : THROW_CCE();
};
protoOf(DispatchedTask).q22 = function (state) {
  var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l1x_1;
};
protoOf(DispatchedTask).s22 = function () {
  // Inline function 'kotlinx.coroutines.assert' call
  try {
    var tmp = this.v21();
    var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
    var continuation = delegate.w20_1;
    // Inline function 'kotlinx.coroutines.withContinuationContext' call
    delegate.y20_1;
    var context = continuation.j8();
    var state = this.x21();
    var exception = this.q22(state);
    var job = exception == null && get_isCancellableMode(this.e21_1) ? context.q8(Key_instance_3) : null;
    if (!(job == null) && !job.g1x()) {
      var cause = job.e1y();
      this.y21(state, cause);
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      // Inline function 'kotlin.Companion.failure' call
      var exception_0 = recoverStackTrace(cause, continuation);
      var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception_0));
      continuation.o8(tmp$ret$1);
    } else {
      if (!(exception == null)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
        continuation.o8(tmp$ret$3);
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = this.g22(state);
        var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
        continuation.o8(tmp$ret$5);
      }
    }
  } catch ($p) {
    if ($p instanceof DispatchException) {
      var e = $p;
      handleCoroutineException(this.v21().j8(), e.g24_1);
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.t22(e_0);
      } else {
        throw $p;
      }
    }
  }
};
protoOf(DispatchedTask).t22 = function (exception) {
  var reason = new CoroutinesInternalError('Fatal exception in coroutines machinery for ' + toString(this) + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", exception);
  handleCoroutineException(this.v21().j8(), reason);
};
function get_isReusableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 2;
}
function get_isCancellableMode(_this__u8e3s4) {
  return _this__u8e3s4 === 1 || _this__u8e3s4 === 2;
}
function dispatch(_this__u8e3s4, mode) {
  // Inline function 'kotlinx.coroutines.assert' call
  var delegate = _this__u8e3s4.v21();
  var undispatched = mode === 4;
  var tmp;
  var tmp_0;
  if (!undispatched) {
    tmp_0 = delegate instanceof DispatchedContinuation;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = get_isCancellableMode(mode) === get_isCancellableMode(_this__u8e3s4.e21_1);
  } else {
    tmp = false;
  }
  if (tmp) {
    var dispatcher = delegate.v20_1;
    var context = delegate.j8();
    if (safeIsDispatchNeeded(dispatcher, context)) {
      safeDispatch(dispatcher, context, _this__u8e3s4);
    } else {
      resumeUnconfined(_this__u8e3s4);
    }
  } else {
    resume(_this__u8e3s4, delegate, undispatched);
  }
}
function DispatchException(cause, dispatcher, context) {
  Exception_init_$Init$('Coroutine dispatcher ' + dispatcher.toString() + ' threw an exception, context = ' + toString(context), cause, this);
  captureStack(this, DispatchException);
  this.g24_1 = cause;
  delete this.cause;
}
protoOf(DispatchException).f = function () {
  return this.g24_1;
};
function resumeUnconfined(_this__u8e3s4) {
  var eventLoop = ThreadLocalEventLoop_getInstance().d25();
  if (eventLoop.x24()) {
    eventLoop.w24(_this__u8e3s4);
  } else {
    // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
    eventLoop.z24(true);
    try {
      resume(_this__u8e3s4, _this__u8e3s4.v21(), true);
      $l$loop: while (eventLoop.v24()) {
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        _this__u8e3s4.t22(e);
      } else {
        throw $p;
      }
    }
    finally {
      eventLoop.a25(true);
    }
  }
}
function resume(_this__u8e3s4, delegate, undispatched) {
  var state = _this__u8e3s4.x21();
  var exception = _this__u8e3s4.q22(state);
  var tmp;
  if (!(exception == null)) {
    // Inline function 'kotlin.Companion.failure' call
    tmp = _Result___init__impl__xyqfz8(createFailure(exception));
  } else {
    // Inline function 'kotlin.Companion.success' call
    var value = _this__u8e3s4.g22(state);
    tmp = _Result___init__impl__xyqfz8(value);
  }
  var result = tmp;
  if (undispatched) {
    // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
    var this_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
    this_0.w20_1;
    // Inline function 'kotlinx.coroutines.withContinuationContext' call
    this_0.y20_1;
    this_0.w20_1.o8(result);
  } else {
    delegate.o8(result);
  }
}
function _InlineList___init__impl__z8n56(holder) {
  holder = holder === VOID ? null : holder;
  return holder;
}
function _get_holder__f6h5pd($this) {
  return $this;
}
function InlineList__plus_impl_nuetvo($this, element) {
  // Inline function 'kotlinx.coroutines.assert' call
  var tmp0_subject = _get_holder__f6h5pd($this);
  var tmp;
  if (tmp0_subject == null) {
    tmp = _InlineList___init__impl__z8n56(element);
  } else {
    if (tmp0_subject instanceof ArrayList) {
      var tmp_0 = _get_holder__f6h5pd($this);
      (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).j(element);
      tmp = _InlineList___init__impl__z8n56(_get_holder__f6h5pd($this));
    } else {
      var list = ArrayList_init_$Create$(4);
      var tmp_1 = _get_holder__f6h5pd($this);
      list.j((tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE());
      list.j(element);
      tmp = _InlineList___init__impl__z8n56(list);
    }
  }
  return tmp;
}
function access$_get_holder__kkflen($this) {
  return _get_holder__f6h5pd($this);
}
function callUndeliveredElement(_this__u8e3s4, element, context) {
  var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this__u8e3s4, element, null);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    handleCoroutineException(context, tmp0_safe_receiver);
  }
}
function UndeliveredElementException(message, cause) {
  RuntimeException_init_$Init$(message, cause, this);
  captureStack(this, UndeliveredElementException);
}
function callUndeliveredElementCatchingException(_this__u8e3s4, element, undeliveredElementException) {
  undeliveredElementException = undeliveredElementException === VOID ? null : undeliveredElementException;
  try {
    _this__u8e3s4(element);
  } catch ($p) {
    if ($p instanceof Error) {
      var ex = $p;
      if (!(undeliveredElementException == null) && !(undeliveredElementException.cause === ex)) {
        addSuppressed(undeliveredElementException, ex);
      } else {
        return new UndeliveredElementException('Exception in undelivered element handler for ' + toString_0(element), ex);
      }
    } else {
      throw $p;
    }
  }
  return undeliveredElementException;
}
function ContextScope(context) {
  this.t2f_1 = context;
}
protoOf(ContextScope).f1x = function () {
  return this.t2f_1;
};
protoOf(ContextScope).toString = function () {
  return 'CoroutineScope(coroutineContext=' + toString(this.t2f_1) + ')';
};
function Symbol(symbol) {
  this.u2f_1 = symbol;
}
protoOf(Symbol).toString = function () {
  return '<' + this.u2f_1 + '>';
};
function systemProp(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? 1 : minValue;
  maxValue = maxValue === VOID ? 2147483647 : maxValue;
  return convertToInt(systemProp_0(propertyName, fromInt(defaultValue), fromInt(minValue), fromInt(maxValue)));
}
function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
  minValue = minValue === VOID ? 1n : minValue;
  maxValue = maxValue === VOID ? 9223372036854775807n : maxValue;
  var tmp0_elvis_lhs = systemProp_1(propertyName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return defaultValue;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var value = tmp;
  var tmp1_elvis_lhs = toLongOrNull(value);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var message = "System property '" + propertyName + "' has unrecognized value '" + value + "'";
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var parsed = tmp_0;
  if (!(minValue <= parsed ? parsed <= maxValue : false)) {
    // Inline function 'kotlin.error' call
    var message_0 = "System property '" + propertyName + "' should be in range " + minValue.toString() + '..' + maxValue.toString() + ", but is '" + parsed.toString() + "'";
    throw IllegalStateException_init_$Create$(toString(message_0));
  }
  return parsed;
}
function startCoroutineCancellable(_this__u8e3s4, completion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(createCoroutineUnintercepted_0(_this__u8e3s4, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp, tmp$ret$0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(completion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function startCoroutineCancellable_0(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp, tmp$ret$0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(completion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function startCoroutineCancellable_1(_this__u8e3s4, fatalCompletion) {
  // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
  try {
    var tmp = intercepted(_this__u8e3s4);
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    resumeCancellableWith(tmp, tmp$ret$0);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      dispatcherFailure(fatalCompletion, e);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function dispatcherFailure(completion, e) {
  var tmp;
  if (e instanceof DispatchException) {
    tmp = e.g24_1;
  } else {
    tmp = e;
  }
  var reportException = tmp;
  // Inline function 'kotlin.Companion.failure' call
  var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(reportException));
  completion.o8(tmp$ret$0);
  throw reportException;
}
function startCoroutineUndispatched(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlinx.coroutines.internal.probeCoroutineCreated' call
  var actualCompletion = completion;
  var tmp;
  try {
    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
    actualCompletion.j8();
    // Inline function 'kotlinx.coroutines.internal.probeCoroutineResumed' call
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(_this__u8e3s4, receiver, actualCompletion);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      var tmp_1;
      if (e instanceof DispatchException) {
        tmp_1 = e.g24_1;
      } else {
        tmp_1 = e;
      }
      var reportException = tmp_1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(reportException));
      actualCompletion.o8(tmp$ret$5);
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  var value = tmp;
  if (!(value === get_COROUTINE_SUSPENDED())) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
    var tmp$ret$7 = _Result___init__impl__xyqfz8(value_0);
    actualCompletion.o8(tmp$ret$7);
  }
}
var DUMMY_PROCESS_RESULT_FUNCTION;
function get_STATE_REG() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_REG;
}
var STATE_REG;
function get_STATE_COMPLETED() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_COMPLETED;
}
var STATE_COMPLETED;
function get_STATE_CANCELLED() {
  _init_properties_Select_kt__zhm2jg();
  return STATE_CANCELLED;
}
var STATE_CANCELLED;
function get_NO_RESULT() {
  _init_properties_Select_kt__zhm2jg();
  return NO_RESULT;
}
var NO_RESULT;
var PARAM_CLAUSE_0;
function SelectInstance() {
}
function trySelectInternal($this, clauseObject, internalResult) {
  $l$loop: while (true) {
    var curState = $this.d2b_1.kotlinx$atomicfu$value;
    if (isInterface(curState, CancellableContinuation)) {
      var tmp0_elvis_lhs = findClause($this, clauseObject);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var clause = tmp;
      var onCancellation = clause.z2f($this, internalResult);
      if ($this.d2b_1.atomicfu$compareAndSet(curState, clause)) {
        var cont = isInterface(curState, CancellableContinuation) ? curState : THROW_CCE();
        $this.f2b_1 = internalResult;
        if (tryResume_0(cont, onCancellation))
          return 0;
        $this.f2b_1 = get_NO_RESULT();
        return 2;
      }
    } else {
      var tmp_0;
      if (equals(curState, get_STATE_COMPLETED())) {
        tmp_0 = true;
      } else {
        tmp_0 = curState instanceof ClauseData;
      }
      if (tmp_0)
        return 3;
      else {
        if (equals(curState, get_STATE_CANCELLED()))
          return 2;
        else {
          if (equals(curState, get_STATE_REG())) {
            if ($this.d2b_1.atomicfu$compareAndSet(curState, listOf_0(clauseObject)))
              return 1;
          } else {
            if (isInterface(curState, KtList)) {
              if ($this.d2b_1.atomicfu$compareAndSet(curState, plus_0(curState, clauseObject)))
                return 1;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Unexpected state: ' + toString(curState);
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
      }
    }
  }
}
function findClause($this, clauseObject) {
  var tmp0_elvis_lhs = $this.e2b_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var clauses = tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = clauses.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      if (element.w2f_1 === clauseObject) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var message = 'Clause with object ' + toString(clauseObject) + ' is not found';
    throw IllegalStateException_init_$Create$(toString(message));
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
function ClauseData() {
}
protoOf(ClauseData).z2f = function (select, internalResult) {
  var tmp0_safe_receiver = this.y2f_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(select, this.x2f_1, internalResult);
};
function SelectImplementation() {
}
protoOf(SelectImplementation).g2b = function (clauseObject, result) {
  return TrySelectDetailedResult_0(trySelectInternal(this, clauseObject, result));
};
var TrySelectDetailedResult_SUCCESSFUL_instance;
var TrySelectDetailedResult_REREGISTER_instance;
var TrySelectDetailedResult_CANCELLED_instance;
var TrySelectDetailedResult_ALREADY_SELECTED_instance;
var TrySelectDetailedResult_entriesInitialized;
function TrySelectDetailedResult_initEntries() {
  if (TrySelectDetailedResult_entriesInitialized)
    return Unit_instance;
  TrySelectDetailedResult_entriesInitialized = true;
  TrySelectDetailedResult_SUCCESSFUL_instance = new TrySelectDetailedResult('SUCCESSFUL', 0);
  TrySelectDetailedResult_REREGISTER_instance = new TrySelectDetailedResult('REREGISTER', 1);
  TrySelectDetailedResult_CANCELLED_instance = new TrySelectDetailedResult('CANCELLED', 2);
  TrySelectDetailedResult_ALREADY_SELECTED_instance = new TrySelectDetailedResult('ALREADY_SELECTED', 3);
}
function TrySelectDetailedResult(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TrySelectDetailedResult_0(trySelectInternalResult) {
  _init_properties_Select_kt__zhm2jg();
  var tmp;
  switch (trySelectInternalResult) {
    case 0:
      tmp = TrySelectDetailedResult_SUCCESSFUL_getInstance();
      break;
    case 1:
      tmp = TrySelectDetailedResult_REREGISTER_getInstance();
      break;
    case 2:
      tmp = TrySelectDetailedResult_CANCELLED_getInstance();
      break;
    case 3:
      tmp = TrySelectDetailedResult_ALREADY_SELECTED_getInstance();
      break;
    default:
      var message = 'Unexpected internal result: ' + trySelectInternalResult;
      throw IllegalStateException_init_$Create$(toString(message));
  }
  return tmp;
}
function tryResume_0(_this__u8e3s4, onCancellation) {
  _init_properties_Select_kt__zhm2jg();
  var tmp0_elvis_lhs = _this__u8e3s4.f20(Unit_instance, null, onCancellation);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var token = tmp;
  _this__u8e3s4.g20(token);
  return true;
}
function DUMMY_PROCESS_RESULT_FUNCTION$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
  _init_properties_Select_kt__zhm2jg();
  return null;
}
function TrySelectDetailedResult_SUCCESSFUL_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_SUCCESSFUL_instance;
}
function TrySelectDetailedResult_REREGISTER_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_REREGISTER_instance;
}
function TrySelectDetailedResult_CANCELLED_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_CANCELLED_instance;
}
function TrySelectDetailedResult_ALREADY_SELECTED_getInstance() {
  TrySelectDetailedResult_initEntries();
  return TrySelectDetailedResult_ALREADY_SELECTED_instance;
}
var properties_initialized_Select_kt_7rpl36;
function _init_properties_Select_kt__zhm2jg() {
  if (!properties_initialized_Select_kt_7rpl36) {
    properties_initialized_Select_kt_7rpl36 = true;
    DUMMY_PROCESS_RESULT_FUNCTION = DUMMY_PROCESS_RESULT_FUNCTION$lambda;
    STATE_REG = new Symbol('STATE_REG');
    STATE_COMPLETED = new Symbol('STATE_COMPLETED');
    STATE_CANCELLED = new Symbol('STATE_CANCELLED');
    NO_RESULT = new Symbol('NO_RESULT');
    PARAM_CLAUSE_0 = new Symbol('PARAM_CLAUSE_0');
  }
}
function get_NO_OWNER() {
  _init_properties_Mutex_kt__jod56b();
  return NO_OWNER;
}
var NO_OWNER;
var ON_LOCK_ALREADY_LOCKED_BY_OWNER;
function Mutex(locked) {
  locked = locked === VOID ? false : locked;
  _init_properties_Mutex_kt__jod56b();
  return new MutexImpl(locked);
}
function MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this$0, this$1) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    // Inline function 'kotlinx.coroutines.assert' call
    this$0.h2g_1.kotlinx$atomicfu$value = this$1.k2g_1;
    this$0.m2g(this$1.k2g_1);
    return Unit_instance;
  };
}
function MutexImpl$CancellableContinuationWithOwner$resume$lambda(this$0, this$1) {
  return function (it) {
    this$0.m2g(this$1.k2g_1);
    return Unit_instance;
  };
}
function holdsLockImpl($this, owner) {
  $l$loop: while (true) {
    if (!$this.n2g())
      return 0;
    var curOwner = $this.h2g_1.kotlinx$atomicfu$value;
    if (curOwner === get_NO_OWNER())
      continue $l$loop;
    return curOwner === owner ? 1 : 2;
  }
}
function lockSuspend($this, owner, $completion) {
  var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
  try {
    var contWithOwner = new CancellableContinuationWithOwner($this, cancellable, owner);
    $this.acquireCont(contWithOwner);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cancellable.f22();
      throw e;
    } else {
      throw $p;
    }
  }
  return cancellable.e22();
}
function tryLockImpl($this, owner) {
  $l$loop: while (true) {
    if ($this.v2g()) {
      // Inline function 'kotlinx.coroutines.assert' call
      $this.h2g_1.kotlinx$atomicfu$value = owner;
      return 0;
    } else {
      if (owner == null)
        return 1;
      switch (holdsLockImpl($this, owner)) {
        case 1:
          return 2;
        case 2:
          return 1;
        case 0:
          continue $l$loop;
      }
    }
  }
}
function CancellableContinuationWithOwner($outer, cont, owner) {
  this.l2g_1 = $outer;
  this.j2g_1 = cont;
  this.k2g_1 = owner;
}
protoOf(CancellableContinuationWithOwner).w2g = function (value, idempotent, onCancellation) {
  // Inline function 'kotlinx.coroutines.assert' call
  var token = this.j2g_1.f20(value, idempotent, MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this.l2g_1, this));
  if (!(token == null)) {
    // Inline function 'kotlinx.coroutines.assert' call
    this.l2g_1.h2g_1.kotlinx$atomicfu$value = this.k2g_1;
  }
  return token;
};
protoOf(CancellableContinuationWithOwner).f20 = function (value, idempotent, onCancellation) {
  return this.w2g(value instanceof Unit ? value : THROW_CCE(), idempotent, onCancellation);
};
protoOf(CancellableContinuationWithOwner).x2g = function (value, onCancellation) {
  // Inline function 'kotlinx.coroutines.assert' call
  this.l2g_1.h2g_1.kotlinx$atomicfu$value = this.k2g_1;
  this.j2g_1.j22(Unit_instance, MutexImpl$CancellableContinuationWithOwner$resume$lambda(this.l2g_1, this));
};
protoOf(CancellableContinuationWithOwner).j20 = function (value, onCancellation) {
  return this.x2g(value instanceof Unit ? value : THROW_CCE(), onCancellation);
};
protoOf(CancellableContinuationWithOwner).b1y = function () {
  return this.j2g_1.b1y();
};
protoOf(CancellableContinuationWithOwner).g20 = function (token) {
  this.j2g_1.g20(token);
};
protoOf(CancellableContinuationWithOwner).h20 = function (handler) {
  this.j2g_1.h20(handler);
};
protoOf(CancellableContinuationWithOwner).l22 = function (segment, index) {
  this.j2g_1.l22(segment, index);
};
protoOf(CancellableContinuationWithOwner).y2g = function (_this__u8e3s4, value) {
  this.j2g_1.i20(_this__u8e3s4, Unit_instance);
};
protoOf(CancellableContinuationWithOwner).i20 = function (_this__u8e3s4, value) {
  return this.y2g(_this__u8e3s4, value instanceof Unit ? value : THROW_CCE());
};
protoOf(CancellableContinuationWithOwner).gg = function (result) {
  this.j2g_1.o8(result);
};
protoOf(CancellableContinuationWithOwner).o8 = function (result) {
  return this.gg(result);
};
protoOf(CancellableContinuationWithOwner).j8 = function () {
  return this.j2g_1.j8();
};
function MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, $owner) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.m2g($owner);
    return Unit_instance;
  };
}
function MutexImpl$onSelectCancellationUnlockConstructor$lambda(this$0) {
  return function (_unused_var__etf5q3, owner, _unused_var__etf5q3_0) {
    return MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, owner);
  };
}
function MutexImpl(locked) {
  SemaphoreAndMutexImpl.call(this, 1, locked ? 1 : 0);
  this.h2g_1 = atomic$ref$1(locked ? null : get_NO_OWNER());
  var tmp = this;
  tmp.i2g_1 = MutexImpl$onSelectCancellationUnlockConstructor$lambda(this);
}
protoOf(MutexImpl).n2g = function () {
  return this.z2g() === 0;
};
protoOf(MutexImpl).a2h = function (owner, $completion) {
  if (this.b2h(owner))
    return Unit_instance;
  return lockSuspend(this, owner, $completion);
};
protoOf(MutexImpl).b2h = function (owner) {
  var tmp;
  switch (tryLockImpl(this, owner)) {
    case 0:
      tmp = true;
      break;
    case 1:
      tmp = false;
      break;
    case 2:
      var message = 'This mutex is already locked by the specified owner: ' + toString_0(owner);
      throw IllegalStateException_init_$Create$(toString(message));
    default:
      var message_0 = 'unexpected';
      throw IllegalStateException_init_$Create$(toString(message_0));
  }
  return tmp;
};
protoOf(MutexImpl).m2g = function (owner) {
  $l$loop_0: while (true) {
    // Inline function 'kotlin.check' call
    if (!this.n2g()) {
      var message = 'This mutex is not locked';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var curOwner = this.h2g_1.kotlinx$atomicfu$value;
    if (curOwner === get_NO_OWNER())
      continue $l$loop_0;
    // Inline function 'kotlin.check' call
    if (!(curOwner === owner || owner == null)) {
      var message_0 = 'This mutex is locked by ' + toString_0(curOwner) + ', but ' + toString_0(owner) + ' is expected';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    if (!this.h2g_1.atomicfu$compareAndSet(curOwner, get_NO_OWNER()))
      continue $l$loop_0;
    this.b1a();
    return Unit_instance;
  }
};
protoOf(MutexImpl).toString = function () {
  return 'Mutex@' + get_hexAddress(this) + '[isLocked=' + this.n2g() + ',owner=' + toString_0(this.h2g_1.kotlinx$atomicfu$value) + ']';
};
var properties_initialized_Mutex_kt_yv4p3j;
function _init_properties_Mutex_kt__jod56b() {
  if (!properties_initialized_Mutex_kt_yv4p3j) {
    properties_initialized_Mutex_kt_yv4p3j = true;
    NO_OWNER = new Symbol('NO_OWNER');
    ON_LOCK_ALREADY_LOCKED_BY_OWNER = new Symbol('ALREADY_LOCKED_BY_OWNER');
  }
}
function get_MAX_SPIN_CYCLES() {
  _init_properties_Semaphore_kt__t514r6();
  return MAX_SPIN_CYCLES;
}
var MAX_SPIN_CYCLES;
function get_PERMIT() {
  _init_properties_Semaphore_kt__t514r6();
  return PERMIT;
}
var PERMIT;
function get_TAKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return TAKEN;
}
var TAKEN;
function get_BROKEN() {
  _init_properties_Semaphore_kt__t514r6();
  return BROKEN;
}
var BROKEN;
function get_CANCELLED() {
  _init_properties_Semaphore_kt__t514r6();
  return CANCELLED;
}
var CANCELLED;
function get_SEGMENT_SIZE_0() {
  _init_properties_Semaphore_kt__t514r6();
  return SEGMENT_SIZE_0;
}
var SEGMENT_SIZE_0;
function decPermits($this) {
  $l$loop: while (true) {
    var p = $this.t2g_1.atomicfu$getAndDecrement();
    if (p > $this.o2g_1)
      continue $l$loop;
    return p;
  }
}
function coerceAvailablePermitsAtMaximum($this) {
  $l$loop_0: while (true) {
    var cur = $this.t2g_1.kotlinx$atomicfu$value;
    if (cur <= $this.o2g_1)
      break $l$loop_0;
    if ($this.t2g_1.atomicfu$compareAndSet(cur, $this.o2g_1))
      break $l$loop_0;
  }
}
function addAcquireToQueue($this, waiter) {
  var curTail = $this.r2g_1.kotlinx$atomicfu$value;
  var enqIdx = $this.s2g_1.atomicfu$getAndIncrement$long();
  var createNewSegment = createSegment$ref_0();
  var tmp0 = $this.r2g_1;
  // Inline function 'kotlin.Long.div' call
  var other = get_SEGMENT_SIZE_0();
  var tmp2 = divide(enqIdx, fromInt(other));
  var tmp$ret$3;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(curTail, tmp2, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2_0 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.i21_1 >= tmp2_0.i21_1) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2_0.i29()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2_0)) {
              if (cur.j29()) {
                cur.k3();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2_0.j29()) {
              tmp2_0.k3();
            }
          }
          tmp$ret$1 = Unit_instance;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$3 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$3);
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE_0();
  var tmp$ret$4 = modulo(enqIdx, fromInt(other_0));
  var i = convertToInt(tmp$ret$4);
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  if (segment.g2h_1.atomicfu$get(i).atomicfu$compareAndSet(null, waiter)) {
    waiter.l22(segment, i);
    return true;
  }
  var tmp4 = get_PERMIT();
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
  var value = get_TAKEN();
  if (segment.g2h_1.atomicfu$get(i).atomicfu$compareAndSet(tmp4, value)) {
    if (isInterface(waiter, CancellableContinuation)) {
      if (!isInterface(waiter, CancellableContinuation))
        THROW_CCE();
      waiter.j20(Unit_instance, $this.u2g_1);
    } else {
      if (isInterface(waiter, SelectInstance)) {
        waiter.v2f(Unit_instance);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unexpected: ' + toString(waiter);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    return true;
  }
  // Inline function 'kotlinx.coroutines.assert' call
  return false;
}
function tryResumeNextFromQueue($this) {
  var curHead = $this.p2g_1.kotlinx$atomicfu$value;
  var deqIdx = $this.q2g_1.atomicfu$getAndIncrement$long();
  // Inline function 'kotlin.Long.div' call
  var other = get_SEGMENT_SIZE_0();
  var id = divide(deqIdx, fromInt(other));
  var createNewSegment = createSegment$ref_1();
  var tmp0 = $this.p2g_1;
  var tmp$ret$3;
  $l$block_2: {
    // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
    while (true) {
      var s = findSegmentInternal(curHead, id, createNewSegment);
      var tmp;
      if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
        tmp = true;
      } else {
        var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
        var tmp$ret$1;
        $l$block_1: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            var cur = tmp0.kotlinx$atomicfu$value;
            if (cur.i21_1 >= tmp2.i21_1) {
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (!tmp2.i29()) {
              tmp$ret$1 = false;
              break $l$block_1;
            }
            if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
              if (cur.j29()) {
                cur.k3();
              }
              tmp$ret$1 = true;
              break $l$block_1;
            }
            if (tmp2.j29()) {
              tmp2.k3();
            }
          }
          tmp$ret$1 = Unit_instance;
        }
        tmp = tmp$ret$1;
      }
      if (tmp) {
        tmp$ret$3 = s;
        break $l$block_2;
      }
    }
  }
  var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$3);
  segment.q29();
  if (segment.i21_1 > id)
    return false;
  // Inline function 'kotlin.Long.rem' call
  var other_0 = get_SEGMENT_SIZE_0();
  var tmp$ret$4 = modulo(deqIdx, fromInt(other_0));
  var i = convertToInt(tmp$ret$4);
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.getAndSet' call
  var value = get_PERMIT();
  var cellState = segment.g2h_1.atomicfu$get(i).atomicfu$getAndSet(value);
  if (cellState === null) {
    // Inline function 'kotlin.repeat' call
    var times = get_MAX_SPIN_CYCLES();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.get' call
        if (segment.g2h_1.atomicfu$get(i).kotlinx$atomicfu$value === get_TAKEN())
          return true;
      }
       while (inductionVariable < times);
    var tmp4 = get_PERMIT();
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
    var value_0 = get_BROKEN();
    return !segment.g2h_1.atomicfu$get(i).atomicfu$compareAndSet(tmp4, value_0);
  } else if (cellState === get_CANCELLED())
    return false;
  else
    return tryResumeAcquire($this, cellState);
}
function tryResumeAcquire($this, _this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, CancellableContinuation)) {
    if (!isInterface(_this__u8e3s4, CancellableContinuation))
      THROW_CCE();
    var token = _this__u8e3s4.f20(Unit_instance, null, $this.u2g_1);
    var tmp_0;
    if (!(token == null)) {
      _this__u8e3s4.g20(token);
      tmp_0 = true;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    if (isInterface(_this__u8e3s4, SelectInstance)) {
      tmp = _this__u8e3s4.a2b($this, Unit_instance);
    } else {
      var message = 'unexpected: ' + toString(_this__u8e3s4);
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  return tmp;
}
function SemaphoreAndMutexImpl$onCancellationRelease$lambda(this$0) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    this$0.b1a();
    return Unit_instance;
  };
}
function createSegment$ref_0() {
  var l = function (p0, p1) {
    return createSegment_0(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
function createSegment$ref_1() {
  var l = function (p0, p1) {
    return createSegment_0(p0, p1);
  };
  l.callableName = 'createSegment';
  return l;
}
function SemaphoreAndMutexImpl(permits, acquiredPermits) {
  this.o2g_1 = permits;
  this.q2g_1 = atomic$long$1(0n);
  this.s2g_1 = atomic$long$1(0n);
  // Inline function 'kotlin.require' call
  if (!(this.o2g_1 > 0)) {
    var message = 'Semaphore should have at least 1 permit, but had ' + this.o2g_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(0 <= acquiredPermits ? acquiredPermits <= this.o2g_1 : false)) {
    var message_0 = 'The number of acquired permits should be in 0..' + this.o2g_1;
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var s = new SemaphoreSegment(0n, null, 2);
  this.p2g_1 = atomic$ref$1(s);
  this.r2g_1 = atomic$ref$1(s);
  this.t2g_1 = atomic$int$1(this.o2g_1 - acquiredPermits | 0);
  var tmp = this;
  tmp.u2g_1 = SemaphoreAndMutexImpl$onCancellationRelease$lambda(this);
}
protoOf(SemaphoreAndMutexImpl).z2g = function () {
  // Inline function 'kotlin.math.max' call
  var a = this.t2g_1.kotlinx$atomicfu$value;
  return Math.max(a, 0);
};
protoOf(SemaphoreAndMutexImpl).v2g = function () {
  $l$loop: while (true) {
    var p = this.t2g_1.kotlinx$atomicfu$value;
    if (p > this.o2g_1) {
      coerceAvailablePermitsAtMaximum(this);
      continue $l$loop;
    }
    if (p <= 0)
      return false;
    if (this.t2g_1.atomicfu$compareAndSet(p, p - 1 | 0))
      return true;
  }
};
protoOf(SemaphoreAndMutexImpl).acquireCont = function (waiter) {
  var tmp$ret$1;
  $l$block_0: {
    // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire' call
    while (true) {
      var p = decPermits(this);
      if (p > 0) {
        waiter.j20(Unit_instance, this.u2g_1);
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      }
      if (addAcquireToQueue(this, isInterface(waiter, Waiter) ? waiter : THROW_CCE())) {
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      }
    }
    tmp$ret$1 = Unit_instance;
  }
  return tmp$ret$1;
};
protoOf(SemaphoreAndMutexImpl).b1a = function () {
  while (true) {
    var p = this.t2g_1.atomicfu$getAndIncrement();
    if (p >= this.o2g_1) {
      coerceAvailablePermitsAtMaximum(this);
      // Inline function 'kotlin.error' call
      var message = 'The number of released permits cannot be greater than ' + this.o2g_1;
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (p >= 0)
      return Unit_instance;
    if (tryResumeNextFromQueue(this))
      return Unit_instance;
  }
};
function SemaphoreSegment(id, prev, pointers) {
  Segment.call(this, id, prev, pointers);
  this.g2h_1 = atomicfu$AtomicRefArray$ofNulls(get_SEGMENT_SIZE_0());
}
protoOf(SemaphoreSegment).j28 = function () {
  return get_SEGMENT_SIZE_0();
};
protoOf(SemaphoreSegment).k21 = function (index, cause, context) {
  // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.set' call
  var value = get_CANCELLED();
  this.g2h_1.atomicfu$get(index).kotlinx$atomicfu$value = value;
  this.g29();
};
protoOf(SemaphoreSegment).toString = function () {
  return 'SemaphoreSegment[id=' + this.i21_1.toString() + ', hashCode=' + hashCode(this) + ']';
};
function createSegment_0(id, prev) {
  _init_properties_Semaphore_kt__t514r6();
  return new SemaphoreSegment(id, prev, 0);
}
var properties_initialized_Semaphore_kt_uqcwok;
function _init_properties_Semaphore_kt__t514r6() {
  if (!properties_initialized_Semaphore_kt_uqcwok) {
    properties_initialized_Semaphore_kt_uqcwok = true;
    MAX_SPIN_CYCLES = systemProp('kotlinx.coroutines.semaphore.maxSpinCycles', 100);
    PERMIT = new Symbol('PERMIT');
    TAKEN = new Symbol('TAKEN');
    BROKEN = new Symbol('BROKEN');
    CANCELLED = new Symbol('CANCELLED');
    SEGMENT_SIZE_0 = systemProp('kotlinx.coroutines.semaphore.segmentSize', 16);
  }
}
function createDefaultDispatcher() {
  var tmp;
  if (isJsdom()) {
    tmp = NodeDispatcher_getInstance();
  } else {
    var tmp_0;
    var tmp_1;
    if (!(typeof window === 'undefined')) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = window != null;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = !(typeof window.addEventListener === 'undefined');
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = asCoroutineDispatcher(window);
    } else {
      if (typeof process === 'undefined' || typeof process.nextTick === 'undefined') {
        tmp = SetTimeoutDispatcher_getInstance();
      } else {
        tmp = NodeDispatcher_getInstance();
      }
    }
  }
  return tmp;
}
function isJsdom() {
  return !(typeof navigator === 'undefined') && navigator != null && navigator.userAgent != null && !(typeof navigator.userAgent === 'undefined') && !(typeof navigator.userAgent.match === 'undefined') && navigator.userAgent.match('\\bjsdom\\b');
}
var counter;
function get_DEBUG() {
  return DEBUG;
}
var DEBUG;
function get_classSimpleName(_this__u8e3s4) {
  var tmp0_elvis_lhs = getKClassFromExpression(_this__u8e3s4).ea();
  return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
}
function get_hexAddress(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var result = _this__u8e3s4.__debug_counter;
  if (!(typeof result === 'number')) {
    counter = counter + 1 | 0;
    result = counter;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.__debug_counter = result;
  }
  return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
}
function NodeDispatcher() {
  NodeDispatcher_instance = this;
  SetTimeoutBasedDispatcher.call(this);
}
protoOf(NodeDispatcher).j2h = function () {
  process.nextTick(this.q2h_1.o2h_1);
};
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance == null)
    new NodeDispatcher();
  return NodeDispatcher_instance;
}
function ScheduledMessageQueue$processQueue$lambda(this$0) {
  return function () {
    this$0.u2h();
    return Unit_instance;
  };
}
function ScheduledMessageQueue(dispatcher) {
  MessageQueue.call(this);
  this.n2h_1 = dispatcher;
  var tmp = this;
  tmp.o2h_1 = ScheduledMessageQueue$processQueue$lambda(this);
}
protoOf(ScheduledMessageQueue).v2h = function () {
  this.n2h_1.j2h();
};
protoOf(ScheduledMessageQueue).w2h = function () {
  setTimeout(this.o2h_1, 0);
};
protoOf(ScheduledMessageQueue).x2h = function (timeout) {
  setTimeout(this.o2h_1, timeout);
};
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
function WindowMessageQueue$lambda(this$0) {
  return function (event) {
    var tmp;
    if (event.source == this$0.k2i_1 && event.data == this$0.l2i_1) {
      event.stopPropagation();
      this$0.u2h();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function WindowMessageQueue$schedule$lambda(this$0) {
  return function (it) {
    this$0.u2h();
    return Unit_instance;
  };
}
function WindowMessageQueue(window_0) {
  MessageQueue.call(this);
  this.k2i_1 = window_0;
  this.l2i_1 = 'dispatchCoroutine';
  this.k2i_1.addEventListener('message', WindowMessageQueue$lambda(this), true);
}
protoOf(WindowMessageQueue).v2h = function () {
  var tmp = Promise.resolve(Unit_instance);
  tmp.then(WindowMessageQueue$schedule$lambda(this));
};
protoOf(WindowMessageQueue).w2h = function () {
  this.k2i_1.postMessage(this.l2i_1, '*');
};
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
function await_0(_this__u8e3s4, $completion) {
  var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
  cancellable.w21();
  var tmp = await$lambda(cancellable);
  _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
  return cancellable.e22();
}
function promise(_this__u8e3s4, context, start, block) {
  context = context === VOID ? EmptyCoroutineContext_instance : context;
  start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
  return asPromise(async(_this__u8e3s4, context, start, block));
}
function asPromise(_this__u8e3s4) {
  var promise = new Promise(asPromise$lambda(_this__u8e3s4));
  // Inline function 'kotlin.js.asDynamic' call
  promise.deferred = _this__u8e3s4;
  return promise;
}
function await$lambda($cont) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $cont;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
    this_0.o8(tmp$ret$0);
    return Unit_instance;
  };
}
function await$lambda_0($cont) {
  return function (it) {
    var tmp0 = $cont;
    var tmp0_elvis_lhs = it instanceof Error ? it : null;
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = tmp0_elvis_lhs == null ? Exception_init_$Create$('Non-Kotlin exception ' + it.toString()) : tmp0_elvis_lhs;
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    tmp0.o8(tmp$ret$0);
    return Unit_instance;
  };
}
function asPromise$lambda$lambda($this_asPromise, $reject, $resolve) {
  return function (it) {
    var e = $this_asPromise.c1z();
    var tmp;
    if (!(e == null)) {
      tmp = $reject(e);
    } else {
      tmp = $resolve($this_asPromise.z1z());
    }
    return Unit_instance;
  };
}
function asPromise$lambda($this_asPromise) {
  return function (resolve, reject) {
    $this_asPromise.h1y(asPromise$lambda$lambda($this_asPromise, reject, resolve));
    return Unit_instance;
  };
}
function asCoroutineDispatcher(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs = _this__u8e3s4.coroutineDispatcher;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_0 = new WindowDispatcher(_this__u8e3s4);
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.coroutineDispatcher = this_0;
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function propagateExceptionFinalResort(exception) {
  console.error(exception.toString());
}
function createEventLoop() {
  return new UnconfinedEventLoop();
}
function UnconfinedEventLoop() {
  EventLoop.call(this);
}
protoOf(UnconfinedEventLoop).e24 = function (context, block) {
  unsupported();
};
function unsupported() {
  throw UnsupportedOperationException_init_$Create$('runBlocking event loop is not supported');
}
function SetTimeoutDispatcher() {
  SetTimeoutDispatcher_instance = this;
  SetTimeoutBasedDispatcher.call(this);
}
protoOf(SetTimeoutDispatcher).j2h = function () {
  this.q2h_1.x2h(0);
};
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance == null)
    new SetTimeoutDispatcher();
  return SetTimeoutDispatcher_instance;
}
function SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return function () {
    // Inline function 'kotlin.with' call
    $continuation.i20(this$0, Unit_instance);
    return Unit_instance;
  };
}
function SetTimeoutBasedDispatcher() {
  CoroutineDispatcher.call(this);
  this.q2h_1 = new ScheduledMessageQueue(this);
}
protoOf(SetTimeoutBasedDispatcher).e24 = function (context, block) {
  this.q2h_1.y2h(block);
};
protoOf(SetTimeoutBasedDispatcher).q24 = function (timeMillis, continuation) {
  var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
  invokeOnCancellation(continuation, new ClearTimeout(handle));
};
function MessageQueue() {
  this.r2h_1 = ArrayDeque_init_$Create$();
  this.s2h_1 = 16;
  this.t2h_1 = false;
}
protoOf(MessageQueue).y2h = function (element) {
  this.z2h(element);
  if (!this.t2h_1) {
    this.t2h_1 = true;
    this.v2h();
  }
};
protoOf(MessageQueue).u2h = function () {
  try {
    // Inline function 'kotlin.repeat' call
    var times = this.s2h_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = removeFirstOrNull(this);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var element = tmp;
        element.s22();
      }
       while (inductionVariable < times);
  }finally {
    if (this.q()) {
      this.t2h_1 = false;
    } else {
      this.w2h();
    }
  }
};
protoOf(MessageQueue).z2h = function (element) {
  return this.r2h_1.j(element);
};
protoOf(MessageQueue).j = function (element) {
  return this.z2h((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).a2i = function (index, element) {
  this.r2h_1.y1(index, element);
};
protoOf(MessageQueue).y1 = function (index, element) {
  return this.a2i(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).b2i = function (elements) {
  return this.r2h_1.s(elements);
};
protoOf(MessageQueue).s = function (elements) {
  return this.b2i(elements);
};
protoOf(MessageQueue).w1 = function () {
  this.r2h_1.w1();
};
protoOf(MessageQueue).c2i = function (index, element) {
  return this.r2h_1.x1(index, element);
};
protoOf(MessageQueue).x1 = function (index, element) {
  return this.c2i(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).z1 = function (index) {
  return this.r2h_1.z1(index);
};
protoOf(MessageQueue).u1 = function () {
  return this.r2h_1.u1();
};
protoOf(MessageQueue).r = function (index) {
  return this.r2h_1.r(index);
};
protoOf(MessageQueue).v1 = function (fromIndex, toIndex) {
  return this.r2h_1.v1(fromIndex, toIndex);
};
protoOf(MessageQueue).q = function () {
  return this.r2h_1.q();
};
protoOf(MessageQueue).d2i = function (element) {
  return this.r2h_1.q1(element);
};
protoOf(MessageQueue).q1 = function (element) {
  if (!(!(element == null) ? isInterface(element, Runnable) : false))
    return false;
  return this.d2i((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).l = function () {
  return this.r2h_1.l();
};
protoOf(MessageQueue).e2i = function (elements) {
  return this.r2h_1.r1(elements);
};
protoOf(MessageQueue).r1 = function (elements) {
  return this.e2i(elements);
};
protoOf(MessageQueue).p = function (index) {
  return this.r2h_1.p(index);
};
protoOf(MessageQueue).f2i = function (element) {
  return this.r2h_1.s1(element);
};
protoOf(MessageQueue).s1 = function (element) {
  if (!(!(element == null) ? isInterface(element, Runnable) : false))
    return -1;
  return this.f2i((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).g2i = function (element) {
  return this.r2h_1.t1(element);
};
protoOf(MessageQueue).t1 = function (element) {
  if (!(!(element == null) ? isInterface(element, Runnable) : false))
    return -1;
  return this.g2i((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
};
protoOf(MessageQueue).asJsReadonlyArrayView = function () {
  return this.r2h_1.asJsReadonlyArrayView();
};
protoOf(MessageQueue).o = function () {
  return this.r2h_1.te_1;
};
function WindowClearTimeout($outer, handle) {
  this.t2i_1 = $outer;
  ClearTimeout.call(this, handle);
}
protoOf(WindowClearTimeout).t20 = function () {
  w3cClearTimeout(this.t2i_1.v2i_1, this.x2i_1);
};
function WindowDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
  return function () {
    // Inline function 'kotlin.with' call
    $continuation.i20(this$0, Unit_instance);
    return Unit_instance;
  };
}
function WindowDispatcher(window_0) {
  CoroutineDispatcher.call(this);
  this.v2i_1 = window_0;
  this.w2i_1 = new WindowMessageQueue(this.v2i_1);
}
protoOf(WindowDispatcher).e24 = function (context, block) {
  return this.w2i_1.y2h(block);
};
protoOf(WindowDispatcher).q24 = function (timeMillis, continuation) {
  var handle = w3cSetTimeout_0(this.v2i_1, WindowDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
  invokeOnCancellation(continuation, new WindowClearTimeout(this, handle));
};
function delayToInt(timeMillis) {
  return convertToInt(coerceIn(timeMillis, 0n, 2147483647n));
}
function ClearTimeout(handle) {
  this.x2i_1 = handle;
}
protoOf(ClearTimeout).t20 = function () {
  w3cClearTimeout_0(this.x2i_1);
};
protoOf(ClearTimeout).s20 = function (cause) {
  this.t20();
};
protoOf(ClearTimeout).toString = function () {
  return 'ClearTimeout[' + this.x2i_1 + ']';
};
function newCoroutineContext(_this__u8e3s4, context) {
  var combined = _this__u8e3s4.f1x().fh(context);
  return !(combined === Dispatchers_getInstance().k24_1) && combined.q8(Key_instance) == null ? combined.fh(Dispatchers_getInstance().k24_1) : combined;
}
function toDebugString(_this__u8e3s4) {
  return toString(_this__u8e3s4);
}
function get_DefaultDelay() {
  var tmp = Dispatchers_getInstance().k24_1;
  return isInterface(tmp, Delay) ? tmp : THROW_CCE();
}
function get_coroutineName(_this__u8e3s4) {
  return null;
}
function Dispatchers() {
  Dispatchers_instance = this;
  this.k24_1 = createDefaultDispatcher();
  this.l24_1 = Unconfined_getInstance();
  this.m24_1 = new JsMainDispatcher(this.k24_1, false);
  this.n24_1 = null;
}
protoOf(Dispatchers).o24 = function () {
  var tmp0_elvis_lhs = this.n24_1;
  return tmp0_elvis_lhs == null ? this.m24_1 : tmp0_elvis_lhs;
};
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance == null)
    new Dispatchers();
  return Dispatchers_instance;
}
function JsMainDispatcher(delegate, invokeImmediately) {
  MainCoroutineDispatcher.call(this);
  this.z2i_1 = delegate;
  this.a2j_1 = invokeImmediately;
  this.b2j_1 = this.a2j_1 ? this : new JsMainDispatcher(this.z2i_1, true);
}
protoOf(JsMainDispatcher).u27 = function () {
  return this.b2j_1;
};
protoOf(JsMainDispatcher).d24 = function (context) {
  return !this.a2j_1;
};
protoOf(JsMainDispatcher).e24 = function (context, block) {
  return this.z2i_1.e24(context, block);
};
protoOf(JsMainDispatcher).toString = function () {
  var tmp0_elvis_lhs = this.v27();
  return tmp0_elvis_lhs == null ? this.z2i_1.toString() : tmp0_elvis_lhs;
};
function CancellationException_0(message, cause) {
  return CancellationException_init_$Create$_0(message, cause);
}
function JobCancellationException(message, cause, job) {
  CancellationException_init_$Init$(message, cause, this);
  captureStack(this, JobCancellationException);
  this.c2j_1 = job;
}
protoOf(JobCancellationException).toString = function () {
  return protoOf(CancellationException).toString.call(this) + '; job=' + toString(this.c2j_1);
};
protoOf(JobCancellationException).equals = function (other) {
  var tmp;
  if (other === this) {
    tmp = true;
  } else {
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof JobCancellationException) {
      tmp_2 = other.message == this.message;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = equals(other.c2j_1, this.c2j_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(other.cause, this.cause);
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(JobCancellationException).hashCode = function () {
  var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.c2j_1) | 0, 31);
  var tmp0_safe_receiver = this.cause;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
};
function Runnable() {
}
function SchedulerTask() {
}
function AbortFlowException(owner) {
  CancellationException_init_$Init$_0('Flow was aborted, no more elements needed', this);
  captureStack(this, AbortFlowException);
  this.q2e_1 = owner;
}
function identitySet(expectedSize) {
  return HashSet_init_$Create$(expectedSize);
}
function get_platformExceptionHandlers_() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return platformExceptionHandlers_;
}
var platformExceptionHandlers_;
function get_platformExceptionHandlers() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return get_platformExceptionHandlers_();
}
function DiagnosticCoroutineContextException(context) {
  RuntimeException_init_$Init$_0(toString(context), this);
  captureStack(this, DiagnosticCoroutineContextException);
}
var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
  if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
    properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
    // Inline function 'kotlin.collections.mutableSetOf' call
    platformExceptionHandlers_ = LinkedHashSet_init_$Create$();
  }
}
function LockFreeLinkedListNode() {
  this.h23_1 = this;
  this.i23_1 = this;
  this.j23_1 = false;
}
protoOf(LockFreeLinkedListNode).k23 = function (node, permissionsBitmask) {
  var prev = this.i23_1;
  var tmp;
  if (prev instanceof ListClosed) {
    tmp = ((prev.g2j_1 & permissionsBitmask) === 0 && prev.k23(node, permissionsBitmask));
  } else {
    node.h23_1 = this;
    node.i23_1 = prev;
    prev.h23_1 = node;
    this.i23_1 = node;
    tmp = true;
  }
  return tmp;
};
protoOf(LockFreeLinkedListNode).o25 = function (forbiddenElementsBit) {
  this.k23(new ListClosed(forbiddenElementsBit), forbiddenElementsBit);
};
protoOf(LockFreeLinkedListNode).l23 = function () {
  if (this.j23_1)
    return false;
  var prev = this.i23_1;
  var next = this.h23_1;
  prev.h23_1 = next;
  next.i23_1 = prev;
  this.j23_1 = true;
  return true;
};
protoOf(LockFreeLinkedListNode).m23 = function (node) {
  if (!(this.h23_1 === this))
    return false;
  this.k23(node, -2147483648);
  return true;
};
function LockFreeLinkedListHead() {
  LockFreeLinkedListNode.call(this);
}
function ListClosed(forbiddenElementsBitmask) {
  LockFreeLinkedListNode.call(this);
  this.g2j_1 = forbiddenElementsBitmask;
}
function recoverStackTrace(exception, continuation) {
  return exception;
}
function unwrap(exception) {
  return exception;
}
function recoverStackTrace_0(exception) {
  return exception;
}
function SynchronizedObject() {
}
function systemProp_1(propertyName) {
  return null;
}
function threadContextElements(context) {
  return 0;
}
function CommonThreadLocal() {
  this.e25_1 = null;
}
protoOf(CommonThreadLocal).f25 = function () {
  var tmp = this.e25_1;
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(CommonThreadLocal).g25 = function (value) {
  this.e25_1 = value;
};
function commonThreadLocal(name) {
  return new CommonThreadLocal();
}
//region block: post-declaration
protoOf(JobSupport).j1y = invokeOnCompletion$default;
protoOf(JobSupport).p1y = cancel$default;
protoOf(JobSupport).fh = plus;
protoOf(JobSupport).q8 = get_0;
protoOf(JobSupport).eh = fold;
protoOf(JobSupport).dh = minusKey_0;
protoOf(CoroutineDispatcher).q8 = get;
protoOf(CoroutineDispatcher).dh = minusKey;
protoOf(BufferedChannel).s2c = close$default;
protoOf(BufferedChannel).u2c = cancel$default_0;
protoOf(ChannelCoroutine).s2c = close$default;
defineProp(protoOf(DispatchException), 'cause', function () {
  return this.f();
});
//endregion
//region block: init
Active_instance = new Active();
Key_instance_1 = new Key_0();
Key_instance_2 = new Key_1();
GlobalScope_instance = new GlobalScope();
Key_instance_3 = new Key_2();
NonDisposableHandle_instance = new NonDisposableHandle();
Key_instance_4 = new Key_3();
counter = 0;
DEBUG = false;
//endregion
//region block: exports
export {
  firstOrNull as firstOrNull3jjcu7fygcopr,
  await_0 as await20nhgj9iqzkt,
  delay as delayolwo40i9ucjz,
  Key_instance_1 as Key_instance2ye2t23iqghop,
  Dispatchers_getInstance as Dispatchers_getInstanceitgtkvqfcnx3,
  GlobalScope_instance as GlobalScope_instance1sfulufhd2ijt,
  Key_instance_3 as Key_instance2tirv2rj82ml4,
  Channel as Channel3r72atmcithql,
  ProducerScope as ProducerScopeb3mmhvfa6ll7,
  cancelConsumed as cancelConsumed2i0oizqhmljf6,
  produce as produce1iljho2c8bp6o,
  FlowCollector as FlowCollector26clgpmzihvke,
  asFlow as asFlow3ngsnn5xpz8pw,
  recoverStackTrace as recoverStackTrace2i3si2i8nvw1k,
  startCoroutineCancellable as startCoroutineCancellable18shtfwdieib,
  Mutex as Mutex16li1l0asjv17,
  CancellableContinuationImpl as CancellableContinuationImpl1cx201opicavg,
  CancellationException_0 as CancellationExceptionjngvjj221x3v,
  CompletableDeferred as CompletableDeferred2lnqvsbvx74d3,
  CompletableJob as CompletableJob1w6swnu15iclo,
  CopyableThrowable as CopyableThrowable1mvc99jcyvivf,
  CoroutineName as CoroutineName2g5zosw74tf0f,
  CoroutineScope_0 as CoroutineScopelux7s7zphw7e,
  CoroutineScope as CoroutineScopefcb5f5dwqcas,
  Job_0 as Job13y4jkazwjho0,
  MainScope as MainScope1gi1r4abhrtmm,
  SupervisorJob as SupervisorJobythnfxkr3jxc,
  async as asyncz02dsa2nb2zt,
  cancel_0 as cancel36mj9lv3a0whl,
  cancel_2 as cancel2en0dn4yvpufo,
  cancel as cancel2ztysw4v4hav6,
  cancel_1 as cancel1xim2hrvjmwpn,
  get_job as get_job2zvlvce9o9a29,
  launch as launch1c91vkjzdi9sd,
  promise as promise1ky6tawqaxbt4,
};
//endregion

//# sourceMappingURL=kotlinx-coroutines-core.mjs.map
